var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--floor--inject-2",
    d: "M77.67,448.33c-95.18-54.95-95.18-144,0-199s249.49-55,344.66,0,95.18,144,0,199S172.84,503.28,77.67,448.33Z",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Shadow--inject-2",
    d: "M32.36,433.81C20,441,20,452.54,32.37,459.69s32.44,7.14,44.82,0,12.38-18.74,0-25.88S44.74,426.66,32.36,433.81Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-2",
    d: "M362.91,302l-5-2.91a13.69,13.69,0,0,0-12.4,0L78.82,453c-3.41,2-3.41,5.19,0,7.16l5,2.91a13.75,13.75,0,0,0,12.4,0l81-46.77,36.05,20.82c9.29,5.36,24.49,5.36,33.78,0L303,404.86c7.93-4.58,7.93-12.08,0-16.66L264.47,366l98.44-56.84C366.32,307.16,366.32,303.94,362.91,302Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--plant--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pot--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.21,449.31c-9.94-10.25-15.77-52-6.08-60.09h49.3c9.69,8.12,3.86,49.83-6.07,60.08l-.27.29-.34.33a11.75,11.75,0,0,1-.9.81l-.24.19c-.24.19-.48.39-.75.57a12.1,12.1,0,0,1-1.28.83c-8.18,4.77-21.43,4.77-29.6,0h0c-.43-.24-.86-.53-1.29-.83-.25-.18-.47-.36-.7-.54l-.29-.23a11,11,0,0,1-.87-.78l-.39-.39A2.61,2.61,0,0,1,36.21,449.31Z",
    style: {
      fill: "#FECE2F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.21,449.31c-9.94-10.25-15.77-52-6.08-60.09h49.3c9.69,8.12,3.86,49.83-6.07,60.08l-.27.29-.34.33a11.75,11.75,0,0,1-.9.81l-.24.19c-.24.19-.48.39-.75.57a12.1,12.1,0,0,1-1.28.83c-8.18,4.77-21.43,4.77-29.6,0h0c-.43-.24-.86-.53-1.29-.83-.25-.18-.47-.36-.7-.54l-.29-.23a11,11,0,0,1-.87-.78l-.39-.39A2.61,2.61,0,0,1,36.21,449.31Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.15,385.94c11.25,6.57,11.25,17.22,0,23.79s-29.49,6.56-40.74,0-11.25-17.22,0-23.79S63.9,379.37,75.15,385.94Z",
    style: {
      fill: "#FECE2F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.15,385.94c11.25,6.57,11.25,17.22,0,23.79s-29.49,6.56-40.74,0-11.25-17.22,0-23.79S63.9,379.37,75.15,385.94Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.74,389.1c8.26,4.82,8.26,12.64,0,17.47s-21.66,4.82-29.92,0-8.26-12.65,0-17.47S61.48,384.28,69.74,389.1Z",
    style: {
      fill: "#FECE2F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.74,389.1c8.26,4.82,8.26,12.64,0,17.47s-21.66,4.82-29.92,0-8.26-12.65,0-17.47S61.48,384.28,69.74,389.1Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.82,397.39c8.26-4.82,21.66-4.82,29.92,0a13.78,13.78,0,0,1,5,4.59,13.87,13.87,0,0,1-5,4.59c-8.26,4.82-21.66,4.82-29.92,0a13.87,13.87,0,0,1-5-4.59A13.78,13.78,0,0,1,39.82,397.39Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M40.5,310.16s0-.66,0-.73c0-.25,0-.5-.07-.76,0-.5-.13-1-.22-1.49a29.58,29.58,0,0,0-.74-2.95,2.33,2.33,0,0,0-.17-.57l-.18-.57-.39-1.16c-.19-.55-.38-1.11-.58-1.66a12.84,12.84,0,0,1-.52-1.59,3.13,3.13,0,0,0-.16-.62,1.57,1.57,0,0,1-.1-.28c-.06-.27-.11-.54-.16-.81-.12-.54-.25-1.07-.39-1.61-.28-1.06-.62-2.11-1-3.15-.3-.81-.64-1.62-1-2.41a8.35,8.35,0,0,0-2.73-3.66,1.09,1.09,0,0,0-1.08-.21c-.38.2-.45.69-.48,1.1L30,294.1a21.9,21.9,0,0,0,0,4.36,10.6,10.6,0,0,0,2.42,5.31,20.65,20.65,0,0,0,2.86,2.59c.77.61,1.56,1.21,2.3,1.85A9.87,9.87,0,0,0,40.5,310.16Z",
    style: {
      fill: "#FECE2F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4,295.3c-.06-.33-.13-.67-.22-1a7.43,7.43,0,0,0-.86-2.05c-.2-.31-.3-.67-.49-1a3.39,3.39,0,0,0-.72-.88,1.38,1.38,0,0,0-.6-.34.63.63,0,0,0-.63.19,1,1,0,0,0-.17.56,19.05,19.05,0,0,1-.74,3.74,13.62,13.62,0,0,1-.65,1.79,2.27,2.27,0,0,1-.33.48,2.43,2.43,0,0,0-.2.35,10.18,10.18,0,0,1-1,1.69,9.14,9.14,0,0,1-.94,1.12c-1.1,1.1-2.47,1.95-3.31,3.26-1.25,2-1,4.49-1.08,6.71,0,.38,0,.77,0,1.15,0,3.06-.5,5.7.29,8.7.06.22.28.73.61.53l.33-.22A11.25,11.25,0,0,0,47.11,315c.21-.5.4-1,.6-1.51a4,4,0,0,1,.72-1c.74-.95,1.37-2,2-3.06a30.71,30.71,0,0,0,3.24-6.58,17.07,17.07,0,0,0,.9-5.25A14.6,14.6,0,0,0,54.4,295.3Z",
    style: {
      fill: "#FECE2F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.23,319.38c.58,0,1.16.05,1.74.05,1.19,0,2.38,0,3.56,0,.6,0,1.19,0,1.78,0,.21,0,.41,0,.62,0a4.83,4.83,0,0,0,.85,0,.48.48,0,0,0,.17-.05.33.33,0,0,0,.08-.26,5.05,5.05,0,0,0-.56-2.35,5.49,5.49,0,0,0-.68-1,9.37,9.37,0,0,0-3.07-2.41,17,17,0,0,0-3.58-1.06l-9.7-2.07c-.45-.09-1-.16-1.29.18a1.14,1.14,0,0,0-.24.7,7.16,7.16,0,0,0,3.3,6.25A13.78,13.78,0,0,0,33.23,319.38Z",
    style: {
      fill: "#FECE2F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.87,331.28a5.83,5.83,0,0,0-1.15-1.42,7.37,7.37,0,0,0-2.26-1.52,25.57,25.57,0,0,0-4.38-1.28,51.54,51.54,0,0,1-9.93-3.55,1.25,1.25,0,0,0-.67-.18c-.57.05-.8.75-.83,1.32A8.25,8.25,0,0,0,29,332.24c2.67,1.39,5.85,1.17,8.86,1.07H38a27.25,27.25,0,0,1,3.26.06,12.23,12.23,0,0,1,1.59.25c.44.1,1.25.58,1.54,0a1.21,1.21,0,0,0,0-.68,5.29,5.29,0,0,0-.53-1.6Z",
    style: {
      fill: "#FECE2F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.15,332.13a2.13,2.13,0,0,1-.45.34.88.88,0,0,1-.39.11.58.58,0,0,1-.49-.25c-.06-.1-.12-.19-.17-.29a3.66,3.66,0,0,1-.27-.61,6.77,6.77,0,0,1-.32-1.31c0-.11,0-.22-.05-.32-.06-.5-.1-1-.15-1.51,0-.25-.06-.5-.1-.76a1.7,1.7,0,0,1,0-.55,4,4,0,0,0,0-.92,7.09,7.09,0,0,1,0-1.13c.28-3.34,2.71-6,4.71-8.71A41.78,41.78,0,0,0,54,308.4c.28-.61.73-1.34,1.39-1.24s.81.65,1,1.15a17.81,17.81,0,0,1-.28,11.13,25,25,0,0,1-3.06,6A31.58,31.58,0,0,1,51,328.09c-.22.26-.41.51-.64.76-.69.74-1.4,1.48-2.12,2.2l-.88.88Z",
    style: {
      fill: "#FECE2F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41,341.37A28,28,0,0,0,34.14,340a15.88,15.88,0,0,1-6.67-2,1.43,1.43,0,0,0-.69-.28c-.48,0-.74.59-.8,1.07a6.57,6.57,0,0,0,1.11,4.1,12.32,12.32,0,0,0,12.29,5.61h0c1.52-.26,3-.8,4.52-1a8.49,8.49,0,0,1,1.13,0c.24,0,.63.16.82,0,.41-.44-.08-1-.18-1.47a5.07,5.07,0,0,0-.67-1.48,7.74,7.74,0,0,0-2.34-2.29A9.86,9.86,0,0,0,41,341.37Z",
    style: {
      fill: "#FECE2F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.16,355.07c-2.31-.58-4.74-.7-7-1.5-1-.36-2-.85-2.95-1.25-.28-.11-.64-.2-.85,0a.81.81,0,0,0-.15.51,7.87,7.87,0,0,0,3.54,6.41A13,13,0,0,0,41,361.3c1.52,0,3.05-.13,4.57,0a3.85,3.85,0,0,1,1.07.16c.17.08.28.27.46.33.68.24.77-.74.7-1.15a5.68,5.68,0,0,0-.91-2.22,4.52,4.52,0,0,0-.78-.91,1.41,1.41,0,0,0-.38-.21c-.65-.32-1.2-.87-1.85-1.22A12,12,0,0,0,41.16,355.07Z",
    style: {
      fill: "#FECE2F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.5,401.65c-.16-.76-.26-1.55-.49-2.3l-.75-2.51c-.44-1.54-.84-3.08-1.19-4.64-.71-3.19-1.28-6.39-1.7-9.63-.82-6.5-1.13-13.05-1.39-19.6s-.57-13.15-1.26-19.69a168.73,168.73,0,0,0-3.33-20,117.72,117.72,0,0,0-7.45-22.22c-.08-.18-.23.07-.19.18,4,13.1,7.42,26.4,9,40,1.5,12.89,1.11,25.91,2.54,38.8.39,3.53.92,7,1.66,10.52q.55,2.58,1.32,5.12c.3,1,.62,2,1,3a23.85,23.85,0,0,0,1.51,3.09C54,402.15,54.61,402.17,54.5,401.65Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43,319.88a4.38,4.38,0,0,0-1.79-1.83,11.44,11.44,0,0,0-2.48-1.16c-2.21-.77-4.49-1.29-6.73-2-.13,0-.18.3-.06.34,2.07.71,4.13,1.48,6.19,2.24a16,16,0,0,1,2.4,1,6.15,6.15,0,0,1,1.09.74c.37.32.65.71,1,1S43,320.1,43,319.88Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.69,334.93c-.92-2.89-4-4.56-6.77-5.12-1.53-.3-3.08-.37-4.62-.58A14.13,14.13,0,0,1,30,327.89c-.08,0-.11.15-.07.19,2.11,1.93,5.54,2,8.21,2.45a11.23,11.23,0,0,1,4.15,1.41,10.2,10.2,0,0,1,3,3.29C45.49,335.54,45.78,335.2,45.69,334.93Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.85,348.4A5.61,5.61,0,0,0,44,346a15.26,15.26,0,0,0-4.09-1.19c-2.85-.45-5.87-.56-8.32-2.29,0,0-.07,0-.05.08,2,1.95,4.89,2.48,7.57,3a23.53,23.53,0,0,1,4,1,9,9,0,0,1,1.76.88,20,20,0,0,1,1.66,1.39C46.79,349.12,47,348.63,46.85,348.4Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.74,361.53a3.55,3.55,0,0,0-1.52-2,7.12,7.12,0,0,0-2.51-1.17c-2.23-.57-4.59-.24-6.78-1-.1,0-.14.2,0,.24,2,.82,4.14.87,6.21,1.37a8.92,8.92,0,0,1,2.39.93,4.58,4.58,0,0,1,1,.76,12.3,12.3,0,0,1,.81,1.09C47.51,362.09,47.78,361.82,47.74,361.53Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.82,301.6A18.8,18.8,0,0,1,47,306.19a21.67,21.67,0,0,0-2.73,4.42,21.91,21.91,0,0,0-1.4,4.83,15.69,15.69,0,0,0-.27,2.73,13.31,13.31,0,0,0,.36,2.52c.05.26.35.38.38,0,.09-1,.32-2,.41-3.06a20.87,20.87,0,0,1,.36-2.48,25.29,25.29,0,0,1,1.51-4.73c1.27-3,3.43-5.58,4.42-8.69C50.1,301.61,49.91,301.38,49.82,301.6Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.26,318.7c-1.25,2.42-3.22,4.39-4.75,6.64a16.4,16.4,0,0,0-2,3.9,7.83,7.83,0,0,0-.19,4.21c.06.25.33.22.35,0a17.38,17.38,0,0,1,2.84-7.55,47.6,47.6,0,0,0,3.85-7C52.44,318.73,52.34,318.55,52.26,318.7Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.05,361.17a23.76,23.76,0,0,0-3.42-1.62l-7.81-3.22a1.22,1.22,0,0,0-1.14-.07,1.12,1.12,0,0,0-.36.83,8.16,8.16,0,0,0,.46,3.31c1.46,4.52,5.37,8.33,10.07,9.06,2,.3,4,.08,5.93.53.76.18,2,.43,2-.73a1.68,1.68,0,0,0-.31-.84,11,11,0,0,1-.44-1.21A12.33,12.33,0,0,0,34.31,363,12.19,12.19,0,0,0,32.05,361.17Z",
    style: {
      fill: "#FECE2F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36,374.39a19.2,19.2,0,0,0-4.91-1.22l-4.49-.71c-.58-.09-1.16-.17-1.73-.27a1.14,1.14,0,0,1-.25-.06,1.33,1.33,0,0,0-.73-.17c-.34.06-.39.28-.41.58a5.05,5.05,0,0,0,.16,1.77,6.51,6.51,0,0,0,1.91,3.07A11.17,11.17,0,0,0,31,379.86a20.73,20.73,0,0,0,4.85.39c1.35-.05,2.72-.35,3.39-1.67.58-1.15-.44-2.23-1.26-2.95A7.91,7.91,0,0,0,36,374.39Z",
    style: {
      fill: "#FECE2F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.15,364.91a2,2,0,0,1,.1-.94,1.11,1.11,0,0,1,1.12-.55,2.08,2.08,0,0,1,1.17.59c1.38,1.24,1.73,3.24,1.91,5.08a17.41,17.41,0,0,1-.21,5.67c-.33,1.35-1,3.1-2.5,3.42a2.65,2.65,0,0,1-2.8-1.33c-.87-1.57-.11-3.65.29-5.25a25.27,25.27,0,0,0,.94-6C41.17,365.39,41.17,365.15,41.15,364.91Z",
    style: {
      fill: "#FECE2F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.88,384.88a21.77,21.77,0,0,0-5.94-1.31l-2.24-.28a1.11,1.11,0,0,0-.48,0c-.49.16-.53.84-.38,1.33.68,2.13,3,3.27,5.19,3.68s4.49.38,6.55,1.24c.47.2,1.23.53,1.54-.08s-.2-.86-.41-1.26a6.9,6.9,0,0,0-2.2-2.42A9.3,9.3,0,0,0,37.88,384.88Z",
    style: {
      fill: "#FECE2F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.34,382.22c.7-1.74,2.21-3.15,2.52-5a1,1,0,0,1,1,.43,2.62,2.62,0,0,1,.4,1.06,20.45,20.45,0,0,1,.68,4.33,7,7,0,0,1-1.12,4.16A2.54,2.54,0,0,1,44,388.37a2.11,2.11,0,0,1-1.69-.68c-.67-.74-.47-1.81-.42-2.73A8,8,0,0,1,42.34,382.22Z",
    style: {
      fill: "#FECE2F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.27,403a19.79,19.79,0,0,1-3.06-7.1c-.54-2.15-1-4.33-1.36-6.51A6.74,6.74,0,0,1,43.2,388a15.85,15.85,0,0,1,.63-1.47c.12-.24.25-.48.36-.71a3.27,3.27,0,0,0,.3-1.11s0-.11-.07-.09c-.61.2-.91.81-1.23,1.33a9.36,9.36,0,0,0-.72,1.41c-.49-2.48-1-5-1.48-7.43h0c.09-.41.16-.82.29-1.22.25-.79.64-1.51,1-2.27a10.42,10.42,0,0,0,.77-2.51,7.17,7.17,0,0,0,.17-2.44c0-.22-.22,0-.2.14.13.9-.6,1.74-1,2.5s-.74,1.37-1.09,2.07c-.16.32-.32.65-.46,1a24.08,24.08,0,0,0-2-6.83,10.69,10.69,0,0,0-4.61-4.62,16.53,16.53,0,0,0-2.44-1c-.09,0-.13.16-.07.2.62.41,1.19.88,1.82,1.28a20.29,20.29,0,0,1,1.94,1.4,7.47,7.47,0,0,1,2.17,3,38.51,38.51,0,0,1,1.79,7.26,19.47,19.47,0,0,0-3.53-.61,10.89,10.89,0,0,1-3.68-1.05c-.16-.08-.22.27-.12.35a8.69,8.69,0,0,0,3.74,1.47l2,.42c.61.14,1.2.33,1.8.5.54,2.84,1.1,5.68,1.66,8.52.07.31.13.63.19.94l-.48-.35a6.25,6.25,0,0,0-1.39-.7,3.45,3.45,0,0,0-.77-.18l-.72,0c-.18,0-.2.35,0,.38a10.27,10.27,0,0,1,1.42.47,8.73,8.73,0,0,1,1.22.62,6.49,6.49,0,0,1,.93.73c.4,2.12.8,4.25,1.33,6.34a21.16,21.16,0,0,0,1.3,3.89,11.39,11.39,0,0,0,3.07,4C47.41,404,47.43,403.21,47.27,403Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.53,299.69c1.82-3.84,5.13-6.9,6.46-10.92a1.22,1.22,0,0,1,.3-.56.79.79,0,0,1,1,.11,2.19,2.19,0,0,1,.49,1,16.83,16.83,0,0,1,.38,9.19,32.44,32.44,0,0,1-1.64,4,72.49,72.49,0,0,1-3.11,7,13.73,13.73,0,0,1-2.6,3.33c-.77.7-2.12,1.91-2.94.61a3.43,3.43,0,0,1-.32-1.92c0-.78,0-1.55,0-2.33a32.26,32.26,0,0,1,.44-4.6,18.91,18.91,0,0,1,1.28-4.37C79.37,300,79.45,299.86,79.53,299.69Z",
    style: {
      fill: "#FECE2F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.36,314.17a19.48,19.48,0,0,0-2.53-5.81l-4.11-7.21c-.1-.18-.24-.39-.46-.41s-.4.2-.52.4c-1.94,3.16-1.87,7.26-.57,10.74a29,29,0,0,0,6.19,9.17,1.14,1.14,0,0,0,1.24.47,1.65,1.65,0,0,0,.82-1.28,2.05,2.05,0,0,0-.06-.49,7.12,7.12,0,0,1,.09-1.38c0-.57.1-1.14.11-1.72A12.15,12.15,0,0,0,73.36,314.17Z",
    style: {
      fill: "#FECE2F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.54,311.63l4-2a.55.55,0,0,1,.35-.08c.19,0,.28.26.32.45a6.09,6.09,0,0,1-.69,4.15,13.68,13.68,0,0,1-2.68,3.34,32.54,32.54,0,0,1-3.36,2.84,30.37,30.37,0,0,1-3.75,2.37,28.43,28.43,0,0,1-4,1.77,24.16,24.16,0,0,1-4.26,1.07c-.77.13-1.79.26-1.94-.75a4.38,4.38,0,0,1,.79-2.63,11.33,11.33,0,0,1,2.48-2.78,35.49,35.49,0,0,1,3.68-2.78c1.29-.85,2.62-1.62,4-2.36s2.75-1.44,4.14-2.14Z",
    style: {
      fill: "#FECE2F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.85,326.66a25,25,0,0,0-1.34-3.32,58.67,58.67,0,0,1-2.89-8c-.44-.05-.81.33-1.08.69a13.67,13.67,0,0,0-2.91,7.54,10.13,10.13,0,0,0,2.73,7.5c1.41,1.41,3.31,2.38,4.31,4.1.19.33.38.7.73.82a.53.53,0,0,0,.57-.26c.11-.21,0-.41,0-.64.07-.69.18-1.37.25-2.06a22.36,22.36,0,0,0,.08-4.09A12.23,12.23,0,0,0,65.85,326.66Z",
    style: {
      fill: "#FECE2F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.37,332.15c2-1.69,4.82-2.18,7.46-2.51s5.39-.59,7.68-1.95a1.62,1.62,0,0,1,.82-.33c.78,0,1.11,1,1,1.77a7.06,7.06,0,0,1-1.49,2.92,14,14,0,0,1-2.2,2.41c-2.92,2.41-7,2.61-10.8,2.7l-2.72.07-1.37,0a11.63,11.63,0,0,1-1.32,0c-.69-.07-.14-.89,0-1.21.37-.67.74-1.34,1.17-2A9.6,9.6,0,0,1,70.37,332.15Z",
    style: {
      fill: "#FECE2F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.15,342.06a16.91,16.91,0,0,0-1.64-3.23l-3.29-5.46c-.34-.57-.79-1.21-1.46-1.23-1.57,4.2-2.42,9-.42,13.05a20.21,20.21,0,0,0,2.55,3.62c.92,1.14,1.85,2.27,2.77,3.4.38.46,1.1,1,1.73.62.29-.15.34-.52.39-.81a9.26,9.26,0,0,0,.17-1.39,4.43,4.43,0,0,0,0-1,16,16,0,0,1-.23-3A14.06,14.06,0,0,0,60.15,342.06Z",
    style: {
      fill: "#FECE2F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70,344a11.56,11.56,0,0,1,3-1.11c1.19-.26,2.43-.27,3.65-.42,2-.24,3.92-.86,5.91-1.16a1,1,0,0,1,.61,0,.92.92,0,0,1,.39.79,6.82,6.82,0,0,1-1,3.86,13.88,13.88,0,0,1-9.26,6.78,34.31,34.31,0,0,1-5.36.45c-.89,0-1.79.1-2.68.23a12,12,0,0,0-1.33.25,1.19,1.19,0,0,1-.81.05c-.44-.19-.47-.8-.43-1.21a4.94,4.94,0,0,1,.66-1.81,16.35,16.35,0,0,1,2.67-3.67,16,16,0,0,1,3.56-2.79Z",
    style: {
      fill: "#FECE2F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51,354.21a36.87,36.87,0,0,0-.55,5.55,18.05,18.05,0,0,0,1,6.93,24.24,24.24,0,0,0,4.18,6.41.7.7,0,0,0,.37.29c.32.08.56-.29.68-.59a16.19,16.19,0,0,0,.91-8.74,16.79,16.79,0,0,0-1.34-4.32c-.29-.63-.72-1.2-1-1.84-.06-.16-.09-.32-.15-.47a9.94,9.94,0,0,0-.76-1.35,18.85,18.85,0,0,1-1.33-3,1.66,1.66,0,0,0-.57-.95.66.66,0,0,0-.65,0c-.23.14-.19.34-.29.56a5,5,0,0,0-.35.74A7.84,7.84,0,0,0,51,354.21Z",
    style: {
      fill: "#FECE2F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.17,361.17a9.93,9.93,0,0,1,2.88-3.26,12.35,12.35,0,0,1,3.1-1.33L75.28,354c.51,3-.89,6-2.94,8.24a29.14,29.14,0,0,1-7,5.1c-1.79,1-3.63,1.83-4.63,2.5-.44.3-.88.62-1.32.95-.28.21-1,.79-1.31.4-.17-.18-.06-.51,0-.72s.12-.62.2-.93l.33-1.18c.11-.38.22-.77.3-1.15,0-.19.07-.39.11-.58a16.93,16.93,0,0,1,.81-2.8A19.52,19.52,0,0,1,61.17,361.17Z",
    style: {
      fill: "#FECE2F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.61,312.86c.74-2,1.38-4,1.93-6s.85-4.2,1.2-6.33c0-.25-.23-.43-.31-.12-.44,1.93-1.14,3.8-1.75,5.68s-1.29,3.65-2,5.44a83.87,83.87,0,0,1-5.1,10l-.78,1.29V322a17.6,17.6,0,0,0-.32-3.54,22.3,22.3,0,0,0-.87-3.23,7.38,7.38,0,0,0-1.52-3c-.12-.1-.21.1-.19.2a21.73,21.73,0,0,0,1.07,2.95,18.29,18.29,0,0,1,.72,3.18,21.92,21.92,0,0,1,.17,3.24,21,21,0,0,0-.15,2.85c-1.39,2.3-2.77,4.6-4,7Q66.81,333.3,66,335l0-.14a20.45,20.45,0,0,0-1.34-3.65c-1.23-2.72-2.64-5.36-3.1-8.34,0-.16-.17,0-.17.07a23.31,23.31,0,0,0,1.86,7.45c.47,1.29.9,2.59,1.26,3.93a14.7,14.7,0,0,1,.37,2c0,.34.07.67.12,1-.06.13-.11.26-.17.4a3.34,3.34,0,0,0-.5,1.18c-.36.84-.71,1.69-1,2.54-1.2,3.1-2.24,6.25-3.16,9.44a19.91,19.91,0,0,0-.93-3.47,19.54,19.54,0,0,0-1.58-3.37,11.5,11.5,0,0,0-2.25-3.16c-.12-.09-.16.19-.13.26.48,1.08,1.21,2,1.69,3.15s.87,2.14,1.22,3.24a50,50,0,0,1,1.31,5.82,123.5,123.5,0,0,0-2.66,13.07c-.68-1.7-1.56-3.29-2.4-4.92-.11-.21-.29.11-.23.25a33.65,33.65,0,0,1,2,6.19c.08.42.16.85.23,1.28q-.91,7-1.12,14.14c0,.71.08,5,.16,7.68a42.31,42.31,0,0,0,.62,6.62,19.63,19.63,0,0,0,1,3.44c.23.5.78,1,1.28.77-.11-.83-.15-1.67-.33-2.49A58.9,58.9,0,0,1,57,388.22c0-1.18,0-2.37,0-3.56q.14-5.54.67-11a13.6,13.6,0,0,1,1.48-2.89c1.69-2.44,4.27-4,6-6.4.1-.13.06-.64-.2-.5a28.82,28.82,0,0,0-4,3,14.82,14.82,0,0,0-2.92,3c.27-2.15.57-4.29.95-6.41q.63-3.56,1.47-7.06a12.35,12.35,0,0,0,.88-1.06c.39-.5.76-1,1.17-1.5a11.92,11.92,0,0,1,2.78-2.33,11.35,11.35,0,0,1,3-1.33,15.28,15.28,0,0,1,1.52-.36,5.42,5.42,0,0,0,1.59-.37c.07,0,.11-.21,0-.26-1.07-.56-2.71-.26-3.84,0a12.36,12.36,0,0,0-3.56,1.43,12.08,12.08,0,0,0-2.67,2.27c.89-3.29,1.93-6.55,3.12-9.75.72-1.91,1.49-3.77,2.32-5.61A8.82,8.82,0,0,1,69,336.28a29.65,29.65,0,0,1,3.23-1,18.59,18.59,0,0,0,3-1.2c.13-.06.15-.41,0-.36-1.25.34-2.6.44-3.87.69a16,16,0,0,0-3.46,1c1.24-2.6,2.58-5.15,4-7.67a12.9,12.9,0,0,1,1.56-1.83,19,19,0,0,1,2.94-1.78,68.74,68.74,0,0,0,6.2-3.77c.12-.09.08-.49-.11-.41a65.22,65.22,0,0,0-7.13,3.48c-.45.24-.94.5-1.42.79l.11-.2A70.29,70.29,0,0,0,79.61,312.86Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.68,388.67a16.09,16.09,0,0,0-.56-3.72,8.2,8.2,0,0,0-2.5-4.46,3.21,3.21,0,0,0-2.5-.7q.39,2.64.77,5.3l.09.56a9.5,9.5,0,0,0,1.22,3.86,5.21,5.21,0,0,0,.7.71,8.54,8.54,0,0,0,1.55,1.26l.26.14a.8.8,0,0,0,.42.13c.5,0,.44-.78.47-1.11a15,15,0,0,0,.08-1.77Z",
    style: {
      fill: "#FECE2F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.13,382A14.93,14.93,0,0,0,74,380.38c.19-.14.45-.29.66-.17a.55.55,0,0,1,.21.34c.37,1.29-.34,2.64-1.15,3.71a14,14,0,0,1-3.42,3.28,10.25,10.25,0,0,1-4.3,1.71c-.91.12-2.93.29-2.54-1.2a5,5,0,0,1,.89-1.62,14.46,14.46,0,0,1,1.43-1.7c1.31-1.3,3.13-1.82,4.8-2.48Z",
    style: {
      fill: "#FECE2F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.36,372.3a15.32,15.32,0,0,1,9.89.34A4.34,4.34,0,0,1,83.37,374a1.7,1.7,0,0,1-.13,2.28,2.31,2.31,0,0,1-1,.39l-15.34,3.77a3.66,3.66,0,0,1-1.23.13c-.2,0-.38-.14-.57-.17s-.32.07-.43-.12a.68.68,0,0,1-.07-.37,5,5,0,0,1,.08-.95,1.9,1.9,0,0,1,.15-.42c.18-.34.31-.69.48-1a10.06,10.06,0,0,1,3.4-3.84A10.89,10.89,0,0,1,71.36,372.3Z",
    style: {
      fill: "#FECE2F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.11,363.12c2.62-1.39,5.71-1.52,8.68-1.61a.61.61,0,0,1,.48.11.58.58,0,0,1,.14.33A4.55,4.55,0,0,1,82,365.53a11.69,11.69,0,0,1-3.78,2.79,22.64,22.64,0,0,1-4.33,1.35l-4,1c-.26.06-.86.38-1.11.19s0-1,.06-1.26a8.75,8.75,0,0,1,.75-1.5,11.84,11.84,0,0,1,1.68-2.68A9.54,9.54,0,0,1,74.11,363.12Z",
    style: {
      fill: "#FECE2F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.72,371.6c-.07-.06-.17-.12-.25-.07a.22.22,0,0,0-.11.18,3.56,3.56,0,0,0-.13.65c0,.06,0,.11,0,.17a2.5,2.5,0,0,1-.11.53,5.36,5.36,0,0,0-.11,1.2,6.14,6.14,0,0,0,.16,1.28,9.18,9.18,0,0,0,1.24,2.83,4.25,4.25,0,0,0,.43.59c.18.21.39.38.58.58A7.68,7.68,0,0,1,62.52,381c.09.15.21.31.38.28a.45.45,0,0,0,.24-.19,1.75,1.75,0,0,0,.37-.61,6.26,6.26,0,0,0,.14-.73.45.45,0,0,0,0-.11,8.86,8.86,0,0,0-.45-3.72,7.59,7.59,0,0,0-3.49-4.3Z",
    style: {
      fill: "#FECE2F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.38,375.54a7.36,7.36,0,0,0-3.84.08,18.79,18.79,0,0,0-4,1.2,9.65,9.65,0,0,0-2.25,1.38,24.1,24.1,0,0,1,3.54-5.61,27.92,27.92,0,0,1,5.66-5.36c.09-.06.1-.35,0-.29a20.91,20.91,0,0,0-5.79,3.72,21.66,21.66,0,0,0-4.25,5.67,22.26,22.26,0,0,0-1.33,3c-.06-.2-.12-.4-.19-.6a9.7,9.7,0,0,0-.83-1.79,6.7,6.7,0,0,0-.56-.83c-.14-.17-.31-.47-.55-.43-.05,0-.07.08-.07.12a2.23,2.23,0,0,0,.36.89c.13.25.26.49.38.74A12.64,12.64,0,0,1,62.2,379c.18.56.28,1.12.41,1.68-.22.73-.4,1.47-.55,2.22a30.72,30.72,0,0,0-.48,4.38,8.33,8.33,0,0,0-.39-.93A11.83,11.83,0,0,0,59.7,384c-.12-.15-.22.18-.15.29a12.21,12.21,0,0,1,1.83,4.88c.06.31.11.61.16.91,0,.5,0,1,0,1.48,0,1.81,0,3.61,0,5.41s-.25,3.44-.32,5.16c0,.26.43.79.63.39,1.23-2.48,1.23-5.5,1.25-8.21,0-1.67,0-3.35,0-5l.07-.06a4.18,4.18,0,0,1,.89-.4A12.9,12.9,0,0,0,66,388a12.28,12.28,0,0,0,3.22-2.47c.06-.07,0-.3-.07-.19a7.45,7.45,0,0,1-3.58,1.94c-.7.19-1.39.39-2.08.6l-.32.11c0-.78.07-1.55.14-2.33a23.29,23.29,0,0,1,.73-4c.55-.57,1-1.32,1.52-1.88a10.58,10.58,0,0,1,2.61-1.83,17.85,17.85,0,0,1,3.34-1.24c.59-.17,1.19-.32,1.79-.48a5.25,5.25,0,0,1,2.06-.4C75.45,375.83,75.49,375.58,75.38,375.54Z",
    style: {
      fill: "#37474f"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Monitor--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M247.73,428.84,294,402.1c4.77-2.75,7.15-6.35,7.15-10s0-6.43,0-6.43L257.63,361a10.18,10.18,0,0,1-4.6-8v-57l-80.75,46.66v57a10.18,10.18,0,0,0,4.6,8l36.34,21.16C222.75,434.34,238.2,434.34,247.73,428.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.67,409.8v6.41l-14.8-8.53a10.18,10.18,0,0,1-4.6-8v-57l15.38-8.87c.32,3.91.67,7.94,1,11.88L177.85,352v44.53a10.11,10.11,0,0,0,4.6,8Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.85,396.5a10.17,10.17,0,0,0,4.6,8l30.76,17.94c9.53,5.5,25,5.5,34.52,0L294,395.68c9.54-5.5,9.54-14.42,0-19.92L263.2,357.81a10.18,10.18,0,0,1-4.6-8V305.3L177.85,352Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.57,363.23h0l-9.37-5.41a10.18,10.18,0,0,1-4.6-8V305.3L177.85,352V396.5a10.17,10.17,0,0,0,4.6,8l9.21,5.32Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.66,431.65c3,1.72,8,1.62,11.14-.21l262-151.25a12.72,12.72,0,0,0,5.75-10v-242c0-3.67-2.42-8-5.4-9.75s-8-1.63-11.15.2L82,169.88a12.73,12.73,0,0,0-5.76,10v242C76.26,425.56,78.68,429.93,81.66,431.65Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.81,431.43,354.75,280.18a12.72,12.72,0,0,0,5.75-10v-242c0-3.67-2.58-5.16-5.75-3.33L92.81,176.11a12.69,12.69,0,0,0-5.75,10v242C87.05,431.78,89.63,433.27,92.81,431.43Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.05,408.54v19.57c0,3.67,2.58,5.16,5.76,3.32L354.75,280.18a12.72,12.72,0,0,0,5.75-10V250.65Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.66,390.34V188.63a7.8,7.8,0,0,1,3.54-6.12l251.15-145c1.95-1.13,3.54-.21,3.54,2V241.23a7.83,7.83,0,0,1-3.54,6.13l-251.17,145C96.24,393.51,94.66,392.59,94.66,390.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78,174.16l10.79,6.22A12.22,12.22,0,0,0,87,186.06V428.11c0,3.35,2.27,5.22,5.75,3.33a12.18,12.18,0,0,1-11.14.21,11.07,11.07,0,0,1-5.4-9.06V179.85A11.87,11.87,0,0,1,78,174.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.6,342.36l13-7.47c1.17-.67,2.11-.19,2.11,1.07a4.5,4.5,0,0,1-2.11,3.5l-13,7.47c-1.16.67-2.11.2-2.11-1.06A4.55,4.55,0,0,1,220.6,342.36Z",
    style: {
      fill: "#FECE2F"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Icons--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Icon--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--online-icon--inject-2",
    d: "M90,46.27c-7.59-4.38-17.24-3.65-27.17,2.08-22.08,12.75-40,47-40,76.38,0,15.75,5.22,27.8,14.31,33.05a21.34,21.34,0,0,0,10.82,2.83c5.14,0,10.7-1.65,16.35-4.91,22.08-12.74,40-47,40-76.38C104.31,63.57,99.1,51.52,90,46.27ZM25.76,122.19c.51-14.55,5.34-30.06,12.81-43.3a20.94,20.94,0,0,0,5.61,1.76,104.2,104.2,0,0,0-7,34.94ZM65,102.85,87,90.16a102.77,102.77,0,0,1-7,33,31.07,31.07,0,0,0-15,3.74Zm0-3.31V75.63A65.37,65.37,0,0,0,80.78,61.8c3.9,6.2,6.13,14.78,6.24,25Zm0-27.31V51.18a20.89,20.89,0,0,1,14.09,8.2A64.66,64.66,0,0,1,65,72.23ZM62.11,74a29.83,29.83,0,0,1-13.83,4.09A111.46,111.46,0,0,1,62.11,53.7Zm-15,7c.26,0,.51,0,.78,0a31.79,31.79,0,0,0,14.19-3.8v24l-22,12.7A102.77,102.77,0,0,1,47.14,81Zm15,23.56v23.91A65.71,65.71,0,0,0,46.3,142.26c-3.9-6.19-6.13-14.77-6.24-25Zm0,27.31v21.07A21,21,0,0,1,48,144.69,65.08,65.08,0,0,1,62.11,131.82ZM65,130.08A29.89,29.89,0,0,1,78.8,126,111.08,111.08,0,0,1,65,150.34Zm24.9-41.6,11.45-6.62c-.51,14.55-5.35,30.08-12.81,43.32a21.33,21.33,0,0,0-5.63-1.77A104.2,104.2,0,0,0,89.89,88.48Zm11.52-10L89.85,85.18C89.5,74.66,87,65.83,82.7,59.44a94.48,94.48,0,0,0,6.87-10C97,54.43,101.24,64.86,101.41,78.51ZM87.09,48a92.51,92.51,0,0,1-6.16,9,23.79,23.79,0,0,0-12.75-8.2,27.45,27.45,0,0,1,11-2.52A18.8,18.8,0,0,1,87.09,48ZM56.84,56.11A116.51,116.51,0,0,0,45.27,77.89,18.26,18.26,0,0,1,40,76.37,81.2,81.2,0,0,1,56.84,56.11ZM25.7,125.54l11.53-6.66c.35,10.53,2.87,19.36,7.15,25.75a95.11,95.11,0,0,0-6.85,9.94C30.14,149.62,25.86,139.19,25.7,125.54ZM40,156a93,93,0,0,1,6.14-9,23.66,23.66,0,0,0,12.69,8.18C52,158.21,45.44,158.49,40,156Zm30.21-8a116.22,116.22,0,0,0,11.58-21.81,18.39,18.39,0,0,1,5.29,1.52A81.09,81.09,0,0,1,70.23,148Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--text-icon--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M173.51,17.59v25l-2.27,1.26V36c0-4.24-3.46-5.69-7.72-3.22l-10.61,6.12V83.92c0,4.92,3,7.18,6.73,5l6.59-3.8.07,0,7.21,4.17L137.44,110.1l-4.87-2.81-2.34,1.35v-2.7l6.65-3.85c3.72-2.14,6.73-7.87,6.73-12.8V44.23L133,50.35c-4.27,2.46-7.73,7.9-7.73,12.15v7.87L123,71.73v-25Z",
    style: {
      fill: "#FECE2F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.51,17.59v25l-2.27,1.26V36c0-4.24-3.46-5.69-7.72-3.22l-10.61,6.12V83.92c0,4.92,3,7.18,6.73,5l6.59-3.8.07,0,7.21,4.17L137.44,110.1l-4.87-2.81-2.34,1.35v-2.7l6.65-3.85c3.72-2.14,6.73-7.87,6.73-12.8V44.23L133,50.35c-4.27,2.46-7.73,7.9-7.73,12.15v7.87L123,71.73v-25Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "178.45 48.01 171.24 43.84 171.24 31.39 178.45 32.76 178.45 48.01",
    style: {
      fill: "#FECE2F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.72,21.75v25L178.45,48V40.13c0-4.25-3.45-5.69-7.72-3.23L160.13,43V88.08c0,4.93,3,7.18,6.73,5l6.65-3.84V92l-36.07,20.83V110.1l6.65-3.84c3.72-2.15,6.73-7.88,6.73-12.8V48.39l-10.6,6.12C136,57,132.5,62.41,132.5,66.66v7.88l-2.27,1.35v-25Z",
    style: {
      fill: "#FECE2F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.72,21.75v25L178.45,48V40.13c0-4.25-3.45-5.69-7.72-3.23L160.13,43V88.08c0,4.93,3,7.18,6.73,5l6.65-3.84V92l-36.07,20.83V110.1l6.65-3.84c3.72-2.15,6.73-7.88,6.73-12.8V48.39l-10.6,6.12C136,57,132.5,62.41,132.5,66.66v7.88l-2.27,1.35v-25Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "173.51 17.59 180.72 21.75 130.23 50.91 123.02 46.74 173.51 17.59",
    style: {
      fill: "#FECE2F"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "173.51 17.59 180.72 21.75 130.23 50.91 123.02 46.74 173.51 17.59",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "123.02 46.74 130.23 50.91 130.23 75.89 123.02 71.73 123.02 46.74",
    style: {
      fill: "#FECE2F"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "123.02 46.74 130.23 50.91 130.23 75.89 123.02 71.73 123.02 46.74",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "130.23 105.94 137.44 110.1 137.44 112.81 130.23 108.64 130.23 105.94",
    style: {
      fill: "#FECE2F"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--window-3--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110.29,382.25a4.29,4.29,0,0,1-2.05.63,5.19,5.19,0,0,1-3-.53,5.59,5.59,0,0,1-2.45-4.43V220.2l4.91,2.83V380.74c0,1.19.59,1.87,1.45,1.87A2.57,2.57,0,0,0,110.29,382.25Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.13,382c-.75,0-.83-.87-.83-1.25V206.41L347.87,68.09V241.72a5.14,5.14,0,0,1-2.3,4L110,381.72A1.74,1.74,0,0,1,109.13,382Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.26,69.16V241.72a4.55,4.55,0,0,1-2,3.46l-235.6,136a1.12,1.12,0,0,1-.54.19c-.21,0-.21-.63-.21-.64v-174L347.26,69.16M348.49,67l-240.8,139V380.74c0,1.19.58,1.87,1.44,1.87a2.28,2.28,0,0,0,1.16-.36l235.59-136a5.75,5.75,0,0,0,2.61-4.52V67Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.23,214.09a5.61,5.61,0,0,1-2.45-4.43V189.28a5.76,5.76,0,0,1,2.61-4.52L341,48.75a4.9,4.9,0,0,1,7.51,4.33V73.46A5.76,5.76,0,0,1,345.88,78L110.29,214A5.61,5.61,0,0,1,105.23,214.09Z",
    style: {
      fill: "#FECE2F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.46,52.66c-.18-1.36-1.28-1.85-2.58-1.09l-235.59,136a5.5,5.5,0,0,0-1.84,1.95l-4.9-2.83a5.38,5.38,0,0,1,1.84-1.94L341,48.75a4.87,4.87,0,0,1,7.48,3.91Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.45,189.53a5.22,5.22,0,0,0-.76,2.57V223l-4.91-2.83V189.28c0-.11,0-.21,0-.32a5.73,5.73,0,0,1,.1-.64,6.14,6.14,0,0,1,.66-1.62Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.49,53.08V67L187,160.34c-1.43.83-2.6.15-2.6-1.51v-5.28c0-1.67-1.17-2.34-2.62-1.51l-61.71,35.54a5.78,5.78,0,0,0-2.61,4.52v5.28a5.79,5.79,0,0,1-2.61,4.53l-7.18,4.14v-14a5.79,5.79,0,0,1,2.6-4.52l235.59-136C347.32,50.74,348.49,51.41,348.49,53.08Z",
    style: {
      fill: "#FECE2F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341,60.56c1.1-.64,2-.12,2,1.16a4.42,4.42,0,0,1-2,3.46c-1.11.64-2,.13-2-1.15A4.42,4.42,0,0,1,341,60.56Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.8,64.72c1.1-.64,2-.12,2,1.15a4.44,4.44,0,0,1-2,3.47c-1.11.64-2,.12-2-1.15A4.42,4.42,0,0,1,333.8,64.72Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.59,68.87c1.1-.63,2-.12,2,1.16a4.44,4.44,0,0,1-2,3.47c-1.11.64-2,.12-2-1.16A4.44,4.44,0,0,1,326.59,68.87Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.49,67V84L107.69,223v-17l5.36-3.1c1.44-.84,1.92-2.1,2.61-4.53l1.82-6.32c.57-2.19,1.17-3.69,2.61-4.52l60.65-34.93c1.45-.83,2.58-.92,3.68.9l2.23,4c.82,1.42,1.23,2.25,2.66,1.42Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "107.69 206.05 107.69 223.03 102.78 220.2 102.78 203.23 107.69 206.05",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "107.69 206.05 107.69 223.03 102.78 220.2 102.78 203.23 107.69 206.05",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.66,207.28l-4.1,2.36,1.57-3a.78.78,0,0,0,0-.74c-.12-.14-.33,0-.47.22l-2.22,4.28v0l-.06.16,0,0a1.64,1.64,0,0,0,0,.22,1.11,1.11,0,0,0,0,.19l0,0,.06.09h0l2.22,1.71a.22.22,0,0,0,.22,0,.78.78,0,0,0,.25-.32.67.67,0,0,0,0-.7l-1.57-1.2,4.1-2.37a.85.85,0,0,0,.33-.69C120,207.31,119.84,207.17,119.66,207.28Z",
    style: {
      fill: "#455a64",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.09,205.3l4.09-2.36-1.56-1.21c-.14-.1-.15-.41,0-.69s.33-.43.46-.32l2.23,1.71h0a.15.15,0,0,1,.06.09s0,0,0,0a.5.5,0,0,1,0,.19.89.89,0,0,1,0,.22l0,.05a.52.52,0,0,1-.06.16h0l-2.23,4.28a.54.54,0,0,1-.21.25.18.18,0,0,1-.25,0,.74.74,0,0,1,0-.73l1.56-3-4.09,2.37c-.19.1-.33,0-.33-.32A.86.86,0,0,1,123.09,205.3Z",
    style: {
      fill: "#455a64",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.53,193.5c0-.25-.24-.22-.35.05l-.56,1.37c-1-.1-2.12.83-2.9,2.49-1,2.15-1,4.69,0,5.67a1.44,1.44,0,0,0,1.84.11A5,5,0,0,0,136.4,201a.7.7,0,0,0,0-.72c-.13-.13-.34,0-.47.27-.75,1.6-2,2.31-2.75,1.58s-.75-2.62,0-4.23c.54-1.14,1.32-1.82,2-1.86l-.43,1c-.11.27,0,.52.17.4l1.67-1.09a.52.52,0,0,0,.18-.46Z",
    style: {
      fill: "#455a64",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.94,160.4l1.5-3.16a1,1,0,0,0,0-1c-.18-.17-.47,0-.64.36l-1.5,3.17-1.49-1.44c-.18-.17-.46,0-.64.37a.94.94,0,0,0,0,1l1.49,1.44-1.49,3.16a1,1,0,0,0,0,1,.27.27,0,0,0,.32,0,.86.86,0,0,0,.32-.39l1.49-3.16,1.5,1.43a.24.24,0,0,0,.32,0,.87.87,0,0,0,.32-.39,1,1,0,0,0,0-1Z",
    style: {
      fill: "#455a64",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142,197.39V192.1a5.78,5.78,0,0,1,2.61-4.52L331.19,79.91c1.44-.83,2.61-.15,2.61,1.51V86.7a5.78,5.78,0,0,1-2.62,4.53L144.58,198.89C143.14,199.73,142,199.05,142,197.39Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.63,91.63a.59.59,0,0,1-.23,0,.68.68,0,0,1-.39-.79l.25-2.14-1-.72a.73.73,0,0,1-.28-.58,1.21,1.21,0,0,1,.43-.92l1.53-1.18a.25.25,0,0,0,.07-.12l.69-2.25a1,1,0,0,1,.77-.73.61.61,0,0,1,.6.36l.58,1.23,1.29-.5a.61.61,0,0,1,.7.16.94.94,0,0,1,0,1l-1.11,2.09a.31.31,0,0,0,0,.12l.26,1.89a1.17,1.17,0,0,1-.32.94.71.71,0,0,1-.61.23l-1.25-.15-1.36,1.73A.77.77,0,0,1,327.63,91.63Zm-.74-4.36,1,.72a.79.79,0,0,1,.27.73L328,90.14l.9-1.15a.73.73,0,0,1,.69-.33l1.25.15a.3.3,0,0,0,.05-.14l-.26-1.88a1.17,1.17,0,0,1,.13-.68l1-1.82-1,.38a.61.61,0,0,1-.79-.32l-.45-1-.61,2a1.11,1.11,0,0,1-.38.57L327,87.15A.42.42,0,0,0,326.89,87.27Zm3.52-3.44Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M336.87,79.27a.91.91,0,0,1-.45-1.69l7.35-4.24a.9.9,0,0,1,1.23.33.91.91,0,0,1-.33,1.24l-7.34,4.24A1,1,0,0,1,336.87,79.27Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.87,83.51a.9.9,0,0,1-.78-.45.91.91,0,0,1,.33-1.24l7.35-4.24a.9.9,0,0,1,1.23.33.91.91,0,0,1-.33,1.24l-7.34,4.24A1,1,0,0,1,336.87,83.51Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.87,87.76a.91.91,0,0,1-.78-.46.9.9,0,0,1,.33-1.23l7.35-4.24a.88.88,0,0,1,1.23.33.9.9,0,0,1-.33,1.23l-7.34,4.24A.87.87,0,0,1,336.87,87.76Z",
    style: {
      fill: "#455a64"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M136.69,217.2v-1.44a2.72,2.72,0,0,1,1.23-2.13l37-21.31c.68-.39,1.24-.07,1.24.71v1.44a2.74,2.74,0,0,1-1.23,2.13l-37,21.31C137.24,218.3,136.69,218,136.69,217.2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.67,219.72l-.11.06a4.89,4.89,0,0,0,.05-.66c0-1.77-1.08-2.58-2.4-1.81a4.55,4.55,0,0,0-1.61,1.74c-.06-2.13-1.39-3.09-3-2.15a7.28,7.28,0,0,0-3,5.81,4.35,4.35,0,0,0,.06.74l-.21.12a4.62,4.62,0,0,0-1.94,3.69h0c0,1.42.87,2.11,1.94,1.49l2.81-1.62h0l7.48-4.32a2.75,2.75,0,0,0,1.16-2.22h0C133.83,219.74,133.32,219.35,132.67,219.72Z",
    style: {
      fill: "#FECE2F"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Gear--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M294.16,126.22l-.53,0s-.06,0-.06-.11a3.1,3.1,0,0,0,0-.44.25.25,0,0,1,0-.18l.52-.74a.2.2,0,0,0,0-.17l-.26-.56s-.07-.07-.1,0l-.58.61a.09.09,0,0,1-.12,0,.79.79,0,0,0-.25-.15.12.12,0,0,1-.05-.13l.13-.83c0-.06,0-.11-.05-.1l-.62.07s-.08,0-.09.11l-.26.86a.18.18,0,0,1-.09.13,2.94,2.94,0,0,0-.39.26s-.08,0-.11,0l-.29-.44a.06.06,0,0,0-.1,0l-.61.75a.23.23,0,0,0,0,.17l.18.56a.22.22,0,0,1,0,.18c-.09.18-.18.36-.26.55a.19.19,0,0,1-.1.1l-.58.16a.16.16,0,0,0-.09.12l-.21,1s0,.1,0,.1l.53,0s.07.05.06.11,0,.3,0,.44a.26.26,0,0,1,0,.18l-.52.74a.2.2,0,0,0,0,.17l.26.56c0,.05.07.07.1,0l.58-.61a.09.09,0,0,1,.12,0,1.28,1.28,0,0,0,.25.15.12.12,0,0,1,.05.13l-.12.83c0,.06,0,.11.05.1l.61-.07a.16.16,0,0,0,.1-.11l.25-.86a.27.27,0,0,1,.09-.13,2.94,2.94,0,0,0,.39-.26s.08,0,.11,0l.29.44s.07,0,.1,0l.61-.75a.19.19,0,0,0,0-.17l-.18-.56a.31.31,0,0,1,0-.19,4.49,4.49,0,0,0,.26-.54.19.19,0,0,1,.1-.1l.58-.16a.16.16,0,0,0,.09-.12l.21-1S294.2,126.22,294.16,126.22Zm-1.45.74c-.2.86-.81,1.61-1.37,1.68s-.86-.58-.67-1.44.81-1.61,1.37-1.68S292.9,126.1,292.71,127Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M308.39,117.51v-1c0-1.1-.67-1.61-1.49-1.13h0a3.57,3.57,0,0,0-1.49,2.85v.86a3.4,3.4,0,0,1-.5,1.67h0a.87.87,0,0,0-.13.44h0c0,.27.17.4.38.28l3.48-2a.89.89,0,0,0,.37-.72h0a.37.37,0,0,0-.11-.29h0A1,1,0,0,1,308.39,117.51Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.61,120.41a1.73,1.73,0,0,1-.71,1.37c-.4.22-.72,0-.72-.54Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.43,100.69,339.09,98a.78.78,0,0,0,.33-.63h0c0-.24-.14-.35-.33-.25l-4.66,2.69a.81.81,0,0,0-.33.63h0C334.1,100.69,334.25,100.8,334.43,100.69Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.43,102.82l4.66-2.69a.78.78,0,0,0,.33-.63h0c0-.25-.14-.36-.33-.25l-4.66,2.69a.81.81,0,0,0-.33.63h0C334.1,102.81,334.25,102.92,334.43,102.82Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.43,104.94l4.66-2.69a.75.75,0,0,0,.33-.63h0c0-.24-.14-.35-.33-.25l-4.66,2.7a.78.78,0,0,0-.33.63h0C334.1,104.94,334.25,105.05,334.43,104.94Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322,109.85l-3.11-1.66,6.58-3.79-3.11,5.25C322.27,109.83,322.13,109.91,322,109.85Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.4,110.72l3.09-6.1v6.3l-6.58,3.79v-6.29L322,111C322.11,111.05,322.29,111,322.4,110.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.4,243.94l19.4-11.21c.72-.42,1.3-.08,1.3.74v1.69a2.86,2.86,0,0,1-1.3,2.25l-19.4,11.21c-.71.42-1.29.08-1.29-.75v-1.68A2.87,2.87,0,0,1,125.4,243.94Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.05,248.53v1.69a2.85,2.85,0,0,1-1.3,2.24l-1.46.84c-.71.42-1.29.08-1.29-.74v-1.69a2.89,2.89,0,0,1,1.29-2.25l1.46-.84C119.47,247.37,120.05,247.7,120.05,248.53Z",
    style: {
      fill: "#FECE2F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.4,253.27l19.4-11.21c.72-.42,1.3-.08,1.3.74v1.69a2.86,2.86,0,0,1-1.3,2.25L125.4,258c-.71.42-1.29.08-1.29-.75v-1.68A2.87,2.87,0,0,1,125.4,253.27Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.05,257.86v1.69a2.85,2.85,0,0,1-1.3,2.24l-1.46.84c-.71.42-1.29.08-1.29-.74V260.2a2.89,2.89,0,0,1,1.29-2.25l1.46-.84C119.47,256.7,120.05,257,120.05,257.86Z",
    style: {
      fill: "#FECE2F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.4,262.6l19.4-11.21c.72-.42,1.3-.08,1.3.74v1.69a2.86,2.86,0,0,1-1.3,2.25l-19.4,11.21c-.71.42-1.29.08-1.29-.75v-1.68A2.87,2.87,0,0,1,125.4,262.6Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.05,267.19v1.69a2.85,2.85,0,0,1-1.3,2.24l-1.46.84c-.71.42-1.29.08-1.29-.74v-1.69a2.89,2.89,0,0,1,1.29-2.25l1.46-.84C119.47,266,120.05,266.36,120.05,267.19Z",
    style: {
      fill: "#FECE2F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.4,293.54l19.4-11.22c.72-.41,1.3-.07,1.3.75v1.69a2.87,2.87,0,0,1-1.3,2.25l-19.4,11.21c-.71.41-1.29.08-1.29-.75v-1.69A2.87,2.87,0,0,1,125.4,293.54Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.05,298.13v1.68a2.86,2.86,0,0,1-1.3,2.25l-1.46.84c-.71.42-1.29.08-1.29-.75v-1.68a2.87,2.87,0,0,1,1.29-2.25l1.46-.84C119.47,297,120.05,297.3,120.05,298.13Z",
    style: {
      fill: "#FECE2F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.4,301.8l19.4-11.21c.72-.42,1.3-.08,1.3.75V293a2.86,2.86,0,0,1-1.3,2.25l-19.4,11.21c-.71.42-1.29.08-1.29-.74v-1.69A2.89,2.89,0,0,1,125.4,301.8Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.05,306.39v1.69a2.85,2.85,0,0,1-1.3,2.24l-1.46.85c-.71.41-1.29.07-1.29-.75v-1.69a2.89,2.89,0,0,1,1.29-2.25l1.46-.84C119.47,305.23,120.05,305.56,120.05,306.39Z",
    style: {
      fill: "#FECE2F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.4,310.06l19.4-11.21c.72-.41,1.3-.08,1.3.75v1.69a2.85,2.85,0,0,1-1.3,2.24l-19.4,11.22c-.71.41-1.29.08-1.29-.75v-1.69A2.89,2.89,0,0,1,125.4,310.06Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.05,314.65v1.69a2.87,2.87,0,0,1-1.3,2.25l-1.46.84c-.71.41-1.29.08-1.29-.75V317a2.87,2.87,0,0,1,1.29-2.24l1.46-.85C119.47,313.49,120.05,313.83,120.05,314.65Z",
    style: {
      fill: "#FECE2F"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "124.11 272.78 124.11 275.69 126.63 272.78 124.11 272.78",
    style: {
      fill: "#FECE2F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.16,272.18c0,.54.39.76.87.48l16.2-9.33a1.89,1.89,0,0,0,.87-1.49c0-.55-.39-.77-.87-.49L129,270.71A1.87,1.87,0,0,0,128.16,272.18Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "124.11 277.46 124.11 280.38 126.63 277.46 124.11 277.46",
    style: {
      fill: "#FECE2F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.16,276.86c0,.54.39.76.87.48l16.2-9.33a1.89,1.89,0,0,0,.87-1.49c0-.55-.39-.77-.87-.49L129,275.39A1.87,1.87,0,0,0,128.16,276.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "124.11 282.14 124.11 285.06 126.63 282.14 124.11 282.14",
    style: {
      fill: "#FECE2F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.16,281.55c0,.54.39.75.87.47l16.2-9.33a1.89,1.89,0,0,0,.87-1.49c0-.55-.39-.77-.87-.49L129,280.07A1.89,1.89,0,0,0,128.16,281.55Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "124.11 286.83 124.11 289.74 126.63 286.83 124.11 286.83",
    style: {
      fill: "#FECE2F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.16,286.23c0,.54.39.75.87.48l16.2-9.34a1.89,1.89,0,0,0,.87-1.49c0-.54-.39-.76-.87-.49L129,284.75A1.89,1.89,0,0,0,128.16,286.23Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.29,110.44a.5.5,0,0,0-.68-.18L112.07,243.93a.51.51,0,0,0-.18.69.5.5,0,0,0,.43.25.47.47,0,0,0,.25-.07l39.87-23V350.67a.5.5,0,0,0,1,0V221.21h0L344.11,111.12A.5.5,0,0,0,344.29,110.44Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--PDF--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M284.15,165.66v38.75a1.81,1.81,0,0,1-.84,1.44l-28,16.19a.58.58,0,0,1-.59.05l-1.56-.9a.58.58,0,0,1-.24-.54V173.84a1.84,1.84,0,0,1,.83-1.44l21-12.15Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256,174.69l-2.91-1.61a1.71,1.71,0,0,0-.21.77v46.8a.58.58,0,0,0,.24.54l1.56.9a.56.56,0,0,0,.59-.06l.73-.42Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.15,165.66v38.75a1.84,1.84,0,0,1-.84,1.44l-28,16.18c-.46.27-.83.05-.83-.48v-46.8a1.83,1.83,0,0,1,.83-1.44l16.35-9.45,4.69-2.71Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.33,161.6l7.43,4.29v38.52a1.48,1.48,0,0,1-.64,1.11l-28,16.18a.33.33,0,0,1-.18.06c-.07,0-.08-.2-.08-.21v-46.8a1.48,1.48,0,0,1,.64-1.11l16.36-9.45,4.49-2.59m0-.45-4.69,2.71-16.35,9.45a1.83,1.83,0,0,0-.83,1.44v46.8c0,.38.19.6.46.6a.73.73,0,0,0,.37-.12l28-16.18a1.84,1.84,0,0,0,.84-1.44V165.66l-7.82-4.51Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.05,166c.3,0,.51.24.51.66v21.72a2,2,0,0,1-.92,1.6L259,201.89a.9.9,0,0,1-.41.12c-.3,0-.51-.24-.51-.66V179.63A2,2,0,0,1,259,178L273,170l6.69-3.86a.81.81,0,0,1,.41-.13m0-.38a1.31,1.31,0,0,0-.61.17l-6.68,3.87-14,8.07a2.42,2.42,0,0,0-1.12,1.93v21.72a.94.94,0,0,0,.9,1.05,1.19,1.19,0,0,0,.6-.18l20.67-11.93a2.43,2.43,0,0,0,1.12-1.94V166.63a.93.93,0,0,0-.9-1Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.76,196.94a.19.19,0,0,1-.17-.1.19.19,0,0,1,.07-.26l17.07-9.86a.2.2,0,1,1,.2.34l-17.08,9.85A.16.16,0,0,1,260.76,196.94Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.76,195a.21.21,0,0,1-.17-.1.19.19,0,0,1,.07-.26l17.07-9.86a.21.21,0,0,1,.27.07.21.21,0,0,1-.07.27l-17.08,9.85A.16.16,0,0,1,260.76,195Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.76,193a.21.21,0,0,1-.17-.1.19.19,0,0,1,.07-.26l17.07-9.86a.21.21,0,0,1,.27.07.19.19,0,0,1-.07.26L260.85,193A.16.16,0,0,1,260.76,193Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.76,191a.2.2,0,0,1-.17-.09.21.21,0,0,1,.07-.27l17.07-9.85a.2.2,0,0,1,.27.07.19.19,0,0,1-.07.26L260.85,191Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.76,189a.19.19,0,0,1-.17-.1.19.19,0,0,1,.07-.26l17.07-9.86a.2.2,0,0,1,.27.08.2.2,0,0,1-.07.26L260.85,189A.16.16,0,0,1,260.76,189Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.76,187a.21.21,0,0,1-.17-.1.19.19,0,0,1,.07-.26l17.07-9.86a.21.21,0,0,1,.27.07.21.21,0,0,1-.07.27L260.85,187A.16.16,0,0,1,260.76,187Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.76,185.05a.21.21,0,0,1-.17-.1.19.19,0,0,1,.07-.26l17.07-9.86a.21.21,0,0,1,.27.07.19.19,0,0,1-.07.26L260.85,185A.16.16,0,0,1,260.76,185.05Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.76,183.06a.2.2,0,0,1-.17-.09.21.21,0,0,1,.07-.27l17.07-9.85a.2.2,0,0,1,.27.07.19.19,0,0,1-.07.26L260.85,183A.15.15,0,0,1,260.76,183.06Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.76,181.08a.19.19,0,0,1-.17-.1.2.2,0,0,1,.07-.26l17.07-9.86a.2.2,0,0,1,.27.08.2.2,0,0,1-.07.26l-17.08,9.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.34,169.21v-8.06l7.81,4.51-7,4C276.71,170,276.34,169.74,276.34,169.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.19,201.78a2.63,2.63,0,0,0-1.19,2.09l0,7.7c0,.77.55,1.08,1.21.69l19.16-11.12V190.69Z",
    style: {
      fill: "#FECE2F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.19,201.78a2.63,2.63,0,0,0-1.19,2.09l0,7.7c0,.77.55,1.08,1.21.69l19.16-11.12V190.69Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "285.4 190.69 284.15 189.97 284.15 191.41 285.4 190.69",
    style: {
      fill: "#FECE2F"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "285.4 190.69 284.15 189.97 284.15 191.41 285.4 190.69",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.2,206.26a.08.08,0,0,1,.1,0,.16.16,0,0,1,.05.13v.82a.41.41,0,0,1-.05.18.28.28,0,0,1-.1.13l-.51.29a.08.08,0,0,1-.1,0,.17.17,0,0,1,0-.13v-.82a.39.39,0,0,1,0-.18.28.28,0,0,1,.1-.13Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.68,200.25c.44-.25.78-.29,1-.11s.36.57.36,1.18a3.44,3.44,0,0,1-.36,1.61,2.54,2.54,0,0,1-1,1.08l-.87.5v1.86a.46.46,0,0,1,0,.19.26.26,0,0,1-.11.12l-.44.26a.08.08,0,0,1-.1,0,.18.18,0,0,1,0-.14V201.4a.46.46,0,0,1,0-.19.25.25,0,0,1,.1-.12Zm-.87,3.22.84-.49a1.5,1.5,0,0,0,.5-.47,1.46,1.46,0,0,0,.18-.77q0-.47-.18-.54a.6.6,0,0,0-.5.11l-.84.48Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.14,198.25a1.53,1.53,0,0,1,.7-.24.61.61,0,0,1,.49.18,1.21,1.21,0,0,1,.31.55,3.6,3.6,0,0,1,.12.88c0,.4,0,.81,0,1.24a5.58,5.58,0,0,1-.12,1,4,4,0,0,1-.31.9,3.2,3.2,0,0,1-.48.75,2.61,2.61,0,0,1-.68.55l-1.37.79a.08.08,0,0,1-.1,0,.16.16,0,0,1-.05-.13v-5.4a.41.41,0,0,1,.05-.18.34.34,0,0,1,.1-.13ZM277,200a2,2,0,0,0-.07-.46.55.55,0,0,0-.17-.3.37.37,0,0,0-.27-.11.87.87,0,0,0-.41.14l-.72.42v3.76l.75-.44a1.34,1.34,0,0,0,.39-.32,2.42,2.42,0,0,0,.27-.41,2.09,2.09,0,0,0,.16-.5,3.33,3.33,0,0,0,.07-.54C277,200.86,277,200.45,277,200Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.94,195.48a.08.08,0,0,1,.1,0,.17.17,0,0,1,0,.13v.59a.41.41,0,0,1,0,.19.25.25,0,0,1-.1.12l-1.73,1v1.63l1.62-.94a.08.08,0,0,1,.1,0,.16.16,0,0,1,.05.13v.59a.49.49,0,0,1-.05.19.25.25,0,0,1-.1.12l-1.62.94v1.91a.49.49,0,0,1,0,.19.25.25,0,0,1-.1.12l-.44.26a.08.08,0,0,1-.1,0,.17.17,0,0,1,0-.13v-5.4a.49.49,0,0,1,0-.19.25.25,0,0,1,.1-.12Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--DOC--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M243.51,189.12v38.74a1.83,1.83,0,0,1-.83,1.44l-28,16.19a.59.59,0,0,1-.58.06l-1.57-.91a.57.57,0,0,1-.24-.54V197.3a1.86,1.86,0,0,1,.83-1.45l21-12.14Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.38,198.14l-2.9-1.61a1.61,1.61,0,0,0-.22.77v46.8a.57.57,0,0,0,.24.54l1.57.91a.59.59,0,0,0,.58-.06l.73-.42Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.51,189.12v38.74a1.86,1.86,0,0,1-.83,1.45l-28,16.18c-.46.26-.84,0-.84-.48V198.2a1.85,1.85,0,0,1,.84-1.44L231,187.31l4.69-2.71Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.7,185.05l7.43,4.29v38.52a1.43,1.43,0,0,1-.65,1.11l-28,16.18a.34.34,0,0,1-.18.07c-.07,0-.07-.21-.07-.21V198.2a1.48,1.48,0,0,1,.64-1.11l16.35-9.45,4.5-2.59m0-.45L231,187.31l-16.35,9.45a1.85,1.85,0,0,0-.84,1.44V245c0,.37.19.59.46.59a.85.85,0,0,0,.38-.11l28-16.18a1.86,1.86,0,0,0,.83-1.45V189.12l-7.81-4.52Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.41,189.42c.31,0,.51.24.51.66v21.73a2,2,0,0,1-.92,1.6l-20.67,11.93a.83.83,0,0,1-.41.12c-.3,0-.51-.24-.51-.65V203.08a2,2,0,0,1,.92-1.6l14-8.07,6.69-3.86a.81.81,0,0,1,.41-.13m0-.38a1.19,1.19,0,0,0-.6.18l-6.69,3.86-14,8.07a2.44,2.44,0,0,0-1.11,1.93v21.73a.93.93,0,0,0,.89,1,1.22,1.22,0,0,0,.61-.18l20.66-11.93a2.42,2.42,0,0,0,1.12-1.93V190.08a.94.94,0,0,0-.9-1Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.12,220.39a.21.21,0,0,1-.17-.09A.2.2,0,0,1,220,220l17.07-9.85a.18.18,0,0,1,.26.07.19.19,0,0,1-.07.26l-17.07,9.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.12,218.41a.2.2,0,0,1-.17-.1.19.19,0,0,1,.08-.26l17.07-9.86a.19.19,0,0,1,.26.08.2.2,0,0,1-.07.26l-17.07,9.85A.19.19,0,0,1,220.12,218.41Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.12,216.43a.22.22,0,0,1-.17-.1.19.19,0,0,1,.08-.26l17.07-9.86a.19.19,0,0,1,.26.07.21.21,0,0,1-.07.27l-17.07,9.85A.19.19,0,0,1,220.12,216.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.12,214.45a.22.22,0,0,1-.17-.1.19.19,0,0,1,.08-.26l17.07-9.86a.19.19,0,0,1,.19.33l-17.07,9.86A.19.19,0,0,1,220.12,214.45Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.12,212.46a.21.21,0,0,1-.17-.09.2.2,0,0,1,.08-.27l17.07-9.85a.18.18,0,0,1,.26.07.19.19,0,0,1-.07.26l-17.07,9.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.12,210.48a.2.2,0,0,1-.17-.1.19.19,0,0,1,.08-.26l17.07-9.86a.19.19,0,0,1,.26.08.2.2,0,0,1-.07.26l-17.07,9.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.12,208.5a.22.22,0,0,1-.17-.1.19.19,0,0,1,.08-.26l17.07-9.86a.19.19,0,0,1,.26.07.21.21,0,0,1-.07.27l-17.07,9.85A.19.19,0,0,1,220.12,208.5Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.12,206.52a.22.22,0,0,1-.17-.1.19.19,0,0,1,.08-.26l17.07-9.86a.19.19,0,0,1,.19.33l-17.07,9.86A.19.19,0,0,1,220.12,206.52Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.12,204.53a.21.21,0,0,1-.17-.09.2.2,0,0,1,.08-.27l17.07-9.85a.18.18,0,0,1,.26.07.19.19,0,0,1-.07.26l-17.07,9.86A.18.18,0,0,1,220.12,204.53Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.7,192.66V184.6l7.81,4.52-7,4C236.07,193.41,235.7,193.19,235.7,192.66Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.56,225.23a2.66,2.66,0,0,0-1.2,2.09l0,7.7c0,.77.54,1.08,1.21.7l19.16-11.13V214.14Z",
    style: {
      fill: "#FECE2F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.56,225.23a2.66,2.66,0,0,0-1.2,2.09l0,7.7c0,.77.54,1.08,1.21.7l19.16-11.13V214.14Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "244.77 214.14 243.51 213.42 243.51 214.87 244.77 214.14",
    style: {
      fill: "#FECE2F"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "244.77 214.14 243.51 213.42 243.51 214.87 244.77 214.14",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.18,229.94a.09.09,0,0,1,.11,0,.17.17,0,0,1,0,.13v.82a.46.46,0,0,1,0,.19.26.26,0,0,1-.11.12l-.5.29a.07.07,0,0,1-.1,0,.2.2,0,0,1-.05-.14v-.82a.41.41,0,0,1,.05-.18.27.27,0,0,1,.1-.13Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.55,224a1.42,1.42,0,0,1,.7-.24.63.63,0,0,1,.49.18,1.15,1.15,0,0,1,.3.55,3.49,3.49,0,0,1,.13.88q0,.6,0,1.23a5.69,5.69,0,0,1-.13,1,4.32,4.32,0,0,1-.3.9,3.14,3.14,0,0,1-.48.74,2.82,2.82,0,0,1-.68.56l-1.37.79s-.08,0-.1,0a.17.17,0,0,1-.05-.13v-5.4a.41.41,0,0,1,.05-.18.23.23,0,0,1,.1-.13Zm.89,1.79a2,2,0,0,0-.07-.46.62.62,0,0,0-.17-.3.38.38,0,0,0-.28-.11.87.87,0,0,0-.4.14l-.73.42v3.76l.76-.44a1.18,1.18,0,0,0,.38-.32,1.81,1.81,0,0,0,.28-.42,2.56,2.56,0,0,0,.16-.49,3.31,3.31,0,0,0,.07-.55C232.45,226.61,232.45,226.19,232.44,225.79Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.75,224.91a5,5,0,0,1,.12-.95,4.22,4.22,0,0,1,.29-.89,3.6,3.6,0,0,1,.49-.77,2.61,2.61,0,0,1,.7-.58,1.31,1.31,0,0,1,.69-.22.66.66,0,0,1,.48.2,1.25,1.25,0,0,1,.3.55,3.14,3.14,0,0,1,.12.81c0,.11,0,.22,0,.35v.79c0,.13,0,.25,0,.36a6.15,6.15,0,0,1-.11.95,4.44,4.44,0,0,1-.3.89,3.19,3.19,0,0,1-.49.76,3,3,0,0,1-.69.58,1.37,1.37,0,0,1-.7.22.68.68,0,0,1-.49-.2,1.26,1.26,0,0,1-.29-.54,3.3,3.3,0,0,1-.12-.82c0-.1,0-.22,0-.35v-.79C233.75,225.13,233.75,225,233.75,224.91Zm2.46-1.38a1.09,1.09,0,0,0-.25-.79c-.16-.13-.36-.12-.61,0a1.46,1.46,0,0,0-.61.68,2.44,2.44,0,0,0-.25,1.07c0,.22,0,.46,0,.72s0,.49,0,.7a1,1,0,0,0,.25.78c.15.13.35.12.61,0A1.57,1.57,0,0,0,236,226a2.52,2.52,0,0,0,.25-1.07c0-.22,0-.45,0-.71S236.22,223.74,236.21,223.53Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240,223.12a.52.52,0,0,1,.06-.2.27.27,0,0,1,.1-.11l.44-.26a.08.08,0,0,1,.1,0s.05.07.05.13a4.17,4.17,0,0,1-.12.75,3.43,3.43,0,0,1-.29.79,3.79,3.79,0,0,1-.49.74,2.77,2.77,0,0,1-.72.59,1.39,1.39,0,0,1-.66.21.7.7,0,0,1-.49-.19,1.16,1.16,0,0,1-.31-.56,3.35,3.35,0,0,1-.14-.85c0-.2,0-.44,0-.69s0-.49,0-.71a5.48,5.48,0,0,1,.14-1,4,4,0,0,1,.31-.92,2.94,2.94,0,0,1,.49-.75,2.52,2.52,0,0,1,.66-.56,1.52,1.52,0,0,1,.72-.24.73.73,0,0,1,.49.17,1,1,0,0,1,.29.45,2.52,2.52,0,0,1,.12.62.34.34,0,0,1-.05.19.25.25,0,0,1-.1.12l-.44.25s-.07,0-.1,0-.06-.06-.06-.13a.77.77,0,0,0-.08-.28.43.43,0,0,0-.16-.19.44.44,0,0,0-.26-.06,1,1,0,0,0-.37.14,1.23,1.23,0,0,0-.37.31,2.26,2.26,0,0,0-.26.42,2.58,2.58,0,0,0-.17.49,3.31,3.31,0,0,0-.06.54c0,.21,0,.45,0,.71s0,.48,0,.69a2.05,2.05,0,0,0,.06.46.72.72,0,0,0,.17.3.42.42,0,0,0,.26.12.69.69,0,0,0,.37-.12,1.48,1.48,0,0,0,.37-.29,1.83,1.83,0,0,0,.26-.36,2,2,0,0,0,.17-.37A1.84,1.84,0,0,0,240,223.12Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--TXT--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M202.94,212.57v38.74a1.84,1.84,0,0,1-.83,1.45l-28,16.18a.59.59,0,0,1-.59.06l-1.57-.91a.57.57,0,0,1-.24-.53V220.75a1.83,1.83,0,0,1,.83-1.44l21-12.15Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.82,221.59,171.91,220a1.61,1.61,0,0,0-.22.77v46.81a.6.6,0,0,0,.24.54c.16.08,1.42.81,1.57.9a.59.59,0,0,0,.59-.06l.73-.42Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.94,212.57v38.75a1.84,1.84,0,0,1-.83,1.44l-28,16.18c-.46.26-.83.05-.83-.48v-46.8a1.84,1.84,0,0,1,.83-1.45l16.35-9.45,4.69-2.7Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.13,208.5l7.43,4.29v38.53a1.48,1.48,0,0,1-.64,1.11l-28,16.18a.41.41,0,0,1-.17.06c-.08,0-.08-.2-.08-.21v-46.8a1.44,1.44,0,0,1,.64-1.11l16.35-9.45,4.5-2.6m0-.44-4.69,2.7-16.35,9.45a1.84,1.84,0,0,0-.83,1.45v46.8c0,.38.18.59.46.59a.73.73,0,0,0,.37-.11l28-16.18a1.84,1.84,0,0,0,.83-1.44V212.57l-7.81-4.51Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.85,212.88c.3,0,.51.24.51.65v21.73a2.06,2.06,0,0,1-.93,1.6l-20.66,11.93a.82.82,0,0,1-.42.13c-.3,0-.51-.24-.51-.66V226.53a2.06,2.06,0,0,1,.93-1.6l14-8.07,6.69-3.86a.9.9,0,0,1,.42-.12m0-.39a1.19,1.19,0,0,0-.61.18l-6.69,3.86-14,8.07a2.44,2.44,0,0,0-1.11,1.93v21.73a.93.93,0,0,0,.89,1,1.22,1.22,0,0,0,.61-.18l20.67-11.93a2.44,2.44,0,0,0,1.11-1.93V213.53a.93.93,0,0,0-.89-1Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.55,243.85a.19.19,0,0,1-.16-.1.18.18,0,0,1,.07-.26l17.07-9.86a.19.19,0,0,1,.26.07.18.18,0,0,1-.07.26l-17.07,9.86A.17.17,0,0,1,179.55,243.85Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.55,241.86a.18.18,0,0,1-.16-.09.2.2,0,0,1,.07-.27l17.07-9.85a.19.19,0,0,1,.26.07.18.18,0,0,1-.07.26l-17.07,9.86A.16.16,0,0,1,179.55,241.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.55,239.88a.17.17,0,0,1-.16-.1.19.19,0,0,1,.07-.26l17.07-9.85a.18.18,0,0,1,.26.07.18.18,0,0,1-.07.26l-17.07,9.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.55,237.9a.19.19,0,0,1-.16-.1.18.18,0,0,1,.07-.26l17.07-9.86a.19.19,0,0,1,.26.07.2.2,0,0,1-.07.27l-17.07,9.85A.17.17,0,0,1,179.55,237.9Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.55,235.92a.19.19,0,0,1-.16-.1.18.18,0,0,1,.07-.26l17.07-9.86a.19.19,0,0,1,.26.07.18.18,0,0,1-.07.26l-17.07,9.86A.17.17,0,0,1,179.55,235.92Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.55,233.93a.18.18,0,0,1-.16-.09.2.2,0,0,1,.07-.27l17.07-9.85a.19.19,0,1,1,.19.33l-17.07,9.86A.16.16,0,0,1,179.55,233.93Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.55,232a.17.17,0,0,1-.16-.1.19.19,0,0,1,.07-.26l17.07-9.85a.18.18,0,0,1,.26.07.18.18,0,0,1-.07.26l-17.07,9.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.55,230a.19.19,0,0,1-.16-.1.18.18,0,0,1,.07-.26l17.07-9.86a.19.19,0,0,1,.26.07.2.2,0,0,1-.07.27l-17.07,9.85A.17.17,0,0,1,179.55,230Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.55,228a.19.19,0,0,1-.16-.1.18.18,0,0,1,.07-.26l17.07-9.86a.19.19,0,0,1,.26.07.18.18,0,0,1-.07.26L179.65,228A.17.17,0,0,1,179.55,228Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.13,216.12v-8.06l7.81,4.51-7,4C195.5,216.86,195.13,216.65,195.13,216.12Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185,248.68a2.66,2.66,0,0,0-1.2,2.09l0,7.71c0,.76.55,1.08,1.21.69L204.2,248V237.6Z",
    style: {
      fill: "#FECE2F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185,248.68a2.66,2.66,0,0,0-1.2,2.09l0,7.71c0,.76.55,1.08,1.21.69L204.2,248V237.6Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "204.2 237.59 202.94 236.87 202.94 238.32 204.2 237.59",
    style: {
      fill: "#FECE2F"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "204.2 237.59 202.94 236.87 202.94 238.32 204.2 237.59",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.49,252.89a.08.08,0,0,1,.1,0,.2.2,0,0,1,0,.14v.82a.39.39,0,0,1,0,.18.34.34,0,0,1-.1.13l-.51.29a.08.08,0,0,1-.1,0,.17.17,0,0,1,0-.13v-.82a.46.46,0,0,1,0-.19.25.25,0,0,1,.1-.12Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.56,246.54a.08.08,0,0,1,.1,0,.2.2,0,0,1,.05.14v.59a.41.41,0,0,1-.05.18.24.24,0,0,1-.1.13l-1,.56v4.58a.43.43,0,0,1,0,.19.25.25,0,0,1-.1.12l-.44.26a.09.09,0,0,1-.11,0,.22.22,0,0,1,0-.13v-4.58l-1,.56a.08.08,0,0,1-.1,0s0-.07,0-.13v-.59a.43.43,0,0,1,0-.19.25.25,0,0,1,.1-.12Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.71,250.57c-.08,0-.13,0-.16,0l-.07-.08-.86-1.35-.86,2.34-.07.17a.37.37,0,0,1-.16.17l-.46.27a.08.08,0,0,1-.1,0,.18.18,0,0,1,0-.14.41.41,0,0,1,0-.1l1.25-3.38L193,246.6a.31.31,0,0,1,0-.08.45.45,0,0,1,.05-.19.25.25,0,0,1,.1-.12l.46-.27q.1-.06.15,0a.23.23,0,0,1,.07.08l.82,1.29.82-2.23a.87.87,0,0,1,.07-.17.35.35,0,0,1,.15-.17l.46-.27a.08.08,0,0,1,.1,0,.18.18,0,0,1,.05.14.58.58,0,0,1,0,.1l-1.2,3.27,1.23,1.92a.31.31,0,0,1,0,.08.58.58,0,0,1,0,.19.26.26,0,0,1-.11.12Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.38,242.6a.08.08,0,0,1,.1,0,.17.17,0,0,1,0,.13v.6a.39.39,0,0,1,0,.18.49.49,0,0,1-.1.13l-1,.56v4.58a.41.41,0,0,1-.05.18.27.27,0,0,1-.1.13l-.44.25a.08.08,0,0,1-.1,0s0-.07,0-.13v-4.58l-1,.57a.08.08,0,0,1-.1,0,.18.18,0,0,1-.05-.14v-.59a.41.41,0,0,1,.05-.18.28.28,0,0,1,.1-.13Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--pdf--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M324.8,142.21V181a1.85,1.85,0,0,1-.84,1.44l-28,16.18a.59.59,0,0,1-.59.06l-1.56-.9a.6.6,0,0,1-.25-.54V150.39a1.81,1.81,0,0,1,.84-1.44l21-12.15Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.67,151.24l-2.91-1.62a1.73,1.73,0,0,0-.22.77V197.2a.6.6,0,0,0,.25.54l1.56.9a.59.59,0,0,0,.59-.06l.73-.42Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.8,142.21V181a1.85,1.85,0,0,1-.84,1.44l-28,16.18c-.46.27-.83,0-.83-.48V151.3a1.86,1.86,0,0,1,.83-1.45l16.35-9.44L317,137.7Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.57,198.89a.65.65,0,0,1-.31-.08.77.77,0,0,1-.34-.71V151.3a2,2,0,0,1,.92-1.61L317,137.48l8,4.62V181a2,2,0,0,1-.93,1.61l-28,16.18A1,1,0,0,1,295.57,198.89Zm21.41-61L296,150a1.67,1.67,0,0,0-.74,1.28v46.8c0,.18.05.32.15.37a.39.39,0,0,0,.39-.06l28-16.18a1.65,1.65,0,0,0,.74-1.27V142.32Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.7,142.52c.3,0,.51.24.51.66V164.9a2,2,0,0,1-.92,1.6l-20.67,11.93a.81.81,0,0,1-.41.13c-.31,0-.52-.24-.52-.66V156.17a2,2,0,0,1,.93-1.59l14-8.07,6.69-3.87a.83.83,0,0,1,.41-.12m0-.39a1.22,1.22,0,0,0-.61.18l-6.69,3.86-14,8.07a2.42,2.42,0,0,0-1.12,1.93V177.9a.94.94,0,0,0,.9,1,1.27,1.27,0,0,0,.6-.17l20.67-11.94a2.44,2.44,0,0,0,1.11-1.93V143.18a.94.94,0,0,0-.89-1.05Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.41,173.49a.19.19,0,0,1-.1-.36l17.07-9.86a.19.19,0,0,1,.26.07.18.18,0,0,1-.07.26l-17.07,9.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.41,171.51a.19.19,0,0,1-.1-.36l17.07-9.86a.19.19,0,0,1,.26.07.18.18,0,0,1-.07.26l-17.07,9.86A.16.16,0,0,1,301.41,171.51Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.41,169.52a.19.19,0,0,1-.17-.09.21.21,0,0,1,.07-.27l17.07-9.85a.19.19,0,0,1,.19.33L301.5,169.5Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.41,167.54a.18.18,0,0,1-.17-.1.19.19,0,0,1,.07-.26l17.07-9.86a.19.19,0,0,1,.26.07.19.19,0,0,1-.07.27l-17.07,9.85A.16.16,0,0,1,301.41,167.54Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.41,165.56a.19.19,0,0,1-.1-.36l17.07-9.86a.19.19,0,0,1,.26.07.19.19,0,0,1-.07.27l-17.07,9.85A.16.16,0,0,1,301.41,165.56Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.41,163.58a.19.19,0,0,1-.1-.36l17.07-9.86a.19.19,0,0,1,.26.07.18.18,0,0,1-.07.26l-17.07,9.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.41,161.59a.19.19,0,0,1-.17-.09.21.21,0,0,1,.07-.27l17.07-9.85a.19.19,0,0,1,.19.33l-17.07,9.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.41,159.61a.18.18,0,0,1-.17-.1.19.19,0,0,1,.07-.26l17.07-9.86a.19.19,0,0,1,.26.08.18.18,0,0,1-.07.26l-17.07,9.85Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.41,157.63a.19.19,0,0,1-.1-.36l17.07-9.86a.19.19,0,0,1,.26.07.19.19,0,0,1-.07.27L301.5,157.6A.16.16,0,0,1,301.41,157.63Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317,145.76V137.7l7.82,4.51-7,4C317.36,146.5,317,146.29,317,145.76Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.84,178.33a2.67,2.67,0,0,0-1.2,2.08l0,7.71c0,.77.55,1.08,1.21.69l19.16-11.12V167.24Z",
    style: {
      fill: "#FECE2F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.84,178.33a2.67,2.67,0,0,0-1.2,2.08l0,7.71c0,.77.55,1.08,1.21.69l19.16-11.12V167.24Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "326.05 167.24 324.8 166.51 324.8 167.96 326.05 167.24",
    style: {
      fill: "#FECE2F"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "326.05 167.24 324.8 166.51 324.8 167.96 326.05 167.24",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.39,180.35l1.16-3.15a.41.41,0,0,0,0-.1c0-.06,0-.11,0-.13a.08.08,0,0,0-.1,0l-.44.26a.33.33,0,0,0-.15.16.89.89,0,0,1-.07.16L312,179.7l-.79-1.25-.07-.08s-.08,0-.15,0l-.44.25a.31.31,0,0,0-.1.12.39.39,0,0,0,0,.18.19.19,0,0,0,0,.08l1.15,1.8-1.2,3.26a.44.44,0,0,0,0,.1.17.17,0,0,0,.05.13.06.06,0,0,0,.09,0l.44-.26a.38.38,0,0,0,.16-.17,1.16,1.16,0,0,0,.06-.16l.83-2.25.83,1.3a.3.3,0,0,1,.07.08s.08,0,.15,0l.44-.25a.27.27,0,0,0,.1-.13.37.37,0,0,0,.05-.17.19.19,0,0,0,0-.08Zm11-3.83-1.18-1.85,1.15-3.16a.44.44,0,0,0,0-.1.22.22,0,0,0,0-.13.08.08,0,0,0-.1,0l-.44.25a.35.35,0,0,0-.15.17.64.64,0,0,0-.07.16l-.79,2.15-.79-1.24a.23.23,0,0,0-.07-.08s-.08,0-.15,0l-.44.26a.25.25,0,0,0-.1.12.39.39,0,0,0,0,.18.31.31,0,0,0,0,.08l1.14,1.8-1.2,3.26a.38.38,0,0,0,0,.1.17.17,0,0,0,0,.13.09.09,0,0,0,.1,0l.44-.25a.35.35,0,0,0,.15-.17L321,178l.83-2.26.83,1.3.07.08s.08,0,.15,0l.44-.26a.25.25,0,0,0,.1-.12.39.39,0,0,0,0-.18A.13.13,0,0,0,323.42,176.52Zm-13.63,6.95-.48.29a.2.2,0,0,0-.1.12.39.39,0,0,0,0,.18v.78c0,.06,0,.11,0,.13s.06,0,.1,0l.48-.28a.2.2,0,0,0,.1-.12.39.39,0,0,0,0-.18v-.79a.17.17,0,0,0,0-.13S309.83,183.45,309.79,183.47Zm6.76-3.68-1.73,1v-4.42a.17.17,0,0,0,0-.13.09.09,0,0,0-.1,0l-.42.25a.2.2,0,0,0-.1.12.41.41,0,0,0-.05.18V182a.17.17,0,0,0,.05.13.07.07,0,0,0,.1,0l2.29-1.32a.25.25,0,0,0,.1-.12.39.39,0,0,0,0-.18v-.57a.17.17,0,0,0,0-.13A.08.08,0,0,0,316.55,179.79Zm3.15-3.46a.55.55,0,0,0-.37-.12,1.85,1.85,0,0,0-.54.06l-.48.11a.69.69,0,0,1-.31,0,.2.2,0,0,1-.17-.1.62.62,0,0,1-.05-.27,1.06,1.06,0,0,1,.05-.31,1.14,1.14,0,0,1,.15-.29,1.51,1.51,0,0,1,.47-.45.61.61,0,0,1,.47-.12.42.42,0,0,1,.24.21.29.29,0,0,0,.08.1s.08,0,.14,0l.36-.21a.2.2,0,0,0,.1-.12.23.23,0,0,0,0-.18,1.08,1.08,0,0,0-.1-.43.73.73,0,0,0-.27-.33.76.76,0,0,0-.44-.1,1.23,1.23,0,0,0-.62.21,2.27,2.27,0,0,0-.55.44,3.07,3.07,0,0,0-.43.59,3,3,0,0,0-.29.69,2.69,2.69,0,0,0-.11.73,1.9,1.9,0,0,0,.07.59.69.69,0,0,0,.19.35.56.56,0,0,0,.32.14,1.56,1.56,0,0,0,.46,0,5,5,0,0,0,.51-.11l.37-.06a.29.29,0,0,1,.22.07.34.34,0,0,1,.07.25.84.84,0,0,1-.07.35,1.34,1.34,0,0,1-.17.31,1.66,1.66,0,0,1-.26.27l-.3.21a1.22,1.22,0,0,1-.34.14.4.4,0,0,1-.22,0,.21.21,0,0,1-.14-.1.83.83,0,0,1-.09-.16.21.21,0,0,0-.08-.1.18.18,0,0,0-.13,0l-.37.21a.4.4,0,0,0-.1.12.39.39,0,0,0,0,.18,1.29,1.29,0,0,0,.14.57.68.68,0,0,0,.33.3.85.85,0,0,0,.48,0,1.86,1.86,0,0,0,.56-.21,3,3,0,0,0,.63-.5,2.87,2.87,0,0,0,.77-1.33,2.64,2.64,0,0,0,.11-.73,1.75,1.75,0,0,0-.07-.55A.71.71,0,0,0,319.7,176.33Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--pdf--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M284.15,231.36V270.1a1.84,1.84,0,0,1-.84,1.45l-28,16.18a.61.61,0,0,1-.59.06l-1.56-.91a.57.57,0,0,1-.24-.54v-46.8a1.83,1.83,0,0,1,.83-1.44l21-12.15Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256,240.38l-2.91-1.61a1.71,1.71,0,0,0-.21.77v46.8a.57.57,0,0,0,.24.54l1.56.91a.61.61,0,0,0,.59-.06l.73-.42Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.15,231.36V270.1a1.87,1.87,0,0,1-.84,1.45l-28,16.18c-.46.26-.83,0-.83-.48V240.44a1.84,1.84,0,0,1,.83-1.44l16.35-9.45,4.69-2.71Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.33,227.29l7.43,4.29V270.1a1.44,1.44,0,0,1-.64,1.11l-28,16.18a.4.4,0,0,1-.18.07c-.07,0-.08-.21-.08-.21V240.44a1.48,1.48,0,0,1,.64-1.11l16.36-9.44,4.49-2.6m0-.45-4.69,2.71L255.29,239a1.84,1.84,0,0,0-.83,1.44v46.81c0,.37.19.59.46.59a.82.82,0,0,0,.37-.11l28-16.18a1.87,1.87,0,0,0,.84-1.45V231.36l-7.82-4.52Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.05,231.66c.3,0,.51.25.51.66v21.73a2,2,0,0,1-.92,1.6L259,267.58a.92.92,0,0,1-.41.13c-.3,0-.51-.25-.51-.66V245.32a2,2,0,0,1,.92-1.6l14-8.07,6.69-3.86a.81.81,0,0,1,.41-.13m0-.38a1.22,1.22,0,0,0-.61.18l-6.68,3.86-14,8.07a2.42,2.42,0,0,0-1.12,1.93v21.73a.94.94,0,0,0,.9,1,1.19,1.19,0,0,0,.6-.18L279.83,256a2.42,2.42,0,0,0,1.12-1.93V232.32a.94.94,0,0,0-.9-1Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.76,262.63a.2.2,0,0,1-.17-.09.21.21,0,0,1,.07-.27l17.07-9.85a.21.21,0,0,1,.27.07.19.19,0,0,1-.07.26l-17.08,9.86A.15.15,0,0,1,260.76,262.63Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.76,260.65a.2.2,0,0,1-.17-.09.21.21,0,0,1,.07-.27l17.07-9.85a.19.19,0,0,1,.27.07.19.19,0,0,1-.07.26l-17.08,9.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.76,258.67a.21.21,0,0,1-.17-.1.19.19,0,0,1,.07-.26l17.07-9.86a.2.2,0,1,1,.2.34l-17.08,9.85A.16.16,0,0,1,260.76,258.67Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.76,256.69a.21.21,0,0,1-.17-.1.19.19,0,0,1,.07-.26l17.07-9.86a.21.21,0,0,1,.27.07.19.19,0,0,1-.07.26l-17.08,9.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.76,254.7a.2.2,0,0,1-.17-.09.19.19,0,0,1,.07-.26l17.07-9.86a.21.21,0,0,1,.27.07.19.19,0,0,1-.07.26l-17.08,9.86A.15.15,0,0,1,260.76,254.7Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.76,252.72a.2.2,0,0,1-.17-.09.21.21,0,0,1,.07-.27l17.07-9.85a.19.19,0,0,1,.27.07.19.19,0,0,1-.07.26l-17.08,9.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.76,250.74a.21.21,0,0,1-.17-.1.19.19,0,0,1,.07-.26l17.07-9.86a.2.2,0,1,1,.2.34l-17.08,9.85A.16.16,0,0,1,260.76,250.74Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.76,248.76a.21.21,0,0,1-.17-.1.19.19,0,0,1,.07-.26l17.07-9.86a.21.21,0,0,1,.27.07.19.19,0,0,1-.07.26l-17.08,9.86A.16.16,0,0,1,260.76,248.76Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.76,246.77a.2.2,0,0,1-.17-.09.19.19,0,0,1,.07-.26l17.07-9.86a.21.21,0,0,1,.27.07.19.19,0,0,1-.07.26l-17.08,9.86A.15.15,0,0,1,260.76,246.77Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.34,234.9v-8.06l7.81,4.52-7,4C276.71,235.65,276.34,235.43,276.34,234.9Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.19,267.47a2.65,2.65,0,0,0-1.19,2.09l0,7.7c0,.77.55,1.08,1.21.7l19.16-11.13V256.38Z",
    style: {
      fill: "#FECE2F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.19,267.47a2.65,2.65,0,0,0-1.19,2.09l0,7.7c0,.77.55,1.08,1.21.7l19.16-11.13V256.38Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "285.4 256.38 284.15 255.66 284.15 257.11 285.4 256.38",
    style: {
      fill: "#FECE2F"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "285.4 256.38 284.15 255.66 284.15 257.11 285.4 256.38",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.2,272a.08.08,0,0,1,.1,0,.17.17,0,0,1,.05.13v.82a.49.49,0,0,1-.05.19.25.25,0,0,1-.1.12l-.51.29a.08.08,0,0,1-.1,0,.2.2,0,0,1,0-.14v-.82a.39.39,0,0,1,0-.18.34.34,0,0,1,.1-.13Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.68,265.94c.44-.25.78-.29,1-.11s.36.57.36,1.18a3.48,3.48,0,0,1-.36,1.62,2.57,2.57,0,0,1-1,1.07l-.87.5v1.87a.39.39,0,0,1,0,.18.36.36,0,0,1-.11.13l-.44.25a.08.08,0,0,1-.1,0,.17.17,0,0,1,0-.13v-5.4a.39.39,0,0,1,0-.18.28.28,0,0,1,.1-.13Zm-.87,3.22.84-.49a1.41,1.41,0,0,0,.5-.47,1.45,1.45,0,0,0,.18-.76q0-.46-.18-.54a.59.59,0,0,0-.5.1l-.84.49Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.14,263.94a1.66,1.66,0,0,1,.7-.24.69.69,0,0,1,.49.18,1.26,1.26,0,0,1,.31.55,3.67,3.67,0,0,1,.12.88c0,.41,0,.82,0,1.24a5.69,5.69,0,0,1-.12,1,4.34,4.34,0,0,1-.31.9,3.36,3.36,0,0,1-.48.74,2.64,2.64,0,0,1-.68.56l-1.37.78s-.07,0-.1,0a.18.18,0,0,1-.05-.14V265a.49.49,0,0,1,.05-.19.25.25,0,0,1,.1-.12Zm.89,1.8a1.94,1.94,0,0,0-.07-.46.58.58,0,0,0-.17-.31.36.36,0,0,0-.27-.1.84.84,0,0,0-.41.13l-.72.42v3.76l.75-.43a1.52,1.52,0,0,0,.39-.32,3,3,0,0,0,.27-.42,2,2,0,0,0,.16-.5A3.33,3.33,0,0,0,277,267Q277,266.34,277,265.74Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.94,261.17a.08.08,0,0,1,.1,0,.17.17,0,0,1,0,.13v.6a.39.39,0,0,1,0,.18.34.34,0,0,1-.1.13l-1.73,1v1.62l1.62-.94a.08.08,0,0,1,.1,0,.17.17,0,0,1,.05.13v.6a.41.41,0,0,1-.05.18.34.34,0,0,1-.1.13l-1.62.93v1.92a.41.41,0,0,1,0,.18.34.34,0,0,1-.1.13l-.44.25a.08.08,0,0,1-.1,0,.17.17,0,0,1,0-.13v-5.4a.41.41,0,0,1,0-.18.28.28,0,0,1,.1-.13Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--doc--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M243.51,254.81v38.75a1.84,1.84,0,0,1-.83,1.44l-28,16.18a.57.57,0,0,1-.58.06l-1.57-.91a.57.57,0,0,1-.24-.53V263a1.83,1.83,0,0,1,.83-1.44l21-12.15Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.38,263.84l-2.9-1.62a1.61,1.61,0,0,0-.22.77V309.8a.6.6,0,0,0,.24.54l1.57.9a.57.57,0,0,0,.58-.06l.73-.42Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.51,254.81v38.75a1.84,1.84,0,0,1-.83,1.44l-28,16.18c-.46.27-.84.05-.84-.48V263.9a1.87,1.87,0,0,1,.84-1.45L231,253l4.69-2.71Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.7,250.74l7.43,4.29v38.53a1.46,1.46,0,0,1-.65,1.11l-28,16.18a.39.39,0,0,1-.18.06c-.07,0-.07-.2-.07-.21V263.9a1.44,1.44,0,0,1,.64-1.11l16.35-9.45,4.5-2.6m0-.44L231,253l-16.35,9.44a1.87,1.87,0,0,0-.84,1.45v46.8c0,.38.19.59.46.59a.74.74,0,0,0,.38-.11l28-16.18a1.84,1.84,0,0,0,.83-1.44V254.81l-7.81-4.51Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.41,255.12c.31,0,.51.24.51.66V277.5a2,2,0,0,1-.92,1.6L218.33,291a.76.76,0,0,1-.41.13c-.3,0-.51-.24-.51-.66V268.77a2,2,0,0,1,.92-1.59l14-8.08,6.69-3.86a.9.9,0,0,1,.41-.12m0-.39a1.19,1.19,0,0,0-.6.18l-6.69,3.86-14,8.07a2.44,2.44,0,0,0-1.11,1.93V290.5a.93.93,0,0,0,.89,1,1.31,1.31,0,0,0,.61-.17l20.66-11.94a2.42,2.42,0,0,0,1.12-1.93V255.78a.94.94,0,0,0-.9-1.05Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.12,286.09a.22.22,0,0,1-.17-.1.19.19,0,0,1,.08-.26l17.07-9.86a.19.19,0,0,1,.19.33l-17.07,9.86A.19.19,0,0,1,220.12,286.09Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.12,284.1A.21.21,0,0,1,220,284a.19.19,0,0,1,.08-.26l17.07-9.86a.19.19,0,0,1,.19.33l-17.07,9.86A.18.18,0,0,1,220.12,284.1Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.12,282.12A.21.21,0,0,1,220,282a.2.2,0,0,1,.08-.27l17.07-9.85a.18.18,0,0,1,.26.07.19.19,0,0,1-.07.26l-17.07,9.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.12,280.14a.22.22,0,0,1-.17-.1.19.19,0,0,1,.08-.26l17.07-9.86a.19.19,0,0,1,.26.07.21.21,0,0,1-.07.27l-17.07,9.85A.19.19,0,0,1,220.12,280.14Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.12,278.16a.22.22,0,0,1-.17-.1.19.19,0,0,1,.08-.26l17.07-9.86a.19.19,0,0,1,.19.33l-17.07,9.86A.19.19,0,0,1,220.12,278.16Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.12,276.17a.21.21,0,0,1-.17-.09.19.19,0,0,1,.08-.26L237.1,266a.19.19,0,0,1,.19.33l-17.07,9.86A.18.18,0,0,1,220.12,276.17Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.12,274.19a.21.21,0,0,1-.17-.09.2.2,0,0,1,.08-.27L237.1,264a.18.18,0,0,1,.26.07.19.19,0,0,1-.07.26l-17.07,9.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.12,272.21a.22.22,0,0,1-.17-.1.19.19,0,0,1,.08-.26L237.1,262a.19.19,0,0,1,.26.07.21.21,0,0,1-.07.27l-17.07,9.85A.19.19,0,0,1,220.12,272.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.12,270.23a.22.22,0,0,1-.17-.1.19.19,0,0,1,.08-.26L237.1,260a.19.19,0,0,1,.19.33l-17.07,9.86A.19.19,0,0,1,220.12,270.23Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.7,258.36V250.3l7.81,4.51-7,4C236.07,259.1,235.7,258.89,235.7,258.36Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.56,290.92a2.66,2.66,0,0,0-1.2,2.09l0,7.71c0,.77.54,1.08,1.21.69l19.16-11.12V279.84Z",
    style: {
      fill: "#FECE2F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.56,290.92a2.66,2.66,0,0,0-1.2,2.09l0,7.71c0,.77.54,1.08,1.21.69l19.16-11.12V279.84Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "244.77 279.84 243.51 279.11 243.51 280.56 244.77 279.84",
    style: {
      fill: "#FECE2F"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "244.77 279.84 243.51 279.11 243.51 280.56 244.77 279.84",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.18,295.64a.08.08,0,0,1,.11,0,.18.18,0,0,1,0,.14v.81a.41.41,0,0,1,0,.19.26.26,0,0,1-.11.12l-.5.3s-.08,0-.1,0a.18.18,0,0,1-.05-.14v-.81a.45.45,0,0,1,.05-.19.2.2,0,0,1,.1-.12Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.55,289.69a1.66,1.66,0,0,1,.7-.24.71.71,0,0,1,.49.18,1.2,1.2,0,0,1,.3.55,3.56,3.56,0,0,1,.13.88c0,.4,0,.82,0,1.24a5.47,5.47,0,0,1-.13,1,4,4,0,0,1-.3.9,3.2,3.2,0,0,1-.48.75,2.78,2.78,0,0,1-.68.55l-1.37.79a.07.07,0,0,1-.1,0,.2.2,0,0,1-.05-.14v-5.4a.41.41,0,0,1,.05-.18.27.27,0,0,1,.1-.13Zm.89,1.79a2.11,2.11,0,0,0-.07-.46.62.62,0,0,0-.17-.3.38.38,0,0,0-.28-.11,1,1,0,0,0-.4.14l-.73.42v3.76l.76-.44a1.29,1.29,0,0,0,.38-.31,2.36,2.36,0,0,0,.28-.42,2.66,2.66,0,0,0,.16-.5,3.33,3.33,0,0,0,.07-.54C232.45,292.3,232.45,291.89,232.44,291.48Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.75,290.6a5.15,5.15,0,0,1,.12-1,4.41,4.41,0,0,1,.29-.89,3.86,3.86,0,0,1,.49-.77,2.81,2.81,0,0,1,.7-.58,1.41,1.41,0,0,1,.69-.22.7.7,0,0,1,.48.2,1.31,1.31,0,0,1,.3.55,3.23,3.23,0,0,1,.12.82c0,.1,0,.22,0,.34v.8c0,.13,0,.24,0,.35a6,6,0,0,1-.11.95,4.23,4.23,0,0,1-.3.89,3.19,3.19,0,0,1-.49.76,2.54,2.54,0,0,1-.69.58,1.5,1.5,0,0,1-.7.23.77.77,0,0,1-.49-.2,1.25,1.25,0,0,1-.29-.55,3.3,3.3,0,0,1-.12-.82c0-.1,0-.21,0-.34V291C233.75,290.83,233.75,290.71,233.75,290.6Zm2.46-1.38a1.06,1.06,0,0,0-.25-.78.5.5,0,0,0-.61,0,1.51,1.51,0,0,0-.61.68,2.46,2.46,0,0,0-.25,1.08c0,.21,0,.45,0,.71s0,.49,0,.7a1,1,0,0,0,.25.78c.15.13.35.12.61,0a1.6,1.6,0,0,0,.61-.67,2.6,2.6,0,0,0,.25-1.08c0-.21,0-.45,0-.71S236.22,289.43,236.21,289.22Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240,288.81a.59.59,0,0,1,.06-.2.27.27,0,0,1,.1-.11l.44-.25s.07,0,.1,0,.05.07.05.14a4.46,4.46,0,0,1-.12.75,3.76,3.76,0,0,1-.78,1.52,2.77,2.77,0,0,1-.72.59,1.2,1.2,0,0,1-.66.21.66.66,0,0,1-.49-.19,1.17,1.17,0,0,1-.31-.55,3.43,3.43,0,0,1-.14-.85c0-.21,0-.44,0-.7s0-.49,0-.71a5.6,5.6,0,0,1,.14-1,3.75,3.75,0,0,1,.31-.91,3,3,0,0,1,.49-.76,2.48,2.48,0,0,1,.66-.55,1.44,1.44,0,0,1,.72-.25.78.78,0,0,1,.49.17.94.94,0,0,1,.29.46,2.44,2.44,0,0,1,.12.61.32.32,0,0,1-.05.19.25.25,0,0,1-.1.12l-.44.26a.09.09,0,0,1-.1,0s-.06-.06-.06-.13a.83.83,0,0,0-.08-.28.49.49,0,0,0-.16-.19.44.44,0,0,0-.26-.05.92.92,0,0,0-.37.13,1.39,1.39,0,0,0-.37.31,2.26,2.26,0,0,0-.26.42,2.67,2.67,0,0,0-.17.5,3.19,3.19,0,0,0-.06.53c0,.22,0,.45,0,.71s0,.49,0,.69a2,2,0,0,0,.06.46.72.72,0,0,0,.17.3.37.37,0,0,0,.26.12.67.67,0,0,0,.37-.11,1.76,1.76,0,0,0,.37-.29,2.7,2.7,0,0,0,.26-.36,2.11,2.11,0,0,0,.17-.38A1.72,1.72,0,0,0,240,288.81Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--txt--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M202.94,278.26V317a1.83,1.83,0,0,1-.83,1.44l-28,16.18a.56.56,0,0,1-.59.06l-1.57-.9a.6.6,0,0,1-.24-.54V286.44a1.84,1.84,0,0,1,.83-1.44l21-12.15Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.82,287.29l-2.91-1.61a1.58,1.58,0,0,0-.22.77v46.8a.58.58,0,0,0,.24.54l1.57.9a.56.56,0,0,0,.59-.06l.73-.42Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.94,278.26V317a1.83,1.83,0,0,1-.83,1.44l-28,16.18c-.46.27-.83.05-.83-.48v-46.8a1.83,1.83,0,0,1,.83-1.44l16.35-9.45,4.69-2.71Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.13,274.19l7.43,4.29V317a1.48,1.48,0,0,1-.64,1.11l-28,16.18a.29.29,0,0,1-.17.06c-.08,0-.08-.2-.08-.21v-46.8a1.48,1.48,0,0,1,.64-1.11l16.35-9.45,4.5-2.6m0-.44-4.69,2.71-16.35,9.45a1.83,1.83,0,0,0-.83,1.44v46.8c0,.38.18.6.46.6a.76.76,0,0,0,.37-.12l28-16.18a1.83,1.83,0,0,0,.83-1.44V278.26l-7.81-4.51Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.85,278.57c.3,0,.51.24.51.66V301a2,2,0,0,1-.93,1.6l-20.66,11.93a.82.82,0,0,1-.42.13c-.3,0-.51-.24-.51-.66V292.23a2,2,0,0,1,.93-1.6l14-8.07,6.69-3.86a.82.82,0,0,1,.42-.13m0-.39a1.19,1.19,0,0,0-.61.18l-6.69,3.86-14,8.07a2.46,2.46,0,0,0-1.11,1.94V314a.94.94,0,0,0,.89,1.05,1.22,1.22,0,0,0,.61-.18l20.67-11.93a2.46,2.46,0,0,0,1.11-1.94V279.23a.94.94,0,0,0-.89-1.05Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.55,309.54a.17.17,0,0,1-.16-.1.18.18,0,0,1,.07-.26l17.07-9.86a.19.19,0,0,1,.26.07.2.2,0,0,1-.07.27l-17.07,9.85A.17.17,0,0,1,179.55,309.54Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.55,307.56a.19.19,0,0,1-.16-.1.18.18,0,0,1,.07-.26l17.07-9.86a.19.19,0,0,1,.26.07.18.18,0,0,1-.07.26l-17.07,9.86A.17.17,0,0,1,179.55,307.56Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.55,305.57a.18.18,0,0,1-.16-.09.18.18,0,0,1,.07-.26l17.07-9.86a.19.19,0,0,1,.26.07.18.18,0,0,1-.07.26l-17.07,9.86A.16.16,0,0,1,179.55,305.57Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.55,303.59a.18.18,0,0,1-.16-.09.2.2,0,0,1,.07-.27l17.07-9.85a.18.18,0,0,1,.26.07.18.18,0,0,1-.07.26l-17.07,9.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.55,301.61a.17.17,0,0,1-.16-.1.18.18,0,0,1,.07-.26l17.07-9.86a.19.19,0,0,1,.26.07.2.2,0,0,1-.07.27l-17.07,9.85A.17.17,0,0,1,179.55,301.61Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.55,299.63a.19.19,0,0,1-.16-.1.18.18,0,0,1,.07-.26l17.07-9.86a.19.19,0,0,1,.26.07.18.18,0,0,1-.07.26l-17.07,9.86A.17.17,0,0,1,179.55,299.63Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.55,297.64a.18.18,0,0,1-.16-.09.18.18,0,0,1,.07-.26l17.07-9.86a.19.19,0,0,1,.26.07.18.18,0,0,1-.07.26l-17.07,9.86A.16.16,0,0,1,179.55,297.64Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.55,295.66a.18.18,0,0,1-.16-.09.2.2,0,0,1,.07-.27l17.07-9.85a.18.18,0,0,1,.26.07.18.18,0,0,1-.07.26l-17.07,9.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.55,293.68a.17.17,0,0,1-.16-.1.18.18,0,0,1,.07-.26l17.07-9.86a.19.19,0,0,1,.26.07.2.2,0,0,1-.07.27l-17.07,9.85A.17.17,0,0,1,179.55,293.68Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.13,281.81v-8.06l7.81,4.51-7,4C195.5,282.56,195.13,282.34,195.13,281.81Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185,314.38a2.64,2.64,0,0,0-1.2,2.09l0,7.7c0,.77.55,1.08,1.21.69l19.16-11.12V303.29Z",
    style: {
      fill: "#FECE2F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185,314.38a2.64,2.64,0,0,0-1.2,2.09l0,7.7c0,.77.55,1.08,1.21.69l19.16-11.12V303.29Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "204.2 303.29 202.94 302.56 202.94 304.01 204.2 303.29",
    style: {
      fill: "#FECE2F"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "204.2 303.29 202.94 302.56 202.94 304.01 204.2 303.29",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.49,318.58a.08.08,0,0,1,.1,0,.17.17,0,0,1,0,.13v.82a.39.39,0,0,1,0,.18.24.24,0,0,1-.1.13l-.51.29a.09.09,0,0,1-.1,0,.2.2,0,0,1,0-.14v-.82a.39.39,0,0,1,0-.18.34.34,0,0,1,.1-.13Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.56,312.23a.08.08,0,0,1,.1,0,.16.16,0,0,1,.05.13V313a.45.45,0,0,1-.05.19.25.25,0,0,1-.1.12l-1,.57v4.58a.39.39,0,0,1,0,.18.34.34,0,0,1-.1.13L191,319a.09.09,0,0,1-.11,0,.22.22,0,0,1,0-.13v-4.58l-1,.56s-.07,0-.1,0a.2.2,0,0,1,0-.14v-.59a.39.39,0,0,1,0-.18.28.28,0,0,1,.1-.13Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.71,316.26c-.08,0-.13,0-.16,0l-.07-.09-.86-1.34-.86,2.34a1.44,1.44,0,0,0-.07.16.35.35,0,0,1-.16.18l-.46.26a.08.08,0,0,1-.1,0,.17.17,0,0,1,0-.13.38.38,0,0,1,0-.1l1.25-3.39L193,312.29a.19.19,0,0,1,0-.08A.41.41,0,0,1,193,312a.28.28,0,0,1,.1-.13l.46-.26c.07,0,.12-.05.15,0a.36.36,0,0,1,.07.09l.82,1.28.82-2.23a.85.85,0,0,1,.07-.16.34.34,0,0,1,.15-.18l.46-.26a.07.07,0,0,1,.1,0,.16.16,0,0,1,.05.13.44.44,0,0,1,0,.1l-1.2,3.27,1.23,1.92a.29.29,0,0,1,0,.09.58.58,0,0,1,0,.18.36.36,0,0,1-.11.13Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.38,308.29a.08.08,0,0,1,.1,0,.18.18,0,0,1,0,.14V309a.39.39,0,0,1,0,.18.36.36,0,0,1-.1.13l-1,.56v4.58a.41.41,0,0,1-.05.18.2.2,0,0,1-.1.13l-.44.25s-.07,0-.1,0a.18.18,0,0,1,0-.14v-4.57l-1,.56a.08.08,0,0,1-.1,0,.17.17,0,0,1-.05-.13v-.59a.41.41,0,0,1,.05-.19.34.34,0,0,1,.1-.13Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--pdf--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M324.8,207.9v38.75a1.84,1.84,0,0,1-.84,1.44l-28,16.19a.58.58,0,0,1-.59.05l-1.56-.9a.59.59,0,0,1-.25-.54v-46.8a1.83,1.83,0,0,1,.84-1.45l21-12.15Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.67,216.93l-2.91-1.61a1.73,1.73,0,0,0-.22.77v46.8a.59.59,0,0,0,.25.54l1.56.9a.56.56,0,0,0,.59-.06l.73-.42Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.8,207.9v38.75a1.84,1.84,0,0,1-.84,1.44l-28,16.18c-.46.27-.83.05-.83-.48V217a1.83,1.83,0,0,1,.83-1.44l16.35-9.45,4.69-2.71Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317,203.84l7.43,4.29v38.52a1.46,1.46,0,0,1-.64,1.11l-28,16.18a.33.33,0,0,1-.18.06c-.08,0-.08-.2-.08-.21V217a1.48,1.48,0,0,1,.64-1.11l16.35-9.45,4.5-2.59m0-.45-4.69,2.71-16.35,9.45a1.83,1.83,0,0,0-.83,1.44v46.8c0,.38.19.6.46.6a.73.73,0,0,0,.37-.12l28-16.18a1.84,1.84,0,0,0,.84-1.44V207.9L317,203.39Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.7,208.21c.3,0,.51.24.51.66V230.6a2,2,0,0,1-.92,1.59l-20.67,11.94a.9.9,0,0,1-.41.12c-.31,0-.52-.24-.52-.66V221.87a2,2,0,0,1,.93-1.6l14-8.07,6.69-3.86a.76.76,0,0,1,.41-.13m0-.38a1.31,1.31,0,0,0-.61.17l-6.69,3.87-14,8.07a2.42,2.42,0,0,0-1.12,1.93v21.72a.94.94,0,0,0,.9,1,1.19,1.19,0,0,0,.6-.18l20.67-11.93a2.44,2.44,0,0,0,1.11-1.93V208.87a.93.93,0,0,0-.89-1Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.41,239.18a.18.18,0,0,1-.17-.1.2.2,0,0,1,.07-.26L318.38,229a.19.19,0,0,1,.19.33l-17.07,9.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.41,237.2a.19.19,0,0,1-.1-.36L318.38,227a.19.19,0,0,1,.26.07.19.19,0,0,1-.07.27l-17.07,9.85A.16.16,0,0,1,301.41,237.2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.41,235.22a.19.19,0,0,1-.1-.36L318.38,225a.19.19,0,0,1,.26.07.18.18,0,0,1-.07.26l-17.07,9.86A.16.16,0,0,1,301.41,235.22Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.41,233.23a.19.19,0,0,1-.17-.09.21.21,0,0,1,.07-.27L318.38,223a.18.18,0,0,1,.26.07.18.18,0,0,1-.07.26l-17.07,9.86A.15.15,0,0,1,301.41,233.23Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.41,231.25a.18.18,0,0,1-.17-.1.2.2,0,0,1,.07-.26L318.38,221a.19.19,0,1,1,.19.33l-17.07,9.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.41,229.27a.19.19,0,0,1-.1-.36l17.07-9.86a.19.19,0,0,1,.26.07.19.19,0,0,1-.07.27l-17.07,9.85Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.41,227.29a.19.19,0,0,1-.1-.36l17.07-9.86a.19.19,0,0,1,.26.07.18.18,0,0,1-.07.26l-17.07,9.86A.16.16,0,0,1,301.41,227.29Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.41,225.3a.19.19,0,0,1-.17-.09.21.21,0,0,1,.07-.27l17.07-9.85a.19.19,0,0,1,.26.07.18.18,0,0,1-.07.26l-17.07,9.86A.15.15,0,0,1,301.41,225.3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.41,223.32a.19.19,0,0,1-.17-.09.21.21,0,0,1,.07-.27l17.07-9.85a.19.19,0,0,1,.19.33L301.5,223.3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317,211.45v-8.06l7.82,4.51-7,4C317.36,212.2,317,212,317,211.45Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.84,244a2.67,2.67,0,0,0-1.2,2.09l0,7.7c0,.77.55,1.08,1.21.69l19.16-11.12V232.93Z",
    style: {
      fill: "#FECE2F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.84,244a2.67,2.67,0,0,0-1.2,2.09l0,7.7c0,.77.55,1.08,1.21.69l19.16-11.12V232.93Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "326.05 232.93 324.8 232.21 324.8 233.65 326.05 232.93",
    style: {
      fill: "#FECE2F"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "326.05 232.93 324.8 232.21 324.8 233.65 326.05 232.93",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.39,246.05l1.16-3.16a.38.38,0,0,0,0-.1.17.17,0,0,0,0-.13.09.09,0,0,0-.1,0l-.44.26a.35.35,0,0,0-.15.17l-.07.16-.78,2.15-.79-1.24-.07-.08s-.08,0-.15,0l-.44.26a.25.25,0,0,0-.1.12.39.39,0,0,0,0,.18.25.25,0,0,0,0,.08l1.15,1.79-1.2,3.27a.37.37,0,0,0,0,.09.16.16,0,0,0,.05.13.06.06,0,0,0,.09,0l.44-.25a.44.44,0,0,0,.16-.17c0-.07.05-.13.06-.16l.83-2.26.83,1.3.07.08s.08,0,.15,0l.44-.25a.2.2,0,0,0,.1-.12.41.41,0,0,0,.05-.18.24.24,0,0,0,0-.08Zm11-3.83-1.18-1.86,1.15-3.16a.37.37,0,0,0,0-.09.2.2,0,0,0,0-.13.08.08,0,0,0-.1,0l-.44.25a.35.35,0,0,0-.15.17,1.28,1.28,0,0,0-.07.16l-.79,2.16-.79-1.25-.07-.08s-.08,0-.15,0l-.44.25a.31.31,0,0,0-.1.12.39.39,0,0,0,0,.18.24.24,0,0,0,0,.08l1.14,1.8-1.2,3.26a.38.38,0,0,0,0,.1.17.17,0,0,0,0,.13.08.08,0,0,0,.1,0l.44-.26a.31.31,0,0,0,.15-.17,1.58,1.58,0,0,0,.07-.16l.83-2.26.83,1.31.07.08s.08,0,.15,0l.44-.25a.34.34,0,0,0,.1-.13.35.35,0,0,0,0-.17A.11.11,0,0,0,323.42,242.22Zm-13.63,6.95-.48.28a.2.2,0,0,0-.1.12.39.39,0,0,0,0,.18v.79a.17.17,0,0,0,0,.13.07.07,0,0,0,.1,0l.48-.28a.2.2,0,0,0,.1-.12.39.39,0,0,0,0-.18v-.79a.17.17,0,0,0,0-.13A.09.09,0,0,0,309.79,249.17Zm6.76-3.69-1.73,1v-4.41c0-.06,0-.11,0-.13a.08.08,0,0,0-.1,0l-.42.24a.27.27,0,0,0-.1.13.34.34,0,0,0-.05.17v5.21a.17.17,0,0,0,.05.13s.06,0,.1,0l2.29-1.33a.25.25,0,0,0,.1-.12.39.39,0,0,0,0-.18v-.57a.17.17,0,0,0,0-.13A.09.09,0,0,0,316.55,245.48ZM319.7,242a.68.68,0,0,0-.37-.12,1.6,1.6,0,0,0-.54.07l-.48.1a.92.92,0,0,1-.31,0,.21.21,0,0,1-.17-.11.62.62,0,0,1-.05-.27,1.18,1.18,0,0,1,.05-.31,1.08,1.08,0,0,1,.15-.28,1.33,1.33,0,0,1,.21-.26,1.57,1.57,0,0,1,.26-.19.61.61,0,0,1,.47-.12.36.36,0,0,1,.24.21.36.36,0,0,0,.08.09s.08,0,.14,0l.36-.21a.29.29,0,0,0,.1-.12.24.24,0,0,0,0-.18,1.09,1.09,0,0,0-.1-.44.66.66,0,0,0-.27-.32.69.69,0,0,0-.44-.11,1.47,1.47,0,0,0-.62.21,2.27,2.27,0,0,0-.55.44,2.85,2.85,0,0,0-.43.6,3,3,0,0,0-.4,1.42,1.94,1.94,0,0,0,.07.59.66.66,0,0,0,.19.34.5.5,0,0,0,.32.14,1.56,1.56,0,0,0,.46,0l.51-.1A1.41,1.41,0,0,1,319,243a.29.29,0,0,1,.22.06.34.34,0,0,1,.07.25.84.84,0,0,1-.07.35,1.34,1.34,0,0,1-.17.31,1.66,1.66,0,0,1-.26.27l-.3.21a1,1,0,0,1-.34.14.41.41,0,0,1-.22,0,.26.26,0,0,1-.14-.11,1.19,1.19,0,0,1-.09-.15.14.14,0,0,0-.08-.1s-.07,0-.13,0l-.37.21a.25.25,0,0,0-.1.12.39.39,0,0,0,0,.18,1.24,1.24,0,0,0,.14.56.66.66,0,0,0,.33.31.94.94,0,0,0,.48,0,1.9,1.9,0,0,0,.56-.22,3,3,0,0,0,.63-.49,3.5,3.5,0,0,0,.48-.63,3,3,0,0,0,.29-.7,2.71,2.71,0,0,0,.11-.74,1.75,1.75,0,0,0-.07-.55A.71.71,0,0,0,319.7,242Z",
    style: {
      fill: "#455a64"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--window-2--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Document--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M301.92,221.48l-6.56-3.82L139.81,310.25V448.91c0,2.23.78,3.79,2,4.52h0l4.17,2.42h0c1.27.73,3,.63,4.95-.49l143.94-83.11a15.48,15.48,0,0,0,7-12.13Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.81,328.94v120c0,2.23.78,3.79,2,4.52h0l4.17,2.42a3.78,3.78,0,0,0,1.82.46l-3.87-5V331.27Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.86,455.52a5.66,5.66,0,0,0,2.72-.85l143.94-83.11a14.62,14.62,0,0,0,6.59-11.43V222.88L144.79,313.14V451.33C144.79,454,145.94,455.52,147.86,455.52Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.3,224.28V360.13a13.91,13.91,0,0,1-6.19,10.73L150.17,454a4.84,4.84,0,0,1-2.31.74c-2,0-2.26-2.36-2.26-3.38V313.6l154.7-89.32m1.62-2.8L144,312.67V451.33c0,3.16,1.58,5,3.88,5a6.31,6.31,0,0,0,3.12-1l143.94-83.11a15.48,15.48,0,0,0,7-12.13V221.48Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.76,208.3c-1.27-.78-3-.7-5,.44L146.81,291.85a15.46,15.46,0,0,0-7,12.12v6.28l4.17,2.42,157.94-91.19V215.2c0-2.22-.78-3.78-2-4.51S296.9,209,295.76,208.3Z",
    style: {
      fill: "#FECE2F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144,306.39a15.5,15.5,0,0,1,7-12.12l143.94-83.11c3.86-2.23,7-.42,7,4v6.28L144,312.67Z",
    style: {
      fill: "#FECE2F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144,306.39a15.5,15.5,0,0,1,7-12.12l143.94-83.11c3.86-2.23,7-.42,7,4v6.28L144,312.67Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300,210.73c-1.28-.79-3-.71-5,.43L151,294.27a14.32,14.32,0,0,0-5,5.22l-4.19-2.4a14.42,14.42,0,0,1,5-5.24l143.94-83.12c2-1.13,3.74-1.21,5-.43s3,1.7,4.14,2.38C299.91,210.7,299.94,210.71,300,210.73Z",
    style: {
      fill: "#FECE2F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300,210.73c-1.28-.79-3-.71-5,.43L151,294.27a14.32,14.32,0,0,0-5,5.22l-4.19-2.4a14.42,14.42,0,0,1,5-5.24l143.94-83.12c2-1.13,3.74-1.21,5-.43s3,1.7,4.14,2.38C299.91,210.7,299.94,210.71,300,210.73Z",
    style: {
      fill: "#fff",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.48,226.07A5.41,5.41,0,0,0,275,230.3c0,1.56,1.09,2.19,2.44,1.42a5.42,5.42,0,0,0,2.45-4.24C279.93,225.92,278.83,225.29,277.48,226.07Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286,221.15a5.39,5.39,0,0,0-2.44,4.23c0,1.56,1.09,2.19,2.44,1.41a5.4,5.4,0,0,0,2.45-4.23C288.48,221,287.38,220.37,286,221.15Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.58,216.22a5.41,5.41,0,0,0-2.44,4.23c0,1.56,1.09,2.2,2.44,1.42a5.42,5.42,0,0,0,2.45-4.24C297,216.08,295.93,215.44,294.58,216.22Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "143.98 312.67 143.98 331.27 301.92 240.11 301.92 221.48 143.98 312.67",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "150.33 313.64 166.5 304.35 166.5 313.62 150.32 322.96 150.33 313.64",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "170.5 302 170.5 305.66 178.57 301 178.57 297.34 170.5 302",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "170.5 307.66 170.5 311.32 178.57 306.66 178.57 303 170.5 307.66",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "182.6 295.01 182.6 298.67 190.67 294.01 190.67 290.35 182.6 295.01",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "182.6 300.67 182.6 304.33 190.67 299.67 190.67 296.01 182.6 300.67",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "194.71 288.02 194.71 291.68 202.78 287.02 202.78 283.36 194.71 288.02",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "194.71 293.68 194.71 297.34 202.78 292.68 202.78 289.02 194.71 293.68",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "231.02 267.06 231.02 270.72 239.09 266.06 239.09 262.4 231.02 267.06",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "231.02 272.72 231.02 276.38 239.09 271.72 239.09 268.06 231.02 272.72",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "243.12 260.07 243.12 263.73 251.19 259.07 251.19 255.41 243.12 260.07",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "243.12 265.73 243.12 269.39 251.19 264.73 251.19 261.07 243.12 265.73",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "255.22 253.08 255.23 256.74 263.3 252.08 263.3 248.42 255.22 253.08",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "255.22 258.74 255.23 262.4 263.3 257.74 263.3 254.08 255.22 258.74",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "206.81 281.03 226.98 269.38 226.98 278.7 206.81 290.35 206.81 281.03",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "267.33 246.09 283.51 236.8 283.51 246.07 267.33 255.41 267.33 246.09",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "287.51 234.44 287.51 238.11 295.58 233.45 295.58 229.78 287.51 234.44",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "287.51 240.1 287.51 243.77 295.58 239.11 295.58 235.44 287.51 240.1",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "143.98 312.67 139.81 310.3 139.81 328.94 143.98 331.27 143.98 312.67",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Spreadsheets--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "168.48 330.17 186.58 319.72 186.58 328.06 168.48 338.53 168.48 330.17",
    style: {
      fill: "#FECE2F"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "168.48 397.07 186.58 386.62 186.58 394.96 168.48 405.43 168.48 397.07",
    style: {
      fill: "#FECE2F"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "168.48 405.43 186.58 394.99 186.58 403.33 168.48 413.79 168.48 405.43",
    style: {
      fill: "#FECE2F"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "168.48 405.43 186.58 394.99 186.58 403.33 168.48 413.79 168.48 405.43",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "277.12 334.34 295.21 323.89 295.21 332.24 277.12 342.7 277.12 334.34",
    style: {
      fill: "#FECE2F"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "277.12 334.34 295.21 323.89 295.21 332.24 277.12 342.7 277.12 334.34",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "277.12 342.7 295.21 332.26 295.21 340.6 277.12 351.06 277.12 342.7",
    style: {
      fill: "#FECE2F"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "277.12 342.7 295.21 332.26 295.21 340.6 277.12 351.06 277.12 342.7",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "277.12 351.07 295.21 340.62 295.21 348.97 277.12 359.43 277.12 351.07",
    style: {
      fill: "#FECE2F"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "277.12 351.07 295.21 340.62 295.21 348.97 277.12 359.43 277.12 351.07",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "277.12 359.43 295.21 348.99 295.21 357.33 277.12 367.79 277.12 359.43",
    style: {
      fill: "#FECE2F"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "277.12 359.43 295.21 348.99 295.21 357.33 277.12 367.79 277.12 359.43",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "259.03 277.89 277.12 267.44 277.12 309.26 259.03 319.72 259.03 277.89",
    style: {
      fill: "#FECE2F"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "259.03 328.07 277.12 317.63 277.12 376.17 259.03 386.63 259.03 328.07",
    style: {
      fill: "#FECE2F"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "186.58 369.89 204.67 359.44 204.67 367.78 186.58 378.25 186.58 369.89",
    style: {
      fill: "#FECE2F"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "186.58 369.89 204.67 359.44 204.67 367.78 186.58 378.25 186.58 369.89",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "222.81 307.16 240.9 296.71 240.9 305.06 222.81 315.52 222.81 307.16",
    style: {
      fill: "#FECE2F"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "222.81 307.16 240.9 296.71 240.9 305.06 222.81 315.52 222.81 307.16",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.16,331.88l-.22.12V450.13L295.69,366V247.84Zm17.89,106.76-17.22,9.94v-7.31l17.22-9.94Zm0-8.35-17.22,9.94v-7.32L168.05,423Zm0-8.36-17.22,9.94v-7.33l17.22-9.94Zm0-8.37-17.22,9.94v-7.34l17.22-9.93Zm0-8.36-17.22,9.94V407.8l17.22-9.94Zm0-8.37-17.22,9.94v-7.34l17.22-9.93Zm0-8.36-17.22,9.94v-7.34l17.22-9.94Zm0-8.36L150.83,390V382.7l17.22-9.93Zm0-8.37-17.22,9.94v-7.34l17.22-9.94Zm0-8.37-17.22,9.94V366L168.05,356Zm0-8.36L150.83,365v-7.34l17.22-9.94Zm0-8.37-17.22,9.94v-7.34l17.22-9.93Zm0-8.36-17.22,9.93v-7.33l17.22-9.94Zm0-8.38-17.22,9.94v-7.32l17.22-9.94Zm18.11,98.28-17.22,9.94v-7.31l17.22-9.94Zm0-8.33-17.22,9.94v-7.34l17.22-9.94Zm0-8.37-17.22,9.94v-7.34l17.22-9.94Zm0-8.36-17.22,9.94v-7.34l17.22-9.94Zm0-8.37-17.22,9.94v-7.34l17.22-9.94Zm0-8.37-17.22,9.94V389l17.22-9.94Zm0-8.37L168.94,388v-7.33l17.22-9.94Zm0-8.36-17.22,9.94v-7.33l17.22-9.94Zm0-8.37-17.22,9.94v-7.34l17.22-9.94Zm0-8.36-17.22,9.94v-7.34l17.22-9.94Zm0-8.37-17.22,9.94v-7.34l17.22-9.94Zm0-8.36-17.22,9.94v-7.34l17.22-9.94Zm0-8.37-17.22,9.94v-7.34l17.22-9.94Zm0-8.36-17.22,9.94v-7.34l17.22-9.94Zm18.09,98.26L187,427.66v-7.31l17.21-9.93Zm0-8.33L187,419.33V412l17.21-9.94Zm0-8.37L187,411v-7.34l17.21-9.94Zm0-8.36L187,402.6v-7.34l17.21-9.94Zm0-8.37L187,394.23v-7.34L204.25,377Zm0-8.36L187,385.87v-7.34l17.21-9.94Zm0-8.37L187,377.5v-7.34l17.21-9.94Zm0-8.36L187,369.14V361.8l17.21-9.94Zm0-8.37L187,360.77v-7.34l17.21-9.94Zm0-8.36L187,352.4v-7.33l17.21-9.94Zm0-8.38L187,344V336.7l17.21-9.94Zm0-8.36L187,335.67v-7.33l17.21-9.94Zm0-8.37L187,327.3V320L204.25,310Zm0-8.36L187,318.94V311.6l17.21-9.94Zm18.11,98.27-17.21,10V409.9L222.36,400Zm0-8.33-17.21,9.94v-7.34l17.21-9.94Zm0-8.37-17.21,9.93v-7.33l17.21-9.94Zm0-8.37-17.21,9.94v-7.33l17.21-9.94Zm0-8.37-17.21,9.94v-7.33l17.21-9.94Zm0-8.36-17.21,9.94v-7.34l17.21-9.93Zm0-8.37L205.15,367V359.7l17.21-9.94Zm0-8.36-17.21,9.94v-7.34l17.21-9.94Zm0-8.37-17.21,9.94V343L222.36,333Zm0-8.36L205.15,342v-7.34l17.21-9.94Zm0-8.37-17.21,9.94v-7.34l17.21-9.94Zm0-8.36-17.21,9.94v-7.34l17.21-9.94Zm0-8.37-17.21,9.94v-7.34l17.21-9.94Zm0-8.36-17.21,9.94v-7.34l17.21-9.94Zm18.11,98.27-17.21,9.94v-7.31l17.21-9.94Zm0-8.34-17.21,9.94v-7.34l17.21-9.94Zm0-8.37-17.21,9.95v-7.34l17.21-9.94Zm0-8.36-17.21,9.94v-7.34l17.21-9.94Zm0-8.37-17.21,9.94V366l17.21-9.94Zm0-8.36L223.26,365v-7.34l17.21-9.94Zm0-8.37-17.21,9.94v-7.33l17.21-9.94Zm0-8.37-17.21,9.94v-7.33L240.47,331Zm0-8.37-17.21,9.94v-7.32l17.21-9.95Zm0-8.36-17.21,9.94v-7.33l17.21-9.94Zm0-8.37-17.21,9.94v-7.33l17.21-9.94Zm0-8.36-17.21,9.94v-7.34l17.21-9.94Zm0-8.37-17.21,9.94v-7.33l17.21-9.94Zm0-8.36L223.26,298V290.7l17.21-9.95Zm18.11,98.28-17.22,9.94V389l17.22-9.94Zm0-8.35L241.36,388v-7.33l17.22-9.94Zm0-8.36-17.22,9.94v-7.34l17.22-9.93Zm0-8.37-17.22,9.94v-7.34L258.58,354Zm0-8.36-17.22,9.94v-7.34l17.22-9.94Zm0-8.37-17.22,9.94v-7.34l17.22-9.94Zm0-8.36-17.22,9.94V338.8l17.22-9.94Zm0-8.37-17.22,9.94v-7.34l17.22-9.94Zm0-8.36-17.22,9.94v-7.34l17.22-9.94Zm0-8.37L241.36,321V313.7l17.22-9.94Zm0-8.36-17.22,9.94v-7.34l17.22-9.94Zm0-8.37-17.22,9.93V297L258.58,287Zm0-8.38-17.22,9.95v-7.33l17.22-9.94Zm0-8.36-17.22,9.94v-7.32l17.22-9.94Zm18.11,98.28-17.22,9.94v-7.31l17.22-9.94Zm0-8.34-17.22,9.94v-7.34l17.22-9.94Zm0-8.36-17.22,9.94v-7.34l17.22-9.94Zm0-8.37-17.22,9.94v-7.34l17.22-9.94Zm0-8.37-17.22,9.94v-7.33l17.22-9.94Zm0-8.37L259.47,344v-7.33l17.22-9.94Zm0-8.36-17.22,9.94v-7.33l17.22-9.94Zm0-8.37-17.22,9.94V320L276.69,310Zm0-8.36L259.47,319v-7.34l17.22-9.94Zm0-8.37-17.22,9.94v-7.34l17.22-9.94Zm0-8.36-17.22,9.94v-7.34l17.22-9.94Zm0-8.37-17.22,9.94v-7.34l17.22-9.94Zm0-8.36-17.22,9.94v-7.34l17.22-9.94Zm0-8.37-17.22,9.94v-7.33l17.22-9.94Zm18.11,98.27-17.22,9.94v-7.31l17.22-9.94Zm0-8.34-17.22,9.94v-7.34l17.22-9.94Zm0-8.36-17.22,9.94v-7.34l17.22-9.94Zm0-8.37-17.22,9.94V343L294.8,333Zm0-8.36L277.58,342v-7.34l17.22-9.94Zm0-8.37-17.22,9.94v-7.34l17.22-9.94Zm0-8.36-17.22,9.94v-7.34L294.8,308Zm0-8.37-17.22,9.94v-7.34l17.22-9.94Zm0-8.36-17.22,9.93v-7.33l17.22-9.94Zm0-8.38-17.22,9.94v-7.33l17.22-9.94Zm0-8.36-17.22,9.94v-7.33l17.22-9.94Zm0-8.37-17.22,9.94v-7.33l17.22-9.94Zm0-8.36L277.58,275v-7.34l17.22-9.94Zm0-8.37-17.22,9.94v-7.33l17.22-9.94Z",
    style: {
      fill: "#e0e0e0"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--window-1--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--document--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M465,96l-6.56-3.81L291.26,191.52V432.2c0,2.22.78,3.79,2,4.52h0l4.17,2.42h0c1.27.73,3,.62,4.95-.49L458,348.79a15.47,15.47,0,0,0,7-12.12Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.3,436.72h0l4.17,2.42a3.64,3.64,0,0,0,1.82.45l-3.87-5V194l-4.17-2.43V432.2C291.26,434.42,292,436,293.3,436.72Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.3,438.81A5.69,5.69,0,0,0,302,438l155.61-89.87a14.62,14.62,0,0,0,6.59-11.42V97.39l-168,97V434.62C296.24,437.24,297.38,438.81,299.3,438.81Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.42,98.79V336.67a13.91,13.91,0,0,1-6.19,10.72L301.62,437.26a4.87,4.87,0,0,1-2.32.74c-2,0-2.25-2.37-2.25-3.38V194.88L463.42,98.79M465,96,295.43,194V434.62c0,3.16,1.58,5,3.87,5a6.33,6.33,0,0,0,3.13-.95L458,348.79a15.47,15.47,0,0,0,7-12.12V96Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.88,82.81c-1.27-.78-3.05-.69-5,.45L298.26,173.13a15.46,15.46,0,0,0-7,12.12v6.27l4.17,2.43L465,96V89.72c0-2.22-.78-3.78-2-4.51S460,83.51,458.88,82.81Z",
    style: {
      fill: "#FECE2F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.43,187.67a15.46,15.46,0,0,1,7-12.12L458,85.68c3.86-2.23,7-.42,7,4V96L295.43,194Z",
    style: {
      fill: "#FECE2F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.43,187.67a15.46,15.46,0,0,1,7-12.12L458,85.68c3.86-2.23,7-.42,7,4V96L295.43,194Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.08,85.25c-1.28-.79-3.05-.72-5,.43L302.43,175.55a14.14,14.14,0,0,0-4.94,5.22l-4.19-2.41a14.38,14.38,0,0,1,5-5.23l155.6-89.88c2-1.13,3.75-1.21,5-.43s3,1.7,4.14,2.38C463,85.22,463.06,85.23,463.08,85.25Z",
    style: {
      fill: "#FECE2F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.08,85.25c-1.28-.79-3.05-.72-5,.43L302.43,175.55a14.14,14.14,0,0,0-4.94,5.22l-4.19-2.41a14.38,14.38,0,0,1,5-5.23l155.6-89.88c2-1.13,3.75-1.21,5-.43s3,1.7,4.14,2.38C463,85.22,463.06,85.23,463.08,85.25Z",
    style: {
      fill: "#fff",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.6,100.59a5.39,5.39,0,0,0-2.44,4.23c0,1.56,1.09,2.19,2.44,1.41a5.39,5.39,0,0,0,2.45-4.23C443.05,100.44,442,99.81,440.6,100.59Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.15,95.67a5.38,5.38,0,0,0-2.44,4.23c0,1.56,1.09,2.19,2.44,1.41a5.4,5.4,0,0,0,2.45-4.23C451.6,95.52,450.5,94.89,449.15,95.67Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.7,90.74A5.39,5.39,0,0,0,455.26,95c0,1.56,1.09,2.19,2.44,1.41a5.39,5.39,0,0,0,2.45-4.23C460.15,90.59,459.05,90,457.7,90.74Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Article--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Image--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M386.84,156.14V211.9c0,.94.66,1.32,1.48.85L450,177.15a3.26,3.26,0,0,0,1.48-2.56V118.83c0-.94-.66-1.32-1.48-.85l-61.66,35.6A3.26,3.26,0,0,0,386.84,156.14Z",
    style: {
      fill: "#FECE2F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.84,156.14V211.9c0,.94.66,1.32,1.48.85L450,177.15a3.26,3.26,0,0,0,1.48-2.56V118.83c0-.94-.66-1.32-1.48-.85l-61.66,35.6A3.26,3.26,0,0,0,386.84,156.14Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "390.25 156.4 448.05 123.03 448.05 174.33 390.25 207.7 390.25 156.4",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "390.25 207.7 390.25 193.37 405.86 157.93 431.31 175.61 422.87 167.04 433.61 153.59 448.05 160.14 448.05 174.33 390.25 207.7",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 428.38,
    cy: 146.44,
    rx: 6.53,
    ry: 3.77,
    transform: "translate(87.38 444.21) rotate(-60)",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--sample-text--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M386.84,227.29a.92.92,0,0,1-.46-1.71L451,188.27a.92.92,0,0,1,.92,1.59L387.3,227.17A1,1,0,0,1,386.84,227.29Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.84,235.87a.92.92,0,0,1-.46-1.71L451,196.85a.92.92,0,0,1,1.25.34.9.9,0,0,1-.33,1.25L387.3,235.75A1,1,0,0,1,386.84,235.87Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.84,244.46a.92.92,0,0,1-.46-1.72L451,205.43a.92.92,0,0,1,1.25.34.9.9,0,0,1-.33,1.25L387.3,244.33A.87.87,0,0,1,386.84,244.46Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.84,253a.93.93,0,0,1-.8-.46.92.92,0,0,1,.34-1.25L451,214a.92.92,0,0,1,.92,1.59L387.3,252.92A1,1,0,0,1,386.84,253Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.84,262.16a.91.91,0,0,1-.46-1.71L451,223.14a.92.92,0,0,1,1.25.34.9.9,0,0,1-.33,1.25L387.3,262A.86.86,0,0,1,386.84,262.16Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.84,272.39a.92.92,0,0,1-.46-1.72L451,233.36a.92.92,0,0,1,1.25.34.9.9,0,0,1-.33,1.25L387.3,272.26A.87.87,0,0,1,386.84,272.39Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.84,281a.93.93,0,0,1-.8-.46.92.92,0,0,1,.34-1.25L451,241.94a.92.92,0,0,1,1.25.34.9.9,0,0,1-.33,1.25L387.3,280.84A.87.87,0,0,1,386.84,281Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.84,289.55a.92.92,0,0,1-.46-1.71L451,250.53a.92.92,0,0,1,.92,1.59L387.3,289.43A1,1,0,0,1,386.84,289.55Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.84,298.13a.92.92,0,0,1-.46-1.71L451,259.11a.92.92,0,0,1,1.25.34.91.91,0,0,1-.33,1.25L387.3,298A1,1,0,0,1,386.84,298.13Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--image--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M309.88,358.34V414.1c0,.94.66,1.32,1.47.85L373,379.35a3.28,3.28,0,0,0,1.48-2.56V321c0-.94-.66-1.33-1.48-.85l-61.67,35.6A3.26,3.26,0,0,0,309.88,358.34Z",
    style: {
      fill: "#FECE2F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.88,358.34V414.1c0,.94.66,1.32,1.47.85L373,379.35a3.28,3.28,0,0,0,1.48-2.56V321c0-.94-.66-1.33-1.48-.85l-61.67,35.6A3.26,3.26,0,0,0,309.88,358.34Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "313.29 358.6 371.09 325.23 371.09 376.52 313.29 409.9 313.29 358.6",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "313.29 409.9 313.29 395.57 328.9 360.13 354.35 377.8 345.91 369.24 356.64 355.78 371.09 362.33 371.09 376.52 313.29 409.9",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.42,343.31C354,341.84,356,343,356,346a10.22,10.22,0,0,1-4.62,8c-2.55,1.47-4.61.27-4.61-2.67A10.19,10.19,0,0,1,351.42,343.31Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M310.8,263.8a.92.92,0,0,1-.46-1.72L375,224.77a.92.92,0,0,1,.92,1.59l-64.62,37.31A.89.89,0,0,1,310.8,263.8Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.8,272.38a.93.93,0,0,1-.8-.46.92.92,0,0,1,.34-1.25L375,233.36a.9.9,0,0,1,1.25.33.93.93,0,0,1-.33,1.26l-64.62,37.3A.89.89,0,0,1,310.8,272.38Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.8,281a.92.92,0,0,1-.46-1.71L375,241.94a.91.91,0,0,1,1.25.33.93.93,0,0,1-.33,1.26l-64.62,37.31A1,1,0,0,1,310.8,281Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.8,289.47a.91.91,0,0,1-.46-1.71L375,250.45a.92.92,0,0,1,.92,1.59l-64.62,37.31A1,1,0,0,1,310.8,289.47Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.62,203.84a.92.92,0,0,1-.46-1.71L375,181.47a.9.9,0,0,1,1.25.33.93.93,0,0,1-.33,1.26l-35.8,20.66A.93.93,0,0,1,339.62,203.84Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.62,212.42a.91.91,0,0,1-.79-.46.92.92,0,0,1,.33-1.25L375,190.05a.92.92,0,0,1,.92,1.59l-35.8,20.66A.93.93,0,0,1,339.62,212.42Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.62,195.1a.91.91,0,0,1-.79-.46.92.92,0,0,1,.33-1.25L375,172.73a.92.92,0,0,1,.92,1.59L340.08,195A.93.93,0,0,1,339.62,195.1Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.62,186.36a.92.92,0,0,1-.79-.45.94.94,0,0,1,.33-1.26L375,164a.92.92,0,0,1,.92,1.59l-35.8,20.66A.83.83,0,0,1,339.62,186.36Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.8,237.65a.91.91,0,0,1-.46-1.71L375,198.63a.92.92,0,0,1,.92,1.59l-64.62,37.31A1,1,0,0,1,310.8,237.65Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.8,246.24a.92.92,0,0,1-.46-1.72L375,207.21a.92.92,0,0,1,.92,1.59l-64.62,37.31A.89.89,0,0,1,310.8,246.24Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.8,254.75a.92.92,0,0,1-.46-1.71L375,215.73a.91.91,0,0,1,1.25.33.93.93,0,0,1-.33,1.26l-64.62,37.31A1,1,0,0,1,310.8,254.75Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--image--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M386.81,313.82V325c0,.94.66,1.32,1.47.85L450,290.24a3.24,3.24,0,0,0,1.48-2.55V276.51c0-.94-.66-1.32-1.48-.85l-61.67,35.6A3.28,3.28,0,0,0,386.81,313.82Z",
    style: {
      fill: "#FECE2F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.81,313.82V325c0,.94.66,1.32,1.47.85L450,290.24a3.24,3.24,0,0,0,1.48-2.55V276.51c0-.94-.66-1.32-1.48-.85l-61.67,35.6A3.28,3.28,0,0,0,386.81,313.82Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M386.81,372.9a.92.92,0,0,1-.46-1.71L451,333.88a.92.92,0,0,1,1.25.34.9.9,0,0,1-.33,1.25l-64.62,37.31A1,1,0,0,1,386.81,372.9Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.81,338.18a.93.93,0,0,1-.8-.46.92.92,0,0,1,.34-1.25L451,299.16a.9.9,0,0,1,1.25.33.92.92,0,0,1-.33,1.26l-64.62,37.31A1,1,0,0,1,386.81,338.18Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.81,346.76a.92.92,0,0,1-.46-1.71L451,307.74a.92.92,0,0,1,1.25.34.9.9,0,0,1-.33,1.25l-64.62,37.31A1,1,0,0,1,386.81,346.76Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.81,355.35a.92.92,0,0,1-.46-1.72L451,316.32a.92.92,0,0,1,1.25.34.9.9,0,0,1-.33,1.25l-64.62,37.31A.89.89,0,0,1,386.81,355.35Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.81,363.86a.93.93,0,0,1-.8-.46.92.92,0,0,1,.34-1.25L451,324.84a.9.9,0,0,1,1.25.33.92.92,0,0,1-.33,1.26l-64.62,37.31A1,1,0,0,1,386.81,363.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.8,298.06a.92.92,0,0,1-.46-1.72L375,259a.92.92,0,0,1,.92,1.59l-64.62,37.31A.89.89,0,0,1,310.8,298.06Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.8,306.64a.92.92,0,0,1-.46-1.71L375,267.62a.91.91,0,0,1,1.25.33.93.93,0,0,1-.33,1.26l-64.62,37.31A1,1,0,0,1,310.8,306.64Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.8,315.41a.92.92,0,0,1-.46-1.71L375,276.39a.92.92,0,0,1,.92,1.59l-64.62,37.31A1,1,0,0,1,310.8,315.41Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.8,324a.91.91,0,0,1-.46-1.71L375,285a.92.92,0,0,1,.92,1.59l-64.62,37.31A.88.88,0,0,1,310.8,324Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.8,332.58a.93.93,0,0,1-.8-.46.92.92,0,0,1,.34-1.25L375,293.56a.9.9,0,0,1,1.25.33.93.93,0,0,1-.33,1.26l-64.62,37.3A.89.89,0,0,1,310.8,332.58Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.8,341.56a.91.91,0,0,1-.46-1.71L375,302.54a.92.92,0,0,1,.92,1.59l-64.62,37.31A.88.88,0,0,1,310.8,341.56Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M311.21,202l2-3.85-1,9.85-2.32,1.34.2-9.4,18.8-10.86.18,9.19-2.31,1.33-1-8.73,1.94,1.6ZM320,220.75l4.82-2v2.4l-10.67,6.16v-2.4l4.78-3.52Zm-2.67-13.33c0-5.26,0-6.44-.1-11.64l4.5-2.59c-.1,5.21-.1,6.39-.1,11.75v2.19c0,5.28,0,10.59.1,15.79l-4.5,2.59c.1-5.21.1-10.52.1-15.88Z",
    style: {
      fill: "#455a64"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Folder--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--folder--inject-2",
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M377.65,98.87a1.33,1.33,0,0,1-1.33-1.34v-54a3.18,3.18,0,0,1,.46-1.57,3.35,3.35,0,0,1,1.12-1.18l16.17-9.33a1.69,1.69,0,0,1,1.72,0,1.77,1.77,0,0,1,.83,1.06l1.3,4.36a.67.67,0,0,0,.38.45.66.66,0,0,0,.57-.07l38-21.94a1.47,1.47,0,0,1,1.36-.15l.17.09a1.46,1.46,0,0,1,.61,1.29V61.8a3.46,3.46,0,0,1-1.58,2.75L378.32,98.69A1.35,1.35,0,0,1,377.65,98.87ZM395,32.24a.78.78,0,0,0-.37.11l-16.17,9.33a2.19,2.19,0,0,0-.72.78,2.1,2.1,0,0,0-.31,1V97.53a.22.22,0,0,0,.11.2.25.25,0,0,0,.24,0L436.91,63.6a2.37,2.37,0,0,0,1-1.8V16.44a.55.55,0,0,0-.09-.36l-.07,0a.72.72,0,0,0-.33.12l-38,21.94a1.77,1.77,0,0,1-1.53.14,1.73,1.73,0,0,1-1-1.16l-1.3-4.35a.7.7,0,0,0-.3-.41A.57.57,0,0,0,395,32.24Z",
    style: {
      fill: "#FECE2F"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--folder--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M446.64,21.3a.94.94,0,0,0-.36-.83h0l0,0L443.79,19h0a.93.93,0,0,0-.92.1L405.25,40.81l-1-3.38a1.23,1.23,0,0,0-.55-.73h0l-2.48-1.43h0a1.19,1.19,0,0,0-1.21,0l-16.16,9.33a2.89,2.89,0,0,0-1.31,2.28v53.89a.92.92,0,0,0,.36.83h0l0,0h0l2.44,1.42h.05a1,1,0,0,0,.9-.11l59-34.06a2.91,2.91,0,0,0,1.32-2.28Z",
    style: {
      fill: "#FECE2F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.11,56.64l-.36.21a15.19,15.19,0,0,0,.15-2.11c0-5.69-3.46-8.31-7.73-5.84A14.9,14.9,0,0,0,421,54.5c-.19-6.86-4.48-10-9.75-6.9s-9.77,11.47-9.77,18.66a14.85,14.85,0,0,0,.18,2.38L401,69c-3.44,2-6.22,7.3-6.22,11.87h0c0,4.58,2.78,6.78,6.22,4.8l9-5.22h0l24.08-13.9c2.06-1.18,3.72-4.37,3.72-7.12h0C437.83,56.72,436.17,55.45,434.11,56.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.13,64.24a.82.82,0,0,0,.31.07.73.73,0,0,0,.64-.41l2-4.3v7.62a.72.72,0,0,0,1.43,0V58.09l2.18,2.1a.71.71,0,0,0,1-1l-3.39-3.26a.7.7,0,0,0-.62-.19.71.71,0,0,0-.52.4l-3.39,7.18A.71.71,0,0,0,412.13,64.24Z",
    style: {
      fill: "#FECE2F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.7,62a.71.71,0,0,0-.72.71V67l-8.31,4.8V68.33a.72.72,0,0,0-1.43,0v4.73a.72.72,0,0,0,.36.62.74.74,0,0,0,.36.09.73.73,0,0,0,.35-.09l9.74-5.62a.73.73,0,0,0,.36-.62V62.71A.71.71,0,0,0,420.7,62Z",
    style: {
      fill: "#FECE2F"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M403.66,36.68a1.19,1.19,0,0,0-1.18.06l-16.16,9.33a2.81,2.81,0,0,0-.92,1l-2.47-1.43a2.75,2.75,0,0,1,.93-1L400,35.31a1.18,1.18,0,0,1,1.2,0h0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M446.18,20.41a1,1,0,0,0-.86.13l-38,21.94a1.15,1.15,0,0,1-1.76-.7l-.29-1,37.61-21.69a1.11,1.11,0,0,1,.58-.18.74.74,0,0,1,.34.08h0Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M385.2,102.9a.53.53,0,0,0,.12.14l-2.38-1.37h0l0,0a.67.67,0,0,1-.22-.25.47.47,0,0,1-.06-.15,1.18,1.18,0,0,1-.07-.43V46.92a.81.81,0,0,1,0-.16c0-.11,0-.22.05-.33s0-.11,0-.16a3,3,0,0,1,.2-.49,1.19,1.19,0,0,1,.08-.16l2.47,1.43a2.64,2.64,0,0,0-.39,1.29v53.9a1.79,1.79,0,0,0,0,.23.79.79,0,0,0,0,.13s0,0,0,.06a.36.36,0,0,1,0,.09A.6.6,0,0,0,385.2,102.9Z",
    style: {
      opacity: 0.35000000000000003
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Cursor--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--cursor--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-2",
    d: "M31.28,244.78l.12-53c0-1.1.52-1.37,1.16-.6l21.88,26.22c.64.76.16,1.84-1.07,2.4l-6.14,2.77a2.66,2.66,0,0,0-1.73,2.81l4.14,14.76a4.58,4.58,0,0,1-1.11,3.65l-3,3.48c-.89,1-1.83,1-2.11,0l-4.14-14.77c-.28-1-.93-.87-1.46.27l-5.55,11.86C31.71,245.84,31.28,245.88,31.28,244.78Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.41,223.17,42.53,197a1.7,1.7,0,0,0-.39-.35l-5.25-3c-.45-.26-.77.08-.78.94l-.11,53c0,.45.07.71.19.78l5.25,3c.18.1.46-.18.77-.85l3.76-8,2.14,7.64a1,1,0,0,0,.42.62c.42.27,5.07,2.93,5.26,3,.43.24,1.07,0,1.68-.69l3-3.48a4.57,4.57,0,0,0,1.11-3.64l-4.14-14.77a2.67,2.67,0,0,1,1.73-2.81l6.14-2.77C64.57,225,65.05,223.94,64.41,223.17Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.25,250.52l.12-53c0-1.1.52-1.36,1.16-.6l21.88,26.22c.64.77.16,1.84-1.07,2.4l-6.14,2.77a2.67,2.67,0,0,0-1.73,2.81l4.14,14.77a4.57,4.57,0,0,1-1.11,3.64l-3,3.48c-.89,1-1.83,1-2.11.05l-4.14-14.77c-.28-1-.93-.87-1.46.27l-5.55,11.86C41.68,251.58,41.25,251.62,41.25,250.52Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.71,199.28,63.31,224a1.35,1.35,0,0,1-.53.39l-6.14,2.77a4,4,0,0,0-2.47,4.4l4.13,14.77a3.28,3.28,0,0,1-.82,2.39l-3,3.44-4-14.15a2,2,0,0,0-1.86-1.66c-.61,0-1.46.3-2.13,1.72l-3.92,8.38.1-47.12m-.84-2.77c-.3,0-.5.36-.5,1l-.12,53c0,.54.1.8.27.8s.42-.29.69-.87l5.55-11.86c.29-.62.61-.94.9-.94s.44.22.56.67l4.14,14.77c.14.49.43.73.81.73a1.9,1.9,0,0,0,1.3-.78l3-3.48a4.57,4.57,0,0,0,1.11-3.64l-4.14-14.77a2.67,2.67,0,0,1,1.73-2.81l6.14-2.77c1.23-.56,1.71-1.63,1.07-2.4L42.53,197a1,1,0,0,0-.66-.44Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.71,253.67c-.67-.38-4.78-2.74-5.19-3a1,1,0,0,1-.41-.62L46,242.42l1.79-3.83c.53-1.14,1.19-1.26,1.47-.27l4.13,14.77A1.07,1.07,0,0,0,53.71,253.67Z",
    style: {
      fill: "#263238"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Gears--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--gears--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-2",
    d: "M421.49,455a4.77,4.77,0,0,1-4.61-3.82L416.1,447a52.58,52.58,0,0,1-5.23-1.3l-8,3.7a5.45,5.45,0,0,1-2.26.48,5.5,5.5,0,0,1-2.73-.71l-8.18-4.72a4.06,4.06,0,0,1-.35-6.91l4.29-3.08c-.2-.3-.4-.59-.58-.9l-10-.63a4.55,4.55,0,0,1-4.26-4.53v-6.08a4.55,4.55,0,0,1,4.27-4.54l10-.63c.18-.3.38-.6.58-.9l-4.29-3.08a4.06,4.06,0,0,1,.35-6.91l8.18-4.72a5.48,5.48,0,0,1,2.73-.7,5.41,5.41,0,0,1,2.26.47l8,3.7c1.68-.51,3.43-.94,5.23-1.3l.78-4.11a4.77,4.77,0,0,1,4.61-3.81h12a4.76,4.76,0,0,1,4.61,3.82l.78,4.1c1.8.36,3.55.79,5.23,1.3l8-3.7a5.41,5.41,0,0,1,2.26-.47,5.48,5.48,0,0,1,2.73.7l8.18,4.72a4.06,4.06,0,0,1,.35,6.91l-4.29,3.08c.2.3.4.6.58.9l10,.63a4.55,4.55,0,0,1,4.26,4.54v6.08a4.55,4.55,0,0,1-4.26,4.53l-10,.63c-.18.31-.38.6-.58.9l4.29,3.08a4.06,4.06,0,0,1-.35,6.91l-8.18,4.72a5.5,5.5,0,0,1-2.73.71h0a5.45,5.45,0,0,1-2.26-.48l-8-3.7a51.9,51.9,0,0,1-5.23,1.3l-.78,4.11a4.77,4.77,0,0,1-4.61,3.82Zm6-37.4a24.92,24.92,0,0,0-12.09,2.85c-2.54,1.46-4,3.28-4,5s1.46,3.51,4,5a27.13,27.13,0,0,0,24.17,0c2.54-1.47,4-3.28,4-5s-1.45-3.52-4-5A25,25,0,0,0,427.51,417.56Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.57,402.19l-8.18-4.72a2.2,2.2,0,0,0-1.81-.08l-8.29,3.84a3,3,0,0,1-1.89.11,50.83,50.83,0,0,0-6.44-1.53,1.58,1.58,0,0,1-1.2-1.16l-1-5.46a1.29,1.29,0,0,0-1.21-1h-12a1.3,1.3,0,0,0-1.21,1l-1,5.46a1.55,1.55,0,0,1-1.19,1.16,50.83,50.83,0,0,0-6.44,1.53,3,3,0,0,1-1.89-.11l-8.29-3.84a2.2,2.2,0,0,0-1.81.08l-8.18,4.72a.67.67,0,0,0-.38.56h0v7.09h0a.69.69,0,0,0,.32.55l3.76,2.71a1.8,1.8,0,0,1-.92.38l-10.9.69a1.11,1.11,0,0,0-1,1.09v4.63h0l0,8.52a1.11,1.11,0,0,0,1,1.09l10.9.69a1.78,1.78,0,0,1,.94.4l-3.74,2.69a.67.67,0,0,0-.32.54h0v7.09h0a.67.67,0,0,0,.38.56l8.18,4.72a2.2,2.2,0,0,0,1.81.08l8.29-3.84a3.06,3.06,0,0,1,1.89-.12,47.61,47.61,0,0,0,6.44,1.53,1.61,1.61,0,0,1,1.2,1.17l1,5.46a1.28,1.28,0,0,0,1.21,1h12a1.28,1.28,0,0,0,1.21-1l1-5.46a1.55,1.55,0,0,1,1.19-1.16,51.24,51.24,0,0,0,6.44-1.53,3,3,0,0,1,1.89.11l8.29,3.84a2.2,2.2,0,0,0,1.81-.08l8.18-4.72a.66.66,0,0,0,.38-.55h0l0-7.11h0a.67.67,0,0,0-.32-.54l-3.76-2.71a1.8,1.8,0,0,1,.92-.38l10.9-.69a1.11,1.11,0,0,0,1-1.09V415.26a1.11,1.11,0,0,0-1-1.09l-10.9-.69a1.78,1.78,0,0,1-.94-.4l3.74-2.69a.67.67,0,0,0,.32-.54h0l0-7.1h0A.67.67,0,0,0,463.57,402.19Zm-55.2,18.37c.58-2,2.33-3.88,5.32-5.6,7.63-4.4,20-4.4,27.63,0,2.8,1.62,4.62,3.39,5.45,5.21-.65,2.24-2.47,4.38-5.45,6.1-7.63,4.41-20,4.41-27.63,0A11.3,11.3,0,0,1,408.37,420.56Z",
    style: {
      fill: "#FECE2F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.57,402.19l-8.18-4.72a2.2,2.2,0,0,0-1.81-.08l-8.29,3.84a3,3,0,0,1-1.89.11,50.83,50.83,0,0,0-6.44-1.53,1.58,1.58,0,0,1-1.2-1.16l-1-5.46a1.29,1.29,0,0,0-1.21-1h-12a1.3,1.3,0,0,0-1.21,1l-1,5.46a1.55,1.55,0,0,1-1.19,1.16,50.83,50.83,0,0,0-6.44,1.53,3,3,0,0,1-1.89-.11l-8.29-3.84a2.2,2.2,0,0,0-1.81.08l-8.18,4.72a.67.67,0,0,0-.38.56h0v7.09h0a.69.69,0,0,0,.32.55l3.76,2.71a1.8,1.8,0,0,1-.92.38l-10.9.69a1.11,1.11,0,0,0-1,1.09v4.63h0l0,8.52a1.11,1.11,0,0,0,1,1.09l10.9.69a1.78,1.78,0,0,1,.94.4l-3.74,2.69a.67.67,0,0,0-.32.54h0v7.09h0a.67.67,0,0,0,.38.56l8.18,4.72a2.2,2.2,0,0,0,1.81.08l8.29-3.84a3.06,3.06,0,0,1,1.89-.12,47.61,47.61,0,0,0,6.44,1.53,1.61,1.61,0,0,1,1.2,1.17l1,5.46a1.28,1.28,0,0,0,1.21,1h12a1.28,1.28,0,0,0,1.21-1l1-5.46a1.55,1.55,0,0,1,1.19-1.16,51.24,51.24,0,0,0,6.44-1.53,3,3,0,0,1,1.89.11l8.29,3.84a2.2,2.2,0,0,0,1.81-.08l8.18-4.72a.66.66,0,0,0,.38-.55h0l0-7.11h0a.67.67,0,0,0-.32-.54l-3.76-2.71a1.8,1.8,0,0,1,.92-.38l10.9-.69a1.11,1.11,0,0,0,1-1.09V415.26a1.11,1.11,0,0,0-1-1.09l-10.9-.69a1.78,1.78,0,0,1-.94-.4l3.74-2.69a.67.67,0,0,0,.32-.54h0l0-7.1h0A.67.67,0,0,0,463.57,402.19Zm-55.2,18.37c.58-2,2.33-3.88,5.32-5.6,7.63-4.4,20-4.4,27.63,0,2.8,1.62,4.62,3.39,5.45,5.21-.65,2.24-2.47,4.38-5.45,6.1-7.63,4.41-20,4.41-27.63,0A11.3,11.3,0,0,1,408.37,420.56Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.67,424.09a2,2,0,0,0-1.48-1l-10.89-.69a1.1,1.1,0,0,1-1-1.08V419.9l0,8.52a1.11,1.11,0,0,0,1,1.09l10.9.69a1.86,1.86,0,0,1,1,.39l2.72-2a.86.86,0,0,0,.12-1.33A17.13,17.13,0,0,1,395.67,424.09ZM391,409.84h0a.66.66,0,0,0,.32.55l3.77,2.71a1.87,1.87,0,0,0,.53-.6,16.87,16.87,0,0,1,2.32-3.21.86.86,0,0,0-.12-1.33l-6.48-4.66a.78.78,0,0,1-.33-.48Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.32,410.32c-7.63-4.4-20-4.41-27.63,0-4.82,2.78-6.6,6.66-5.33,10.25.58-2,2.34-3.88,5.33-5.61,7.63-4.41,20-4.4,27.63,0,2.79,1.62,4.62,3.39,5.45,5.21C447.78,416.7,446,413,441.32,410.32Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.72,421.48a1.13,1.13,0,0,1-1,.94l-10.89.69a1.42,1.42,0,0,0-.55.15v7.09a1.51,1.51,0,0,1,.53-.15l10.9-.69a1.11,1.11,0,0,0,1-1.08ZM464,402.75h0a.43.43,0,0,1,0,.22.52.52,0,0,1-.13.21.93.93,0,0,1-.15.13L457.15,408a.73.73,0,0,0-.16.14.8.8,0,0,0-.2.4.67.67,0,0,0,0,.28.5.5,0,0,0,0,.13,1,1,0,0,0,.22.38l.12.14a16.41,16.41,0,0,1,2.19,3.07,2,2,0,0,0,.52.58l3.75-2.69a.7.7,0,0,0,.32-.54h0Zm0,31.15a.7.7,0,0,1-.38.5l-8.18,4.72a2.2,2.2,0,0,1-1.27.22v7.08a2.15,2.15,0,0,0,1.27-.21l8.17-4.72a.66.66,0,0,0,.38-.54Zm-53.42,1.26a2.53,2.53,0,0,0-.82.2l-8.28,3.84a1.91,1.91,0,0,1-.74.16l0,7.07a2,2,0,0,0,.74-.14l8.29-3.84a2.24,2.24,0,0,1,.81-.19Zm24,8.7a1.25,1.25,0,0,1-1,.54h-12a1.19,1.19,0,0,1-.73-.27v7.09a1.28,1.28,0,0,0,.72.27h12a1.34,1.34,0,0,0,1.06-.61Z",
    style: {
      fill: "#FECE2F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.72,421.48a1.13,1.13,0,0,1-1,.94l-10.89.69a1.42,1.42,0,0,0-.55.15v7.09a1.51,1.51,0,0,1,.53-.15l10.9-.69a1.11,1.11,0,0,0,1-1.08ZM464,402.75h0a.43.43,0,0,1,0,.22.52.52,0,0,1-.13.21.93.93,0,0,1-.15.13L457.15,408a.73.73,0,0,0-.16.14.8.8,0,0,0-.2.4.67.67,0,0,0,0,.28.5.5,0,0,0,0,.13,1,1,0,0,0,.22.38l.12.14a16.41,16.41,0,0,1,2.19,3.07,2,2,0,0,0,.52.58l3.75-2.69a.7.7,0,0,0,.32-.54h0Zm0,31.15a.7.7,0,0,1-.38.5l-8.18,4.72a2.2,2.2,0,0,1-1.27.22v7.08a2.15,2.15,0,0,0,1.27-.21l8.17-4.72a.66.66,0,0,0,.38-.54Zm-53.42,1.26a2.53,2.53,0,0,0-.82.2l-8.28,3.84a1.91,1.91,0,0,1-.74.16l0,7.07a2,2,0,0,0,.74-.14l8.29-3.84a2.24,2.24,0,0,1,.81-.19Zm24,8.7a1.25,1.25,0,0,1-1,.54h-12a1.19,1.19,0,0,1-.73-.27v7.09a1.28,1.28,0,0,0,.72.27h12a1.34,1.34,0,0,0,1.06-.61Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.58,397.39l-8.29,3.84a3,3,0,0,1-1.89.11,50.83,50.83,0,0,0-6.44-1.53,1.58,1.58,0,0,1-1.2-1.16l-1-5.46a1.29,1.29,0,0,0-1.21-1h-12a1.28,1.28,0,0,0-1.21,1l-1,5.46a1.55,1.55,0,0,1-1.19,1.16,50.83,50.83,0,0,0-6.44,1.53,3,3,0,0,1-1.89-.11l-8.29-3.84a2.2,2.2,0,0,0-1.81.08l-8.18,4.72a.61.61,0,0,0-.06,1.11l6.48,4.66a.86.86,0,0,1,.12,1.33,16.81,16.81,0,0,0-2.31,3.21,2,2,0,0,1-1.47,1l-10.9.69a1.11,1.11,0,0,0-1,1.09v6.08a1.11,1.11,0,0,0,1,1.08l10.9.69a2,2,0,0,1,1.47,1A16.81,16.81,0,0,0,398,427.3a.86.86,0,0,1-.12,1.33l-6.48,4.66a.61.61,0,0,0,.06,1.11l8.18,4.72a2.2,2.2,0,0,0,1.81.08l8.28-3.84a3,3,0,0,1,1.9-.11,50.83,50.83,0,0,0,6.44,1.53,1.55,1.55,0,0,1,1.19,1.16l1,5.46a1.29,1.29,0,0,0,1.21,1h12a1.29,1.29,0,0,0,1.21-1l1-5.46a1.58,1.58,0,0,1,1.2-1.16,51.24,51.24,0,0,0,6.44-1.53,3,3,0,0,1,1.89.11l8.29,3.84a2.2,2.2,0,0,0,1.81-.08l8.18-4.72a.61.61,0,0,0,.06-1.11l-6.48-4.66a.86.86,0,0,1-.12-1.33,16.81,16.81,0,0,0,2.31-3.21,2,2,0,0,1,1.47-1l10.9-.69a1.11,1.11,0,0,0,1-1.09v-6.07a1.11,1.11,0,0,0-1-1.09l-10.9-.69a2,2,0,0,1-1.47-1,16.81,16.81,0,0,0-2.31-3.21.86.86,0,0,1,.12-1.33l6.48-4.66a.61.61,0,0,0-.06-1.11l-8.18-4.72A2.2,2.2,0,0,0,453.58,397.39Zm-12.26,12.93c7.63,4.4,7.63,11.55,0,15.95s-20,4.41-27.63,0-7.63-11.55,0-15.95S433.69,405.91,441.32,410.32Z",
    style: {
      fill: "#FECE2F"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.55
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M453.58,397.39l-8.29,3.84a3,3,0,0,1-1.89.11,50.83,50.83,0,0,0-6.44-1.53,1.58,1.58,0,0,1-1.2-1.16l-1-5.46a1.29,1.29,0,0,0-1.21-1h-12a1.28,1.28,0,0,0-1.21,1l-1,5.46a1.55,1.55,0,0,1-1.19,1.16,50.83,50.83,0,0,0-6.44,1.53,3,3,0,0,1-1.89-.11l-8.29-3.84a2.2,2.2,0,0,0-1.81.08l-8.18,4.72a.61.61,0,0,0-.06,1.11l6.48,4.66a.86.86,0,0,1,.12,1.33,16.81,16.81,0,0,0-2.31,3.21,2,2,0,0,1-1.47,1l-10.9.69a1.11,1.11,0,0,0-1,1.09v6.08a1.11,1.11,0,0,0,1,1.08l10.9.69a2,2,0,0,1,1.47,1A16.81,16.81,0,0,0,398,427.3a.86.86,0,0,1-.12,1.33l-6.48,4.66a.61.61,0,0,0,.06,1.11l8.18,4.72a2.2,2.2,0,0,0,1.81.08l8.28-3.84a3,3,0,0,1,1.9-.11,50.83,50.83,0,0,0,6.44,1.53,1.55,1.55,0,0,1,1.19,1.16l1,5.46a1.29,1.29,0,0,0,1.21,1h12a1.29,1.29,0,0,0,1.21-1l1-5.46a1.58,1.58,0,0,1,1.2-1.16,51.24,51.24,0,0,0,6.44-1.53,3,3,0,0,1,1.89.11l8.29,3.84a2.2,2.2,0,0,0,1.81-.08l8.18-4.72a.61.61,0,0,0,.06-1.11l-6.48-4.66a.86.86,0,0,1-.12-1.33,16.81,16.81,0,0,0,2.31-3.21,2,2,0,0,1,1.47-1l10.9-.69a1.11,1.11,0,0,0,1-1.09v-6.07a1.11,1.11,0,0,0-1-1.09l-10.9-.69a2,2,0,0,1-1.47-1,16.81,16.81,0,0,0-2.31-3.21.86.86,0,0,1,.12-1.33l6.48-4.66a.61.61,0,0,0-.06-1.11l-8.18-4.72A2.2,2.2,0,0,0,453.58,397.39Zm-12.26,12.93c7.63,4.4,7.63,11.55,0,15.95s-20,4.41-27.63,0-7.63-11.55,0-15.95S433.69,405.91,441.32,410.32Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.52,444.81h-12a1.68,1.68,0,0,1-1.6-1.33l-1-5.47a1.18,1.18,0,0,0-.87-.84,49.62,49.62,0,0,1-6.49-1.54,2.68,2.68,0,0,0-1.61.09l-8.29,3.84a2.61,2.61,0,0,1-2.17-.09l-8.18-4.73a1.06,1.06,0,0,1-.59-.86,1.12,1.12,0,0,1,.5-.92l6.48-4.66a.5.5,0,0,0,.21-.33.53.53,0,0,0-.15-.4,16.74,16.74,0,0,1-2.37-3.29,1.65,1.65,0,0,0-1.15-.77l-10.9-.69a1.5,1.5,0,0,1-1.39-1.49v-6.07a1.52,1.52,0,0,1,1.39-1.49l10.9-.69a1.65,1.65,0,0,0,1.15-.77,16.74,16.74,0,0,1,2.37-3.29.53.53,0,0,0,.15-.4.5.5,0,0,0-.21-.33l-6.48-4.67a1.09,1.09,0,0,1-.5-.91,1.06,1.06,0,0,1,.59-.86l8.18-4.73a2.61,2.61,0,0,1,2.17-.09l8.29,3.84a2.68,2.68,0,0,0,1.61.09,49.24,49.24,0,0,1,6.49-1.54,1.18,1.18,0,0,0,.87-.84l1-5.47a1.68,1.68,0,0,1,1.6-1.33h12a1.68,1.68,0,0,1,1.6,1.33l1,5.47a1.18,1.18,0,0,0,.87.84,49.24,49.24,0,0,1,6.49,1.54,2.68,2.68,0,0,0,1.61-.09l8.29-3.84a2.61,2.61,0,0,1,2.17.09l8.18,4.73a1.06,1.06,0,0,1,.59.86,1.09,1.09,0,0,1-.5.91l-6.48,4.67a.5.5,0,0,0-.21.33.53.53,0,0,0,.15.4,16.45,16.45,0,0,1,2.37,3.29,1.65,1.65,0,0,0,1.15.77l10.9.69a1.51,1.51,0,0,1,1.39,1.48v6.08a1.51,1.51,0,0,1-1.39,1.49l-10.9.69a1.65,1.65,0,0,0-1.15.77,16.34,16.34,0,0,1-2.37,3.29.53.53,0,0,0-.15.4.5.5,0,0,0,.21.33l6.48,4.66a1.08,1.08,0,0,1,.49.92,1,1,0,0,1-.58.86l-8.18,4.73a2.61,2.61,0,0,1-2.17.09l-8.29-3.84a2.68,2.68,0,0,0-1.61-.09,49.24,49.24,0,0,1-6.49,1.54,1.17,1.17,0,0,0-.87.85l-1,5.46A1.68,1.68,0,0,1,433.52,444.81Zm-22.67-10.07a3.07,3.07,0,0,1,.88.12,50,50,0,0,0,6.38,1.52,2,2,0,0,1,1.53,1.49l1,5.46a.87.87,0,0,0,.81.67h12a.87.87,0,0,0,.81-.67l1-5.46a2,2,0,0,1,1.52-1.49,49.32,49.32,0,0,0,6.39-1.52,3.45,3.45,0,0,1,2.18.13l8.29,3.84a1.76,1.76,0,0,0,1.44-.06l8.18-4.72c.11-.07.18-.14.18-.21s-.05-.15-.16-.22L456.91,429a1.27,1.27,0,0,1-.54-.9,1.32,1.32,0,0,1,.36-1A16.27,16.27,0,0,0,459,423.9a2.38,2.38,0,0,1,1.8-1.19l10.9-.69a.7.7,0,0,0,.64-.69v-6.08a.71.71,0,0,0-.65-.68l-10.89-.69a2.37,2.37,0,0,1-1.8-1.19,16.27,16.27,0,0,0-2.26-3.13,1.27,1.27,0,0,1-.35-1,1.22,1.22,0,0,1,.53-.9l6.48-4.67c.11-.07.17-.16.16-.22s-.07-.15-.18-.21l-8.18-4.72a1.81,1.81,0,0,0-1.44-.07l-8.29,3.84a3.39,3.39,0,0,1-2.18.14,49.56,49.56,0,0,0-6.38-1.52,2,2,0,0,1-1.53-1.48l-1-5.47a.87.87,0,0,0-.81-.67h-12a.87.87,0,0,0-.81.67l-1,5.47a2,2,0,0,1-1.53,1.48,49.56,49.56,0,0,0-6.38,1.52,3.46,3.46,0,0,1-2.18-.13l-8.29-3.85a1.81,1.81,0,0,0-1.44.07l-8.18,4.72c-.11.06-.18.14-.18.21s.05.15.16.22l6.48,4.67a1.27,1.27,0,0,1,.54.9,1.32,1.32,0,0,1-.36,1,16.27,16.27,0,0,0-2.26,3.13,2.38,2.38,0,0,1-1.8,1.19l-10.9.69a.7.7,0,0,0-.64.69v6.07a.71.71,0,0,0,.64.69l10.9.69a2.38,2.38,0,0,1,1.8,1.19,16.27,16.27,0,0,0,2.26,3.13,1.27,1.27,0,0,1,.35,1,1.22,1.22,0,0,1-.53.9l-6.48,4.67c-.11.07-.17.16-.16.22s.07.15.18.21l8.18,4.72a1.8,1.8,0,0,0,1.44.07l8.29-3.85A3.28,3.28,0,0,1,410.85,434.74ZM427.5,430a28.66,28.66,0,0,1-14-3.35c-3.82-2.21-5.92-5.16-5.92-8.32s2.1-6.12,5.92-8.33c7.73-4.46,20.3-4.46,28,0,3.82,2.21,5.92,5.16,5.92,8.33s-2.1,6.11-5.92,8.32A28.67,28.67,0,0,1,427.5,430Zm0-22.55a27.78,27.78,0,0,0-13.61,3.25c-3.56,2.05-5.52,4.76-5.52,7.63s2,5.57,5.52,7.62c7.51,4.34,19.72,4.34,27.23,0,3.56-2.05,5.52-4.76,5.52-7.62s-2-5.58-5.52-7.63A27.82,27.82,0,0,0,427.5,407.42Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-2",
    d: "M353.38,476.91l-.51,0-7.09-.75a4.69,4.69,0,0,1-4.18-5.23l.13-1.1c-.6-.22-1.18-.45-1.75-.7,0,0,0,0,0,0h-.08l-5.38,1.69a5.56,5.56,0,0,1-1.64.24,6,6,0,0,1-3.79-1.31l-3.62-3a4.21,4.21,0,0,1,.82-7.12l1.23-.62-3.33-.57a4.53,4.53,0,0,1-3.58-5.86l1-3.13a5.23,5.23,0,0,1,4.88-3.58l6,.24-.77-.83a4.25,4.25,0,0,1,1.54-7l5.68-2.27a5.62,5.62,0,0,1,2.11-.39,6.08,6.08,0,0,1,3.31.95L348,439h0c1.06-.19,2.15-.33,3.23-.43l1.1-2.13a5.45,5.45,0,0,1,4.76-2.88,4.36,4.36,0,0,1,.51,0l7.09.74a4.69,4.69,0,0,1,4.18,5.23l-.13,1.1c.6.22,1.19.45,1.75.7,0,0,0,0,0,0h.08l5.39-1.69a5.45,5.45,0,0,1,1.63-.24,6,6,0,0,1,3.79,1.31l3.62,3a4.21,4.21,0,0,1-.82,7.12l-1.23.62,3.33.56a4.52,4.52,0,0,1,3.58,5.86l-1,3.14a5.21,5.21,0,0,1-4.88,3.58l-6-.24.78.83a4.25,4.25,0,0,1-1.54,7l-5.68,2.27a5.62,5.62,0,0,1-2.11.39,6,6,0,0,1-3.3-.95l-3.69-2.44h0c-1.05.18-2.14.33-3.23.43l-1.1,2.13A5.46,5.46,0,0,1,353.38,476.91Zm1.88-26a17.49,17.49,0,0,0-6.43,1.15c-2.49,1-3.52,2.27-3.65,3.06s.68,1.56,1.16,2c1.9,1.58,5.33,2.56,8.94,2.56a17.49,17.49,0,0,0,6.43-1.14c2.49-1,3.52-2.27,3.65-3.06s-.68-1.56-1.16-2C362.3,451.86,358.87,450.87,355.26,450.87Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.24,437.54a1.56,1.56,0,0,1-1.06-1.6l.33-2.7a1.24,1.24,0,0,0-1.11-1.38l-7.09-.74a2,2,0,0,0-1.83,1l-1.42,2.75a2.46,2.46,0,0,1-1.83,1.2c-1.24.09-2.47.24-3.68.45a3.66,3.66,0,0,1-2.29-.45l-3.82-2.54a2.66,2.66,0,0,0-2.22-.23l-5.67,2.27a.85.85,0,0,0-.59.73h0v.06h0v5.8h0a.92.92,0,0,0,.28.64l.33.35a3.05,3.05,0,0,1-1.57.48l-6.48-.26a1.74,1.74,0,0,0-1.64,1.15l-1,3.14a1,1,0,0,0,0,.39h0v5.86h0a1.06,1.06,0,0,0,.91,1l5,.86-2,1a.82.82,0,0,0-.51.71h0v5.86h0a.89.89,0,0,0,.35.65l3.62,3a2.57,2.57,0,0,0,2.18.43l5.52-1.73a3.86,3.86,0,0,1,2.35.16,31.25,31.25,0,0,0,3,1.09,1.43,1.43,0,0,1,.72.51v3.95h0a1.24,1.24,0,0,0,1.11,1.22l7.09.74a2,2,0,0,0,1.83-1l1.41-2.76a2.52,2.52,0,0,1,1.84-1.2c1.24-.09,2.47-.24,3.68-.45a3.6,3.6,0,0,1,2.29.46l3.81,2.53a2.69,2.69,0,0,0,2.23.23l5.67-2.27a.83.83,0,0,0,.59-.76h0v-5.85h0a.92.92,0,0,0-.28-.63l-.33-.35a3,3,0,0,1,1.57-.49l6.48.26a1.73,1.73,0,0,0,1.64-1.15l1-3.14a1.1,1.1,0,0,0,.05-.35h0v-5.83h0a1.06,1.06,0,0,0-.9-1.09l-5-.86,2-1a.8.8,0,0,0,.51-.72h0v-5.82h0a.85.85,0,0,0-.35-.67l-3.63-3a2.54,2.54,0,0,0-2.17-.43l-5.52,1.73a3.86,3.86,0,0,1-2.35-.15A26.56,26.56,0,0,0,366.24,437.54ZM342.7,452.23a10.47,10.47,0,0,1,4.84-3.5c6.15-2.47,14.6-1.59,18.87,2a7.77,7.77,0,0,1,1.44,1.52,10.49,10.49,0,0,1-4.85,3.53c-6.15,2.46-14.6,1.58-18.87-2A7.6,7.6,0,0,1,342.7,452.23Z",
    style: {
      fill: "#FECE2F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.24,437.54a1.56,1.56,0,0,1-1.06-1.6l.33-2.7a1.24,1.24,0,0,0-1.11-1.38l-7.09-.74a2,2,0,0,0-1.83,1l-1.42,2.75a2.46,2.46,0,0,1-1.83,1.2c-1.24.09-2.47.24-3.68.45a3.66,3.66,0,0,1-2.29-.45l-3.82-2.54a2.66,2.66,0,0,0-2.22-.23l-5.67,2.27a.85.85,0,0,0-.59.73h0v.06h0v5.8h0a.92.92,0,0,0,.28.64l.33.35a3.05,3.05,0,0,1-1.57.48l-6.48-.26a1.74,1.74,0,0,0-1.64,1.15l-1,3.14a1,1,0,0,0,0,.39h0v5.86h0a1.06,1.06,0,0,0,.91,1l5,.86-2,1a.82.82,0,0,0-.51.71h0v5.86h0a.89.89,0,0,0,.35.65l3.62,3a2.57,2.57,0,0,0,2.18.43l5.52-1.73a3.86,3.86,0,0,1,2.35.16,31.25,31.25,0,0,0,3,1.09,1.43,1.43,0,0,1,.72.51v3.95h0a1.24,1.24,0,0,0,1.11,1.22l7.09.74a2,2,0,0,0,1.83-1l1.41-2.76a2.52,2.52,0,0,1,1.84-1.2c1.24-.09,2.47-.24,3.68-.45a3.6,3.6,0,0,1,2.29.46l3.81,2.53a2.69,2.69,0,0,0,2.23.23l5.67-2.27a.83.83,0,0,0,.59-.76h0v-5.85h0a.92.92,0,0,0-.28-.63l-.33-.35a3,3,0,0,1,1.57-.49l6.48.26a1.73,1.73,0,0,0,1.64-1.15l1-3.14a1.1,1.1,0,0,0,.05-.35h0v-5.83h0a1.06,1.06,0,0,0-.9-1.09l-5-.86,2-1a.8.8,0,0,0,.51-.72h0v-5.82h0a.85.85,0,0,0-.35-.67l-3.63-3a2.54,2.54,0,0,0-2.17-.43l-5.52,1.73a3.86,3.86,0,0,1-2.35-.15A26.56,26.56,0,0,0,366.24,437.54ZM342.7,452.23a10.47,10.47,0,0,1,4.84-3.5c6.15-2.47,14.6-1.59,18.87,2a7.77,7.77,0,0,1,1.44,1.52,10.49,10.49,0,0,1-4.85,3.53c-6.15,2.46-14.6,1.58-18.87-2A7.6,7.6,0,0,1,342.7,452.23Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.44,451.57a2.15,2.15,0,0,0-1.5-1.44l-6.18-1.05a1.06,1.06,0,0,1-.91-1v5.78a1.06,1.06,0,0,0,.91,1l5,.86,2.6-1.31a1.22,1.22,0,0,0,.52-1.67A7.93,7.93,0,0,1,332.44,451.57Zm1.51-9.42h0a1,1,0,0,0,.27.64l.34.35a2.48,2.48,0,0,0,.53-.41,12.38,12.38,0,0,1,1.56-1.38,1.11,1.11,0,0,0,.15-1.67L334.24,437a.87.87,0,0,1-.28-.63Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.54,442.89c-5.3,2.12-7.18,6-4.84,9.35a10.48,10.48,0,0,1,4.84-3.51c6.15-2.47,14.6-1.59,18.87,2a8.08,8.08,0,0,1,1.44,1.52c1.64-2.35,1.26-5.12-1.43-7.37C362.14,441.3,353.7,440.42,347.54,442.89Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.07,463.09a2.08,2.08,0,0,0-.59.68l-1.42,2.75a2,2,0,0,1-1,.88v5.84a1.9,1.9,0,0,0,1.05-.87l1.42-2.76a2.09,2.09,0,0,1,.6-.67Zm19.52-.78h0a.84.84,0,0,1-.59.76l-5.67,2.27a2.58,2.58,0,0,1-1.49.06v5.84a2.66,2.66,0,0,0,1.49-.06l5.68-2.27a.81.81,0,0,0,.58-.76Zm-37.67-2.45-5.45,1.72a2.47,2.47,0,0,1-1.37,0v5.83a2.51,2.51,0,0,0,1.38,0l5.46-1.71Zm47.78-9.23a2.21,2.21,0,0,1-.06.34l-1,3.14a1.72,1.72,0,0,1-1.63,1.15l-6.49-.26a2.54,2.54,0,0,0-1,.21v5.84a2.59,2.59,0,0,1,1-.21l6.48.26a1.74,1.74,0,0,0,1.64-1.15l1-3.14a1.1,1.1,0,0,0,.05-.35Zm-3.46-9.46a1.94,1.94,0,0,1-.05.2.64.64,0,0,1-.2.3,1.13,1.13,0,0,1-.29.2l-4.55,2.29a.81.81,0,0,0-.27.19,1.14,1.14,0,0,0-.31.48,1.12,1.12,0,0,0-.07.45,2,2,0,0,0,0,.24,2.81,2.81,0,0,0,.1.31,8.73,8.73,0,0,1,.47,1.22,2.14,2.14,0,0,0,1.51,1.46l1.14.18,2-1a.84.84,0,0,0,.51-.73h0Z",
    style: {
      fill: "#FECE2F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.07,463.09a2.08,2.08,0,0,0-.59.68l-1.42,2.75a2,2,0,0,1-1,.88v5.84a1.9,1.9,0,0,0,1.05-.87l1.42-2.76a2.09,2.09,0,0,1,.6-.67Zm19.52-.78h0a.84.84,0,0,1-.59.76l-5.67,2.27a2.58,2.58,0,0,1-1.49.06v5.84a2.66,2.66,0,0,0,1.49-.06l5.68-2.27a.81.81,0,0,0,.58-.76Zm-37.67-2.45-5.45,1.72a2.47,2.47,0,0,1-1.37,0v5.83a2.51,2.51,0,0,0,1.38,0l5.46-1.71Zm47.78-9.23a2.21,2.21,0,0,1-.06.34l-1,3.14a1.72,1.72,0,0,1-1.63,1.15l-6.49-.26a2.54,2.54,0,0,0-1,.21v5.84a2.59,2.59,0,0,1,1-.21l6.48.26a1.74,1.74,0,0,0,1.64-1.15l1-3.14a1.1,1.1,0,0,0,.05-.35Zm-3.46-9.46a1.94,1.94,0,0,1-.05.2.64.64,0,0,1-.2.3,1.13,1.13,0,0,1-.29.2l-4.55,2.29a.81.81,0,0,0-.27.19,1.14,1.14,0,0,0-.31.48,1.12,1.12,0,0,0-.07.45,2,2,0,0,0,0,.24,2.81,2.81,0,0,0,.1.31,8.73,8.73,0,0,1,.47,1.22,2.14,2.14,0,0,0,1.51,1.46l1.14.18,2-1a.84.84,0,0,0,.51-.73h0Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.07,437.05l-5.52,1.73a3.86,3.86,0,0,1-2.35-.15,26.56,26.56,0,0,0-3-1.09,1.56,1.56,0,0,1-1.06-1.6l.33-2.7a1.24,1.24,0,0,0-1.11-1.38l-7.09-.74a2,2,0,0,0-1.83,1l-1.42,2.75a2.46,2.46,0,0,1-1.83,1.2c-1.24.09-2.47.24-3.68.45a3.66,3.66,0,0,1-2.29-.45l-3.82-2.54a2.66,2.66,0,0,0-2.22-.23l-5.67,2.27a.8.8,0,0,0-.31,1.39l2.57,2.74a1.1,1.1,0,0,1-.15,1.66,15.24,15.24,0,0,0-1.56,1.39,3.13,3.13,0,0,1-2.1.89l-6.48-.26a1.74,1.74,0,0,0-1.64,1.15l-1,3.14a1.08,1.08,0,0,0,.86,1.42l6.17,1.05a2.12,2.12,0,0,1,1.51,1.45,9.51,9.51,0,0,0,.46,1.22,1.23,1.23,0,0,1-.52,1.68l-4.55,2.28a.76.76,0,0,0-.16,1.37l3.63,3a2.55,2.55,0,0,0,2.17.43l5.52-1.73a3.93,3.93,0,0,1,2.35.15,26.56,26.56,0,0,0,3,1.09,1.56,1.56,0,0,1,1.06,1.61l-.33,2.69a1.24,1.24,0,0,0,1.11,1.38l7.09.74a2,2,0,0,0,1.83-1l1.42-2.75a2.49,2.49,0,0,1,1.83-1.2c1.24-.09,2.47-.24,3.68-.45a3.6,3.6,0,0,1,2.29.46l3.82,2.53a2.66,2.66,0,0,0,2.22.23l5.68-2.27a.8.8,0,0,0,.3-1.39l-2.57-2.74a1.09,1.09,0,0,1,.16-1.66,16.23,16.23,0,0,0,1.55-1.39,3.13,3.13,0,0,1,2.1-.89l6.48.26a1.74,1.74,0,0,0,1.64-1.15l1-3.14a1.08,1.08,0,0,0-.86-1.42l-6.17-1.05a2.12,2.12,0,0,1-1.51-1.45,9.51,9.51,0,0,0-.46-1.22,1.24,1.24,0,0,1,.52-1.68l4.55-2.28a.76.76,0,0,0,.16-1.37l-3.63-3A2.54,2.54,0,0,0,377.07,437.05Zm-10.66,7.8c4.27,3.56,2.74,8.43-3.41,10.9s-14.6,1.58-18.87-2-2.74-8.43,3.41-10.9S362.14,441.3,366.41,444.85Z",
    style: {
      fill: "#FECE2F"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.55
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M377.07,437.05l-5.52,1.73a3.86,3.86,0,0,1-2.35-.15,26.56,26.56,0,0,0-3-1.09,1.56,1.56,0,0,1-1.06-1.6l.33-2.7a1.24,1.24,0,0,0-1.11-1.38l-7.09-.74a2,2,0,0,0-1.83,1l-1.42,2.75a2.46,2.46,0,0,1-1.83,1.2c-1.24.09-2.47.24-3.68.45a3.66,3.66,0,0,1-2.29-.45l-3.82-2.54a2.66,2.66,0,0,0-2.22-.23l-5.67,2.27a.8.8,0,0,0-.31,1.39l2.57,2.74a1.1,1.1,0,0,1-.15,1.66,15.24,15.24,0,0,0-1.56,1.39,3.13,3.13,0,0,1-2.1.89l-6.48-.26a1.74,1.74,0,0,0-1.64,1.15l-1,3.14a1.08,1.08,0,0,0,.86,1.42l6.17,1.05a2.12,2.12,0,0,1,1.51,1.45,9.51,9.51,0,0,0,.46,1.22,1.23,1.23,0,0,1-.52,1.68l-4.55,2.28a.76.76,0,0,0-.16,1.37l3.63,3a2.55,2.55,0,0,0,2.17.43l5.52-1.73a3.93,3.93,0,0,1,2.35.15,26.56,26.56,0,0,0,3,1.09,1.56,1.56,0,0,1,1.06,1.61l-.33,2.69a1.24,1.24,0,0,0,1.11,1.38l7.09.74a2,2,0,0,0,1.83-1l1.42-2.75a2.49,2.49,0,0,1,1.83-1.2c1.24-.09,2.47-.24,3.68-.45a3.6,3.6,0,0,1,2.29.46l3.82,2.53a2.66,2.66,0,0,0,2.22.23l5.68-2.27a.8.8,0,0,0,.3-1.39l-2.57-2.74a1.09,1.09,0,0,1,.16-1.66,16.23,16.23,0,0,0,1.55-1.39,3.13,3.13,0,0,1,2.1-.89l6.48.26a1.74,1.74,0,0,0,1.64-1.15l1-3.14a1.08,1.08,0,0,0-.86-1.42l-6.17-1.05a2.12,2.12,0,0,1-1.51-1.45,9.51,9.51,0,0,0-.46-1.22,1.24,1.24,0,0,1,.52-1.68l4.55-2.28a.76.76,0,0,0,.16-1.37l-3.63-3A2.54,2.54,0,0,0,377.07,437.05Zm-10.66,7.8c4.27,3.56,2.74,8.43-3.41,10.9s-14.6,1.58-18.87-2-2.74-8.43,3.41-10.9S362.14,441.3,366.41,444.85Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.38,468h-.2l-7.09-.74a1.72,1.72,0,0,1-1.18-.65,1.67,1.67,0,0,1-.37-1.29l.33-2.69a1.06,1.06,0,0,0-.72-1.07,31.3,31.3,0,0,1-3-1.11,3.44,3.44,0,0,0-2-.14l-5.52,1.73a3.08,3.08,0,0,1-2.64-.52l-3.62-3a1.38,1.38,0,0,1-.54-1.18,1.34,1.34,0,0,1,.79-1l4.55-2.29a.75.75,0,0,0,.3-1,8.81,8.81,0,0,1-.5-1.29,1.61,1.61,0,0,0-1.11-1.1l-6.17-1.06a1.57,1.57,0,0,1-1.26-2.05l1-3.14a2.24,2.24,0,0,1,2.13-1.5l6.48.26a2.62,2.62,0,0,0,1.73-.74,17.26,17.26,0,0,1,1.6-1.43.67.67,0,0,0,.28-.47.62.62,0,0,0-.18-.46l-2.57-2.74a1.35,1.35,0,0,1-.39-1.23,1.38,1.38,0,0,1,.87-1l5.68-2.27a3.16,3.16,0,0,1,2.68.28l3.82,2.53a3.12,3.12,0,0,0,1.93.39,37.42,37.42,0,0,1,3.72-.47,2,2,0,0,0,1.43-.93l1.42-2.75a2.49,2.49,0,0,1,2.32-1.26l7.09.74a1.72,1.72,0,0,1,1.18.65,1.67,1.67,0,0,1,.37,1.29l-.33,2.69a1.06,1.06,0,0,0,.72,1.07,30.34,30.34,0,0,1,3,1.11,3.44,3.44,0,0,0,2,.14l5.52-1.73a3.08,3.08,0,0,1,2.64.52l3.63,3a1.25,1.25,0,0,1-.26,2.19l-4.55,2.29a.75.75,0,0,0-.3,1,9.27,9.27,0,0,1,.5,1.29,1.61,1.61,0,0,0,1.11,1.1l6.17,1.06a1.58,1.58,0,0,1,1.11.73,1.6,1.6,0,0,1,.15,1.32l-1,3.14a2.22,2.22,0,0,1-2.13,1.5l-6.48-.26a2.67,2.67,0,0,0-1.73.74,14.79,14.79,0,0,1-1.6,1.43.73.73,0,0,0-.28.47.6.6,0,0,0,.18.46l2.57,2.74a1.32,1.32,0,0,1,.39,1.23,1.38,1.38,0,0,1-.87,1l-5.68,2.27a3.16,3.16,0,0,1-2.68-.28L364,463a3,3,0,0,0-1.93-.38c-1.21.21-2.46.36-3.72.46a2,2,0,0,0-1.43.93l-1.42,2.75A2.5,2.5,0,0,1,353.38,468Zm-13.5-8.78a4.23,4.23,0,0,1,1.66.31,28.36,28.36,0,0,0,2.91,1.07,2,2,0,0,1,1.4,2.14l-.32,2.69a.72.72,0,0,0,.15.55.75.75,0,0,0,.51.28l7.09.74a1.5,1.5,0,0,0,1.34-.72l1.42-2.76a3,3,0,0,1,2.23-1.46c1.23-.1,2.45-.25,3.63-.45a4.06,4.06,0,0,1,2.65.53l3.82,2.54a2.21,2.21,0,0,0,1.76.18l5.68-2.27a.5.5,0,0,0,.28-.25.43.43,0,0,0-.15-.34l-2.57-2.74a1.6,1.6,0,0,1-.45-1.21,1.66,1.66,0,0,1,.66-1.18,16.39,16.39,0,0,0,1.5-1.34,3.57,3.57,0,0,1,2.48-1.05l6.48.27a1.23,1.23,0,0,0,1.15-.81l1-3.14a.58.58,0,0,0-.05-.5.62.62,0,0,0-.43-.28L379.52,449a2.61,2.61,0,0,1-1.9-1.8,8,8,0,0,0-.43-1.15,1.73,1.73,0,0,1,.74-2.33l4.56-2.28c.14-.08.23-.17.24-.25a.39.39,0,0,0-.18-.3l-3.62-3a2.13,2.13,0,0,0-1.71-.34l-5.52,1.73a4.33,4.33,0,0,1-2.7-.17,30.71,30.71,0,0,0-2.9-1.07,2,2,0,0,1-1.41-2.13l.32-2.7a.72.72,0,0,0-.15-.55.75.75,0,0,0-.51-.28l-7.09-.74a1.52,1.52,0,0,0-1.34.72l-1.41,2.76a2.94,2.94,0,0,1-2.25,1.46c-1.22.1-2.44.25-3.62.45a4.06,4.06,0,0,1-2.65-.53l-3.82-2.54a2.25,2.25,0,0,0-1.76-.18L334.73,436c-.15.07-.25.16-.27.25a.39.39,0,0,0,.14.34l2.57,2.74a1.6,1.6,0,0,1,.45,1.21,1.66,1.66,0,0,1-.66,1.18,15.16,15.16,0,0,0-1.5,1.34,3.66,3.66,0,0,1-2.48,1.05l-6.48-.27a1.3,1.3,0,0,0-1.15.81l-1,3.14a.58.58,0,0,0,.05.5.62.62,0,0,0,.43.28l6.17,1.05a2.63,2.63,0,0,1,1.9,1.8,8,8,0,0,0,.43,1.15,1.73,1.73,0,0,1-.74,2.33l-4.56,2.28c-.14.08-.23.17-.24.25a.39.39,0,0,0,.18.3l3.62,3a2.13,2.13,0,0,0,1.71.34l5.52-1.73A3.36,3.36,0,0,1,339.88,459.24Zm15.43-1.61c-4.42,0-8.78-1.21-11.5-3.47-1.95-1.63-2.85-3.62-2.53-5.63.39-2.49,2.61-4.72,6.08-6.11,6.29-2.52,15-1.6,19.37,2.05,1.95,1.63,2.85,3.63,2.53,5.63-.39,2.49-2.61,4.72-6.08,6.11A21.47,21.47,0,0,1,355.31,457.63Zm0-15.65a20.55,20.55,0,0,0-7.54,1.36c-3.14,1.26-5.14,3.21-5.47,5.35-.27,1.66.49,3.29,2.19,4.71,4.13,3.44,12.37,4.29,18.36,1.89,3.14-1.26,5.14-3.21,5.47-5.35.27-1.66-.49-3.29-2.19-4.7C363.55,443.12,359.44,442,355.27,442Z",
    style: {
      fill: "#fff"
    }
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKb);
export default __webpack_public_path__ + "static/media/kb.e52ac94efcf332cd8ad102f81a7bd3bb.svg";
export { ForwardRef as ReactComponent };